import React, { useState, useEffect, useCallback, memo } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getToken } from "../../utils/auth";
import CONFIG from "../../config";
import { useNavigate } from "react-router-dom";
import BRANDING from "../../branding";

// const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';

// const SystemSettingsAdmin = memo(() => {
//     const { t } = useTranslation();
//     const navigate = useNavigate();

//     // Stats State
//     const [configStats, setConfigStats] = useState(null);
//     const [storageStats, setStorageStats] = useState(null);

//     // Profile State
//     const [profiles, setProfiles] = useState([]);
//     const [selectedProfileId, setSelectedProfileId] = useState(null);
//     const [showProfileModal, setShowProfileModal] = useState(false);
//     const [editingProfile, setEditingProfile] = useState(null);
//     const [profileForm, setProfileForm] = useState({ name: "", description: "", hostname: "" });

//     // Config State
//     const [configs, setConfigs] = useState([]);
//     const [loadingConfigs, setLoadingConfigs] = useState(false);
//     const [showConfigModal, setShowConfigModal] = useState(false);
//     const [editingConfig, setEditingConfig] = useState(null);
//     const [configForm, setConfigForm] = useState({ config_key: "", config_value: "", description: "", is_active: 1 });

//     const [message, setMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");

//     // --- Data Fetching ---

//     const fetchStats = useCallback(async () => {
//         try {
//             const token = getToken();
//             const configRes = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             const storageRes = await axios.get(`${CONFIG.API_URL}/api/storage/stats`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setConfigStats(configRes.data);
//             setStorageStats(storageRes.data);
//             if (configRes.data.activeProfile) {
//                 if (!selectedProfileId) setSelectedProfileId(configRes.data.activeProfile.id);
//             }
//         } catch (err) {
//             console.error("Failed to fetch stats", err);
//         }
//     }, [selectedProfileId]);

//     const fetchProfiles = useCallback(async () => {
//         try {
//             const token = getToken();
//             const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setProfiles(res.data || []);
//         } catch (err) {
//             console.error("Failed to fetch profiles", err);
//         }
//     }, []);

//     const fetchConfigs = useCallback(async (profileId) => {
//         if (!profileId) return;
//         setLoadingConfigs(true);
//         try {
//             const token = getToken();
//             const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs?profile_id=${profileId}`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setConfigs(res.data || []);
//         } catch (err) {
//             console.error("Failed to fetch configs", err);
//         } finally {
//             setLoadingConfigs(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchStats();
//         fetchProfiles();
//     }, [fetchStats, fetchProfiles]);

//     useEffect(() => {
//         if (selectedProfileId) {
//             fetchConfigs(selectedProfileId);
//         }
//     }, [selectedProfileId, fetchConfigs]);

//     // --- Profile Handlers ---

//     const handleActivateProfile = async (id) => {
//         try {
//             const token = getToken();
//             await axios.patch(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/activate`, {}, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setMessage(t("admin.settings.profile_activated", "Profile activated successfully"));
//             fetchStats();
//             fetchProfiles();
//             setTimeout(() => setMessage(""), 3000);
//         } catch (err) {
//             alert(t("admin.common.error", "Action failed"));
//         }
//     };

//     const handleDeleteProfile = async (id) => {
//         if (id === 1) return;
//         if (!window.confirm(t("admin.settings.delete_profile_confirm", "Delete this configuration set and all its variables?"))) return;
//         try {
//             const token = getToken();
//             await axios.delete(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             fetchProfiles();
//             if (selectedProfileId === id) setSelectedProfileId(1);
//         } catch (err) {
//             alert(err.response?.data?.message || t("admin.common.error", "Delete failed"));
//         }
//     };



// import React, { useState, useEffect, useCallback, memo } from "react";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { getToken } from "../../utils/auth";
// import CONFIG from "../../config";
// import { useNavigate } from "react-router-dom";
// import BRANDING from "../../branding";

const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';


// import React, { useState, useEffect, useCallback, memo } from "react";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { getToken } from "../../utils/auth";
// import CONFIG from "../../config";
// import { useNavigate } from "react-router-dom";

// const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';

// Deep merge utility function
const deepMerge = (target, source) => {
    if (!source) return target;
    const result = { ...target };
    Object.keys(source).forEach(key => {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            result[key] = deepMerge(result[key] || {}, source[key]);
        } else {
            result[key] = source[key];
        }
    });
    return result;
};

const SystemSettingsAdmin = memo(() => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const isArabic = i18n.language.startsWith('ar');

    // Stats State
    const [configStats, setConfigStats] = useState(null);
    const [storageStats, setStorageStats] = useState(null);

    // Profile State
    const [profiles, setProfiles] = useState([]);
    const [selectedProfileId, setSelectedProfileId] = useState(null);

    const [showProfileModal, setShowProfileModal] = useState(false);
    const [editingProfile, setEditingProfile] = useState(null);
    const [profileForm, setProfileForm] = useState({
        name: "",
        description: "",
        hostname: "",
        is_active: 0,
        branding: {
            appName: { en: '', ar: '' },
            contact: { phoneHeader: '', phoneFooter: '', email: '' },
            colors: {
                primary: '',
                primaryHover: '',
                secondary: '',
                accent: '',
                bgBody: '',
                bgHeader: '',
                textHeader: '',
                textMain: '',
                textMuted: '',
                border: '',
                glassBg: '',
                glassBorder: '',
                glassShadow: '',
                cardGlassBg: '',
                cardGlassBorder: ''
            },
            ui: {
                buttonRadius: '',
                cardRadius: '',
                inputRadius: '',
                cardShadow: '',
                cardPadding: '',
                navbarHeight: '',
                footerBg: '',
                footerText: '',
                transitionSpeed: ''
            },
            fonts: {
                bodyEn: '',
                bodyAr: '',
                headingEn: '',
                headingAr: ''
            },
            socialLinks: { facebook: '', instagram: '', whatsapp: '', tiktok: '' },
            logo: { path: '', alt: '', showText: false },
            favicon: { path: '' },
            appleTouchIcon: { path: '' },
            seo: {
                defaultTitle: { en: '', ar: '' },
                defaultDescription: { en: '', ar: '' },
                pages: {}
            },
            compliance: {
                enableGlobalConsentBanner: true,
                enableEgyptMarketingConsent: true,
                enableExplicitDataProcessing: true
            },
            homeContent: {
                exploreCollections: { en: '', ar: '' },
                shopByCategory: { en: '', ar: '' },
                eliteSelection: { en: '', ar: '' },
                topRatedProducts: { en: '', ar: '' },
                viewAllCollection: { en: '', ar: '' },
                testimonials: { en: '', ar: '' },
                customerReviews: { en: '', ar: '' },
                trustBannerTitle: { en: '', ar: '' },
                trustFeatures: {
                    verifiedReviews: { en: '', ar: '' },
                    qualityGuarantee: { en: '', ar: '' },
                    easyContact: { en: '', ar: '' }
                }
            }
        }
    });

    // Config State
    const [configs, setConfigs] = useState([]);
    const [loadingConfigs, setLoadingConfigs] = useState(false);
    const [showConfigModal, setShowConfigModal] = useState(false);
    const [editingConfig, setEditingConfig] = useState(null);
    const [configForm, setConfigForm] = useState({ config_key: "", config_value: "", description: "", is_active: 1 });

    // Owner Storage Server (per-hostname) — dedicated, labeled fields instead of free-form key input.
    const [ownerStorageForm, setOwnerStorageForm] = useState({
        STORAGE_PROVIDER: "local",
        LOCAL_STORAGE_UPLOAD_URL: "",
        LOCAL_STORAGE_PUBLIC_URL: "",
        LOCAL_STORAGE_API_KEY: "",
        LOCAL_OWNER_ID: ""
    });
    const [savingOwnerStorage, setSavingOwnerStorage] = useState(false);

    // Media Library (uploaded files tracked in the `media` table)
    const [mediaList, setMediaList] = useState([]);
    const [mediaLoading, setMediaLoading] = useState(false);
    const [mediaError, setMediaError] = useState("");

    const [message, setMessage] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [syncingProfileId, setSyncingProfileId] = useState(null);
    const [pullingProfileId, setPullingProfileId] = useState(null);
    const [syncingTunnelProfileId, setSyncingTunnelProfileId] = useState(null);
    const [syncingAllUnnamed, setSyncingAllUnnamed] = useState(false);
    const [syncingCountProfileId, setSyncingCountProfileId] = useState(null);
    const [syncingVarsProfileId, setSyncingVarsProfileId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [logoPreview, setLogoPreview] = useState('');

    // --- Extra Sets Modal State ---
    const [showExtraSetsModal, setShowExtraSetsModal] = useState(false);
    const [extraSetsTargetProfile, setExtraSetsTargetProfile] = useState(null);
    const [extraSetsVariables, setExtraSetsVariables] = useState([{ key: '', value: '', description: '' }]);
    const [extraSetName, setExtraSetName] = useState('');
    const [extraSetDescription, setExtraSetDescription] = useState('');
    const [extraSetDbUrl, setExtraSetDbUrl] = useState('');
    const [submittingExtraSets, setSubmittingExtraSets] = useState(false);



    // --- Data Fetching ---

    const fetchStats = useCallback(async () => {
        try {
            const token = getToken();
            const configRes = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats?profile_id=${selectedProfileId || ''}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // Determine the correct profile ID to fetch storage stats for.
            // If none is selected yet, use the active profile ID from the config response.
            let targetProfileId = selectedProfileId;
            if (!targetProfileId && configRes.data?.activeProfile) {
                targetProfileId = configRes.data.activeProfile.id;
                // Update state for subsequent renders
                setSelectedProfileId(targetProfileId);
            }

            const storageUrl = targetProfileId
                ? `${CONFIG.API_URL}/api/admin/storage/stats?profile_id=${targetProfileId}`
                : `${CONFIG.API_URL}/api/admin/storage/stats`;

            const storageRes = await axios.get(storageUrl, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setConfigStats(configRes.data);
            setStorageStats(storageRes.data);
            // expose master flag for UI conditional fields
            if (configRes.data && typeof configRes.data.isMaster !== 'undefined') {
                setIsMaster(!!configRes.data.isMaster);
            }
        } catch (err) {
            console.error("Failed to fetch stats", err);
        }
    }, [selectedProfileId]);

    // UI: whether the current admin is master (can edit hostnames/branding/db)
    const [isMaster, setIsMaster] = useState(false);

    const fetchProfiles = useCallback(async () => {
        try {
            const token = getToken();
            const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProfiles(res.data || []);
        } catch (err) {
            console.error("Failed to fetch profiles", err);
        }
    }, []);

    const fetchConfigs = useCallback(async (profileId) => {
        if (!profileId) return;
        setLoadingConfigs(true);
        try {
            const token = getToken();
            const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs?profile_id=${profileId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setConfigs(res.data || []);
        } catch (err) {
            console.error("Failed to fetch configs", err);
        } finally {
            setLoadingConfigs(false);
        }
    }, []);

    const handleRefreshProfileCount = async (id) => {
        try {
            setSyncingCountProfileId(id);
            const token = getToken();
            const res = await axios.post(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/refresh-count`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-profile-id': id
                }
            });

            // Update the count in the profiles list
            setProfiles(prev => prev.map(p =>
                p.id === id ? { ...p, product_counts: res.data.count } : p
            ));

            setMessage(t("admin.settings.count_refreshed", "Count refreshed!"));
            setTimeout(() => setMessage(""), 3000);
        } catch (err) {
            console.error("Failed to refresh count", err);
            alert(t("admin.common.failed", "Failed!"));
        } finally {
            setSyncingCountProfileId(null);
        }
    };

    useEffect(() => {
        fetchStats();
        fetchProfiles();
    }, [fetchStats, fetchProfiles]);

    useEffect(() => {
        if (selectedProfileId) {
            fetchConfigs(selectedProfileId);
        }
    }, [selectedProfileId, fetchConfigs]);

    // --- Profile Handlers ---

    const handleActivateProfile = async (id, currentActive) => {
        try {
            const token = getToken();
            const newActive = currentActive ? 0 : 1;
            await axios.patch(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/activate`, { active: newActive }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage(newActive ? t("admin.settings.profile_activated", "Profile activated successfully") : t("admin.settings.profile_deactivated", "Profile deactivated successfully"));
            fetchStats();
            fetchProfiles();
            setTimeout(() => setMessage(""), 3000);
        } catch (err) {
            alert(t("admin.common.error", "Action failed"));
        }
    };

    const handleDeleteProfile = async (id) => {
        if (id === MASTER_PROFILE_ID) return;
        if (!window.confirm(t("admin.settings.delete_profile_confirm", "Delete this configuration set and all its variables?"))) return;
        try {
            const token = getToken();
            await axios.delete(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchProfiles();
            if (selectedProfileId === id) setSelectedProfileId(MASTER_PROFILE_ID);
        } catch (err) {
            alert(err.response?.data?.message || t("admin.common.error", "Delete failed"));
        }
    };

    const handleActivateAllVars = async (id) => {
        try {
            setSyncingVarsProfileId(id);
            const token = getToken();
            await axios.put(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/activate-vars`, { active: 1 }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-profile-id': id
                }
            });
            fetchStats();
            fetchConfigs(id);
            fetchProfiles();
        } catch (err) {
            console.error("Failed to activate variables:", err);
        } finally {
            setSyncingVarsProfileId(null);
        }
    };

    const handleSyncProfile = async (id) => {
        if (syncingProfileId) return;
        if (!window.confirm(t("admin.settings.sync_profile_confirm", "Initialize and synchronize this domain's database? This will create missing tables and mirror your settings."))) return;

        try {
            setSyncingProfileId(id);
            const token = getToken();
            const res = await axios.post(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/sync`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-profile-id': id
                }
            });

            if (res.data.success) {
                setMessage(t("admin.settings.sync_success", "Domain synchronized successfully!"));
                setTimeout(() => setMessage(""), 5000);
            }
        } catch (err) {
            console.error("Sync error:", err.response?.data || err);
            alert(err.response?.data?.message || t("admin.settings.sync_failed", "Synchronization failed"));
        } finally {
            setSyncingProfileId(null);
        }
    };

    const handlePullSyncProfile = async (id) => {
        if (pullingProfileId) return;
        if (!window.confirm(t("admin.settings.pull_sync_confirm", "Securely save Remote data to Local? This will pull products and users from your live site into this local MariaDB mirror."))) return;

        try {
            setPullingProfileId(id);
            const token = getToken();
            const res = await axios.post(`${CONFIG.API_URL}/api/admin/profiles/${id}/pull-sync`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-profile-id': id
                }
            });

            if (res.data.success) {
                setMessage(t("admin.settings.pull_sync_success", "Data mirrored to local MariaDB successfully!"));
                fetchProfiles(); // Refresh to show new counts
                setTimeout(() => setMessage(""), 5000);
            }
        } catch (err) {
            console.error("Pull Sync error:", err.response?.data || err);
            alert(err.response?.data?.message || t("admin.settings.pull_sync_failed", "Data migration failed"));
        } finally {
            setPullingProfileId(null);
        }
    };

    const handleSyncTunnel = async (id) => {
        if (syncingTunnelProfileId) return;
        const tunnelUrl = window.prompt(t("admin.settings.enter_tunnel_url", "Enter your new Cloudflare Tunnel URL (e.g. https://example.trycloudflare.com):"));
        if (!tunnelUrl) return;

        try {
            setSyncingTunnelProfileId(id);
            const token = getToken();
            const res = await axios.post(`${CONFIG.API_URL}/api/admin/profiles/${id}/sync-tunnel`, { tunnelUrl }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-profile-id': id
                }
            });

            if (res.data.success) {
                // const profile = profiles.find(p => p.id === id);
                const message = `✅ Tunnel Updated!\n\n` +
                    `Hostname (UNCHANGED): ${res.data.results.hostname}\n` +
                    `Tunnel URL: ${res.data.results.tunnelUrl}\n` +
                    `Storage URL: ${res.data.results.publicUrl}\n\n` +
                    `✨ Your files will now be served via the tunnel!\n` +
                    `Hostname stayed the same for data integrity.`;

                setMessage(message);
                fetchProfiles();
                fetchConfigs(id);
                setTimeout(() => setMessage(""), 8000);
            }
        } catch (err) {
            console.error("Tunnel Sync error:", err.response?.data || err);
            alert(err.response?.data?.message || t("admin.settings.tunnel_sync_failed", "Tunnel sync failed"));
        } finally {
            setSyncingTunnelProfileId(null);
        }
    };



    const handleSyncAllUnnamed = async () => {
        if (syncingAllUnnamed) return;
        if (!window.confirm(t("admin.settings.sync_all_unnamed_confirm", "Sync all expansion (hostname-less) DBs? This will initialize and mirror each configured DB."))) return;
        try {
            setSyncingAllUnnamed(true);
            const token = getToken();
            const url = `${CONFIG.API_URL}/api/admin/profiles/sync-unnamed${selectedProfileId ? `?profile_id=${selectedProfileId}` : ''}`;
            const res = await axios.post(url, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data && res.data.ok) {
                setMessage(t("admin.settings.sync_all_unnamed_done", "Bulk sync complete — check results in console."));
                console.log('Bulk unnamed sync results:', res.data.results || res.data);
                setTimeout(() => setMessage(""), 5000);
            }
        } catch (err) {
            console.error('Bulk unnamed sync failed:', err.response?.data || err);
            alert(err.response?.data?.message || t("admin.settings.sync_failed", "Synchronization failed"));
        } finally {
            setSyncingAllUnnamed(false);
        }
    };

    // // Opens the Extra Sets modal for a specific profile card
    // const handleAddExtraSets = (profile) => {
    //     setExtraSetsTargetProfile(profile);
    //     setExtraSetsVariables([{ key: '', value: '', description: '' }]);
    //     setExtraSetName('');
    //     setExtraSetDescription('');
    //     setExtraSetDbUrl('');
    //     setShowExtraSetsModal(true);
    // };

    // // Add a blank variable row
    // const addExtraVarRow = () =>
    //     setExtraSetsVariables(prev => [...prev, { key: '', value: '', description: '' }]);

    // // Remove a variable row
    // const removeExtraVarRow = (idx) =>
    //     setExtraSetsVariables(prev => prev.filter((_, i) => i !== idx));

    // // Update a single field in a variable row
    // const updateExtraVarRow = (idx, field, val) =>
    //     setExtraSetsVariables(prev => prev.map((r, i) => i === idx ? { ...r, [field]: val } : r));

    // // Submits the modal form — targets the specific profile that was clicked
    // const handleSubmitExtraSets = async () => {
    //     if (!extraSetsTargetProfile) return;

    //     // Only send rows that have a non-empty key, and apply Set Name/Desc to the variable description
    //     const variables = extraSetsVariables.filter(v => v.key.trim()).map(v => {
    //         let finalDesc = v.description || '';
    //         if (extraSetName) {
    //             const prefix = `[${extraSetName}]${extraSetDescription ? ` - ${extraSetDescription}` : ''}`;
    //             finalDesc = finalDesc ? `${prefix}: ${finalDesc}` : prefix;
    //         }
    //         return {
    //             ...v,
    //             description: finalDesc
    //         };
    //     });

    //     try {
    //         setSubmittingExtraSets(true);
    //         const token = getToken();

    //         // 1. If a Database URL was provided, update the domain's profile first
    //         if (extraSetDbUrl && extraSetDbUrl.trim() !== '') {
    //             // PUT /api/admin/configs/profiles/:id updates the profile
    //             // We send a partial update. The backend should handle it.
    //             try {
    //                 await axios.put(`${CONFIG.API_URL}/api/admin/configs/profiles/${extraSetsTargetProfile.id}`,
    //                     { database_url: extraSetDbUrl.trim() },
    //                     { headers: { Authorization: `Bearer ${token}` } }
    //                 );
    //             } catch (dbErr) {
    //                 console.warn("Failed to update database URL before sync:", dbErr);
    //                 // Proceed anyway, the user might just be updating variables
    //             }
    //         }

    //         // 2. Add extra domain sets and sync
    //         const res = await axios.post(
    //             `${CONFIG.API_URL}/api/admin/extra-domain-sets`,
    //             { extraProfileIds: [extraSetsTargetProfile.id], variables },
    //             { headers: { Authorization: `Bearer ${token}` } }
    //         );

    //         if (res.data && res.data.ok) {
    //             const results = res.data.results || [];
    //             const successCount = results.filter(r => r.success).length;
    //             const failCount = results.filter(r => !r.success).length;
    //             setShowExtraSetsModal(false);
    //             setMessage(
    //                 t(
    //                     "admin.settings.add_extra_sets_success",
    //                     `Extra sets added to "${extraSetsTargetProfile.name}" — ${successCount > 0 ? 'Synced' : ''}${failCount > 0 ? `, ${failCount} failed` : ''}.`
    //                 )
    //             );
    //             if (failCount > 0) {
    //                 const summary = results
    //                     .map(r => `${r.name || r.id}: ${r.success ? '✅' : `❌ ${r.error || 'failed'}`}`)
    //                     .join('\n');
    //                 alert(`Sync completed with issues:\n\n${summary}`);
    //             }
    //             fetchProfiles();
    //             fetchStats();
    //             if (selectedProfileId === extraSetsTargetProfile.id) {
    //                 fetchConfigs(selectedProfileId);
    //             }
    //             setTimeout(() => setMessage(""), 6000);
    //         }
    //     } catch (err) {
    //         console.error("Add extra sets error:", err.response?.data || err);
    //         alert(err.response?.data?.message || t("admin.settings.add_extra_sets_failed", "Failed to add extra sets."));
    //     } finally {
    //         setSubmittingExtraSets(false);
    //     }
    // };

    // Opens the Extra Sets modal for a specific profile card
    const handleAddExtraSets = (profile) => {
        setExtraSetsTargetProfile(profile);
        setExtraSetsVariables([{ key: '', value: '', description: '' }]);
        setExtraSetName('');
        setExtraSetDescription('');
        setExtraSetDbUrl('');
        setShowExtraSetsModal(true);
    };

    // Add a blank variable row
    const addExtraVarRow = () =>
        setExtraSetsVariables(prev => [...prev, { key: '', value: '', description: '' }]);

    // Remove a variable row
    const removeExtraVarRow = (idx) =>
        setExtraSetsVariables(prev => prev.filter((_, i) => i !== idx));

    // Update a single field in a variable row
    const updateExtraVarRow = (idx, field, val) =>
        setExtraSetsVariables(prev => prev.map((r, i) => i === idx ? { ...r, [field]: val } : r));

    // Submits the modal form — targets the specific profile that was clicked
    const handleSubmitExtraSets = async () => {
        if (!extraSetsTargetProfile) return;

        // Only send rows that have a non-empty key, and apply Set Name/Desc to the variable description
        const variables = extraSetsVariables.filter(v => v.key.trim()).map(v => {
            let finalDesc = v.description || '';
            if (extraSetName) {
                const prefix = `[${extraSetName}]${extraSetDescription ? ` - ${extraSetDescription}` : ''}`;
                finalDesc = finalDesc ? `${prefix}: ${finalDesc}` : prefix;
            }
            return {
                ...v,
                description: finalDesc
            };
        });

        try {
            setSubmittingExtraSets(true);
            const token = getToken();

            // 1. Send to backend to create a completely new profile (Extra Set) that targets this domain
            const res = await axios.post(
                `${CONFIG.API_URL}/api/admin/extra-domain-sets`,
                {
                    targetProfileId: extraSetsTargetProfile.id,
                    variables,
                    setName: extraSetName.trim(),
                    setDescription: extraSetDescription.trim(),
                    databaseUrl: extraSetDbUrl.trim()
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data && res.data.ok) {
                const results = res.data.results || [];
                const successCount = results.filter(r => r.success).length;
                const failCount = results.filter(r => !r.success).length;
                setShowExtraSetsModal(false);
                setMessage(
                    t(
                        "admin.settings.add_extra_sets_success",
                        `Extra sets added to "${extraSetsTargetProfile.name}" — ${successCount > 0 ? 'Synced' : ''}${failCount > 0 ? `, ${failCount} failed` : ''}.`
                    )
                );
                if (failCount > 0) {
                    const summary = results
                        .map(r => `${r.name || r.id}: ${r.success ? '✅' : `❌ ${r.error || 'failed'}`}`)
                        .join('\n');
                    alert(`Sync completed with issues:\n\n${summary}`);
                }
                fetchProfiles();
                fetchStats();
                if (selectedProfileId === extraSetsTargetProfile.id) {
                    fetchConfigs(selectedProfileId);
                }
                setTimeout(() => setMessage(""), 6000);
            }
        } catch (err) {
            console.error("Add extra sets error:", err.response?.data || err);
            alert(err.response?.data?.message || t("admin.settings.add_extra_sets_failed", "Failed to add extra sets."));
        } finally {
            setSubmittingExtraSets(false);
        }
    };


    const handleSaveProfile = async (e) => {
        e.preventDefault();
        try {
            const token = getToken();
            const authHeaders = { Authorization: `Bearer ${token}` };
            // Send the profileForm as is, it now contains a structured branding object
            const payload = { ...profileForm };

            let savedProfileId;
            if (editingProfile) {
                await axios.put(`${CONFIG.API_URL}/api/admin/configs/profiles/${editingProfile.id}`, payload, {
                    headers: authHeaders
                });
                savedProfileId = editingProfile.id;
            } else {
                const res = await axios.post(`${CONFIG.API_URL}/api/admin/configs/profiles`, payload, {
                    headers: authHeaders
                });
                savedProfileId = res.data?.id;
            }

            // Safety-net: also save branding via the dedicated endpoint so that
            // hostname profile owners (who may not be the DB owner_id) always
            // persist their branding even if the embedded branding in the PUT
            // body was skipped by a server-side guard.
            if (savedProfileId && profileForm.branding) {
                try {
                    await axios.put(
                        `${CONFIG.API_URL}/api/admin/configs/profiles/${savedProfileId}/branding`,
                        profileForm.branding,
                        { headers: authHeaders }
                    );
                } catch (brandingErr) {
                    // Non-fatal: log but don't block the rest of the save flow
                    console.warn('[handleSaveProfile] Secondary branding save failed:', brandingErr?.response?.data?.message || brandingErr);
                }
            }

            setShowProfileModal(false);
            setEditingProfile(null);
            fetchProfiles();
            fetchStats();
            if (selectedProfileId) fetchConfigs(selectedProfileId);
        } catch (err) {
            alert(t("admin.common.error", "Save failed"));
        }
    };

    const testDatabaseConnection = async () => {
        if (!profileForm.database_url) return alert(t('admin.settings.enter_db_url', 'Enter a Database URL to test'));
        try {
            const token = getToken();
            const id = editingProfile?.id || 0; // 0 -> server will allow admin testing for new profiles
            const res = await axios.post(`${CONFIG.API_URL}/api/profiles/${id}/test-db`, { database_url: profileForm.database_url }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data && res.data.ok) alert(t('admin.settings.db_test_ok', 'Connection successful'));
            else alert(t('admin.settings.db_test_failed', 'Connection failed'));
        } catch (err) {
            alert(err.response?.data?.message || t('admin.settings.db_test_failed', 'Connection failed'));
        }
    };

    const uploadBrandingFile = async (file, field = 'logo') => {
        if (!file) return;
        try {
            const token = getToken();
            const fd = new FormData();
            fd.append('file', file);
            fd.append('folder', 'branding');
            const res = await axios.post(`${CONFIG.API_URL}/api/storage/upload`, fd, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
            });
            if (res.data && res.data.url) {
                const url = res.data.url;
                setProfileForm(prev => {
                    const updated = { ...prev.branding };
                    if (field === 'logo') {
                        updated.logo = { ...(updated.logo || {}), path: url };
                        updated.logo_url = url;
                        setLogoPreview(url);
                    } else if (field === 'favicon') {
                        updated.favicon = { path: url };
                    } else if (field === 'appleTouchIcon') {
                        updated.appleTouchIcon = { path: url };
                    }
                    return { ...prev, branding: updated };
                });
                setMessage(t('admin.settings.file_uploaded', 'File uploaded'));
                setTimeout(() => setMessage(''), 2500);
            }
        } catch (err) {
            alert(err.response?.data?.message || t('admin.settings.upload_failed', 'Upload failed'));
        }
    };

    const openProfileModal = async (profile) => {
        setIsEditing(!!profile);
        if (!profile) {
            setEditingProfile(null);
            setProfileForm({
                name: "",
                description: "",
                hostname: "",
                is_active: 1,
                branding: {
                    appName: { en: '', ar: '' },
                    seo: {
                        defaultTitle: { en: '', ar: '' },
                        defaultDescription: { en: '', ar: '' },
                        sellingPoints: { en: [], ar: [] },
                        pages: {},
                        customHeadTags: ''
                    },
                    colors: {
                        primary: '#0ea5a4',
                        bgBody: '#FAFAFA',
                        secondary: '',
                        accent: '',
                        textMain: '',
                        textMuted: '',
                        bgHeader: '',
                        textHeader: '',
                        border: '',
                        glassBg: 'rgba(255, 255, 255, 0.03)',
                        glassBorder: 'rgba(255, 255, 255, 0.05)',
                        glassShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
                        cardGlassBg: 'rgba(255, 255, 255, 0.05)',
                        cardGlassBorder: 'rgba(255, 255, 255, 0.1)'
                    },
                    ui: {
                        buttonRadius: '',
                        cardRadius: '',
                        inputRadius: '',
                        cardShadow: '',
                        cardPadding: '',
                        navbarHeight: '',
                        footerBg: '',
                        footerText: '',
                        transitionSpeed: ''
                    },
                    fonts: {
                        bodyEn: '',
                        bodyAr: '',
                        headingEn: '',
                        headingAr: ''
                    },
                    logo: { path: '', alt: '' },
                    favicon: { path: '' },
                    appleTouchIcon: { path: '' },
                    footerDescription: { en: '', ar: '' },
                    defaultLanguage: 'en',
                    features: {
                        cart: true,
                        wishlist: true,
                        comparison: true,
                        userPortal: true,
                        payments: true,
                        aiStories: true
                    },
                    compliance: {
                        enableGlobalConsentBanner: true,
                        enableEgyptMarketingConsent: true,
                        enableExplicitDataProcessing: true
                    },
                    contact: { phoneHeader: '', phoneFooter: '', email: '' },
                    socialLinks: { facebook: '', instagram: '', whatsapp: '', tiktok: '' },
                    homeContent: {
                        exploreCollections: { en: '', ar: '' },
                        shopByCategory: { en: '', ar: '' },
                        eliteSelection: { en: '', ar: '' },
                        topRatedProducts: { en: '', ar: '' },
                        viewAllCollection: { en: '', ar: '' },
                        testimonials: { en: '', ar: '' },
                        customerReviews: { en: '', ar: '' },
                        trustBannerTitle: { en: '', ar: '' },
                        trustFeatures: {
                            verifiedReviews: { en: '', ar: '' },
                            qualityGuarantee: { en: '', ar: '' },
                            easyContact: { en: '', ar: '' }
                        }
                    },
                    checkout: {
                        gatewayKeys: { stripe_publishable_key: '', stripe_secret_key: '', paypal_client_id: '', paypal_client_secret: '' },
                        receiptWhatsApp: '',
                        paymentMethods: {
                            cash_on_delivery: { enabled: true, instructions: 'Pay when your order arrives at your door.' },
                            bank_transfer: { enabled: true, accountNumber: '', bankName: '', instructions: 'Transfer the total to our bank account and send the receipt to our WhatsApp.' },
                            vodafone_cash: { enabled: false, accountNumber: '', instructions: 'Send the amount to our Vodafone Cash number and send the receipt.' },
                            instapay: { enabled: false, accountNumber: '', instructions: 'Transfer via InstaPay to our registered account.' },
                            fawry: { enabled: false, accountNumber: '', instructions: 'Pay at any Fawry outlet using our reference number.' },
                            paypal: { enabled: false, instructions: 'You will be redirected to PayPal to complete payment.' },
                            stripe_card: { enabled: false, instructions: 'Secure card payment via Stripe.' }
                        }
                    },
                    filterPlaceholders: {
                        category: {
                            label: { en: 'Category', ar: 'الفئة' },
                            icon: 'category-icon',
                            SelectTypeAndOption: { en: 'All Categories', ar: 'جميع الفئات' }
                        },
                        material: {
                            label: { en: 'Material', ar: 'المواد' },
                            icon: 'material-icon',
                            selectTypeAndOption: { en: 'All Materials', ar: 'جميع المواد' }
                        },
                        dimensions: {
                            label: { en: 'Dimensions', ar: 'المقاسات' },
                            icon: 'dimensions-icon',
                            SelectTypeAndOption: { en: 'All Dimensions', ar: 'جميع المقاسات' }
                        }
                    }
                }
            });
            setLogoPreview('');
            setShowProfileModal(true);
            return;
        }

        // -----------------------------------------------------------------------
        // Fetch the profile's core data AND branding independently so that a
        // 403 on the core-profile endpoint (e.g. when owner_id lookup hasn't
        // propagated yet) does NOT wipe out the branding form fields.
        // Both requests run in parallel; failures fall back gracefully.
        // -----------------------------------------------------------------------
        const token = getToken();
        const authHeaders = { Authorization: `Bearer ${token}` };

        // Empty branding skeleton – used as the merge base
        const emptyBranding = {
            appName: { en: '', ar: '' },
            seo: {
                defaultTitle: { en: '', ar: '' },
                defaultDescription: { en: '', ar: '' },
                sellingPoints: { en: [], ar: [] },
                pages: {},
                customHeadTags: ''
            },
            colors: {
                primary: '#0ea5a4', primaryHover: '', secondary: '', accent: '',
                bgBody: '', bgHeader: '', textMain: '', textMuted: '', textHeader: '', border: '',
                glassBg: 'rgba(255,255,255,0.03)', glassBorder: 'rgba(255,255,255,0.05)',
                glassShadow: '0 8px 32px 0 rgba(0,0,0,0.37)',
                cardGlassBg: 'rgba(255,255,255,0.05)', cardGlassBorder: 'rgba(255,255,255,0.1)'
            },
            ui: {
                buttonRadius: '', cardRadius: '', inputRadius: '', cardShadow: '',
                cardPadding: '', navbarHeight: '', footerBg: '', footerText: '', transitionSpeed: ''
            },
            fonts: { bodyEn: '', bodyAr: '', headingEn: '', headingAr: '' },
            logo: { path: '' },
            favicon: { path: '' },
            appleTouchIcon: { path: '' },
            footerDescription: { en: '', ar: '' },
            defaultLanguage: 'en',
            features: { cart: true, wishlist: true, comparison: true, userPortal: true, payments: true, aiStories: true },
            compliance: {
                enableGlobalConsentBanner: true,
                enableEgyptMarketingConsent: true,
                enableExplicitDataProcessing: true
            },
            contact: { phoneHeader: '', phoneFooter: '', email: '' },
            socialLinks: { facebook: '', instagram: '', whatsapp: '', tiktok: '' },
            homeContent: {
                exploreCollections: { en: '', ar: '' },
                shopByCategory: { en: '', ar: '' },
                eliteSelection: { en: '', ar: '' },
                topRatedProducts: { en: '', ar: '' },
                viewAllCollection: { en: '', ar: '' },
                testimonials: { en: '', ar: '' },
                customerReviews: { en: '', ar: '' },
                trustBannerTitle: { en: '', ar: '' },
                trustFeatures: {
                    verifiedReviews: { en: '', ar: '' },
                    qualityGuarantee: { en: '', ar: '' },
                    easyContact: { en: '', ar: '' }
                }
            },
            checkout: {
                gatewayKeys: { stripe_publishable_key: '', stripe_secret_key: '', paypal_client_id: '', paypal_client_secret: '' },
                receiptWhatsApp: '',
                paymentMethods: {
                    cash_on_delivery: { enabled: true, instructions: 'Pay when your order arrives at your door.' },
                    bank_transfer: { enabled: true, accountNumber: '', bankName: '', instructions: 'Transfer the total to our bank account and send the receipt to our WhatsApp.' },
                    vodafone_cash: { enabled: false, accountNumber: '', instructions: 'Send the amount to our Vodafone Cash number and send the receipt.' },
                    instapay: { enabled: false, accountNumber: '', instructions: 'Transfer via InstaPay to our registered account.' },
                    fawry: { enabled: false, accountNumber: '', instructions: 'Pay at any Fawry outlet using our reference number.' },
                    paypal: { enabled: false, instructions: 'You will be redirected to PayPal to complete payment.' },
                    stripe_card: { enabled: false, instructions: 'Secure card payment via Stripe.' }
                }
            },
            filterPlaceholders: {
                category: {
                    label: { en: 'Category', ar: 'الفئة' },
                    icon: 'category-icon',
                    selectTypeAndOption: { en: 'All Categories', ar: 'جميع الفئات' }
                },
                material: {
                    label: { en: 'Material', ar: 'المواد' },
                    icon: 'material-icon',
                    selectTypeAndOption: { en: 'All Materials', ar: 'جميع المواد' }
                },
                dimensions: {
                    label: { en: 'Dimensions', ar: 'المقاسات' },
                    icon: 'dimensions-icon',
                    selectTypeAndOption: { en: 'All Dimensions', ar: 'جميع المقاسات' }
                }
            }
        };

        // Run both fetches in parallel; capture individual results/errors
        const [coreResult, brandingResult] = await Promise.allSettled([
            axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles/${profile.id}`, { headers: authHeaders }),
            axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles/${profile.id}/branding`, { headers: authHeaders })
        ]);

        // --- Core profile data ---
        // Falls back to the profile object from the list (already has name/hostname/etc.)
        const core = coreResult.status === 'fulfilled'
            ? (coreResult.value?.data || {})
            : {};

        if (coreResult.status === 'rejected') {
            console.warn('[openProfileModal] Core profile fetch failed, using list data as fallback:', coreResult.reason?.response?.data?.message || coreResult.reason);
        }

        const base = {
            name: core.name ?? profile.name ?? '',
            description: core.description ?? profile.description ?? '',
            hostname: core.hostname ?? profile.hostname ?? '',
            is_active: core.is_active ?? profile.is_active ?? 0,
            database_url: core.database_url ?? '',
            branding: { ...emptyBranding }
        };

        // --- Branding data ---
        if (brandingResult.status === 'fulfilled') {
            const bData = brandingResult.value?.data;
            if (bData && Object.keys(bData).length > 0) {
                base.branding = deepMerge(emptyBranding, bData);
                const logoPath = bData.logo?.path || bData.logo_url || '';
                if (logoPath) setLogoPreview(logoPath);
            }
        } else {
            console.warn('[openProfileModal] Branding fetch failed:', brandingResult.reason?.response?.data?.message || brandingResult.reason);
        }

        setEditingProfile(profile);
        setProfileForm(base);
        setShowProfileModal(true);
    };

    // --- Config Handlers ---

    const handleSaveConfig = async (e) => {
        e.preventDefault();
        try {
            const token = getToken();
            const payload = { ...configForm, profile_id: selectedProfileId };
            if (editingConfig) {
                await axios.put(`${CONFIG.API_URL}/api/admin/configs/${editingConfig.id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            } else {
                await axios.post(`${CONFIG.API_URL}/api/admin/configs`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }
            setShowConfigModal(false);
            setEditingConfig(null);
            fetchConfigs(selectedProfileId);
            fetchStats();
        } catch (err) {
            alert(t("admin.common.error", "Save failed"));
        }
    };

    const handleToggleAllVariables = async (active) => {
        if (!selectedProfileId) return;
        const actionStr = active ? t("admin.settings.enable", "enable") : t("admin.settings.disable", "disable");
        if (!window.confirm(t("admin.settings.bulk_toggle_confirm", "Are you sure you want to {{action}} all variables for this set?", { action: actionStr }))) return;

        try {
            setSyncingVarsProfileId(selectedProfileId);
            const token = getToken();
            await axios.patch(`${CONFIG.API_URL}/api/admin/configs/profiles/${selectedProfileId}/variables/toggle-all`, { active: active ? 1 : 0 }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-profile-id': selectedProfileId
                }
            });
            setMessage(t("admin.settings.bulk_toggle_success", `All variables ${active ? 'enabled' : 'disabled'} successfully`));
            fetchConfigs(selectedProfileId);
            fetchStats();
            setTimeout(() => setMessage(""), 3000);
        } catch (err) {
            alert(err.response?.data?.message || t("admin.common.error", "Action failed"));
        } finally {
            setSyncingVarsProfileId(null);
        }
    };

    const handleDeleteConfig = async (id) => {
        if (!window.confirm(t("admin.settings.delete_config_confirm", "Delete this variable?"))) return;
        try {
            const token = getToken();
            await axios.delete(`${CONFIG.API_URL}/api/admin/configs/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchConfigs(selectedProfileId);
            fetchStats();
        } catch (err) {
            alert(t("admin.common.error", "Delete failed"));
        }
    };

    const filteredConfigs = configs.filter(c =>
        c.config_key.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (c.description && c.description.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    // Read an existing config value for the selected profile (used to prefill the Owner Storage form).
    const getCfg = (key) => {
        const found = configs.find(c => c.config_key === key);
        return found ? found.config_value : "";
    };

    // Prefill the Owner Storage form whenever the selected profile's configs load.
    useEffect(() => {
        if (!selectedProfileId) return;
        setOwnerStorageForm({
            STORAGE_PROVIDER: getCfg("STORAGE_PROVIDER") || "local",
            LOCAL_STORAGE_UPLOAD_URL: getCfg("LOCAL_STORAGE_UPLOAD_URL") || "",
            LOCAL_STORAGE_PUBLIC_URL: getCfg("LOCAL_STORAGE_PUBLIC_URL") || "",
            LOCAL_STORAGE_API_KEY: getCfg("LOCAL_STORAGE_API_KEY") || "",
            LOCAL_OWNER_ID: getCfg("LOCAL_OWNER_ID") || ""
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configs, selectedProfileId]);

    // Save each Owner Storage field as its own app_configs row for the selected profile.
    const handleSaveOwnerStorage = async (e) => {
        e.preventDefault();
        if (!selectedProfileId) {
            alert(t("admin.settings.select_set_first", "Please select a Configuration Set first"));
            return;
        }
        try {
            setSavingOwnerStorage(true);
            const token = getToken();
            const fields = [
                { key: "STORAGE_PROVIDER", value: ownerStorageForm.STORAGE_PROVIDER || "local", desc: "Storage provider (local = owner storage server)" },
                { key: "LOCAL_STORAGE_UPLOAD_URL", value: ownerStorageForm.LOCAL_STORAGE_UPLOAD_URL.trim(), desc: "Owner storage server upload endpoint" },
                { key: "LOCAL_STORAGE_PUBLIC_URL", value: ownerStorageForm.LOCAL_STORAGE_PUBLIC_URL.trim(), desc: "Owner storage server public base URL" },
                { key: "LOCAL_STORAGE_API_KEY", value: ownerStorageForm.LOCAL_STORAGE_API_KEY.trim(), desc: "Owner storage server API key (x-api-key)" },
                { key: "LOCAL_OWNER_ID", value: (ownerStorageForm.LOCAL_OWNER_ID || "").trim(), desc: "Optional owner ID override (defaults to hostname)" }
            ];
            for (const f of fields) {
                // Skip empty optional fields (except provider which always has a value).
                if (!f.value && f.key !== "STORAGE_PROVIDER") continue;
                const existing = configs.find(c => c.config_key === f.key);
                const payload = { config_key: f.key, config_value: f.value, description: f.desc, is_active: 1, profile_id: selectedProfileId };
                if (existing) {
                    await axios.put(`${CONFIG.API_URL}/api/admin/configs/${existing.id}`, payload, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                } else {
                    await axios.post(`${CONFIG.API_URL}/api/admin/configs`, payload, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                }
            }
            setMessage(t("admin.settings.owner_storage_saved", "Owner Storage Server settings saved"));
            fetchConfigs(selectedProfileId);
            fetchStats();
            setTimeout(() => setMessage(""), 3000);
        } catch (err) {
            alert(err.response?.data?.message || t("admin.common.error", "Save failed"));
        } finally {
            setSavingOwnerStorage(false);
        }
    };

    // Fetch the uploaded media records for the selected configuration set.
    const fetchMedia = async () => {
        if (!selectedProfileId) return;
        try {
            setMediaLoading(true);
            setMediaError("");
            const token = getToken();
            const res = await axios.get(
                `${CONFIG.API_URL}/api/admin/media?profile_id=${encodeURIComponent(selectedProfileId)}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setMediaList(Array.isArray(res.data) ? res.data : (res.data?.media || []));
        } catch (err) {
            setMediaError(err.response?.data?.message || t("admin.settings.media_load_error", "Could not load media list"));
        } finally {
            setMediaLoading(false);
        }
    };

    const getProgressColor = (percent) => {
        if (percent >= 90) return 'bg-red-500';
        if (percent >= 75) return 'bg-amber-500';
        return 'bg-green-500';
    };

    return (
        <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
            {/* Header */}
            <div className="flex flex-wrap justify-center md:justify-between items-start gap-4 md:gap-0 mb-12">
                <div>
                    <h2 className="text-4xl font-black text-gray-900 tracking-tight">{t("admin.settings.title", "System Settings")}</h2>
                    <p className="text-gray-500 font-medium mt-2">{t("admin.settings.subtitle", "Unified dashboard for profiles, configurations, and system health.")}</p>
                </div>
                <button onClick={() => navigate("/admin")} className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all">
                    <span className={`inline-block transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
                    {t('admin.common.back', 'Back')}
                </button>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                {/* Active Profile Status */}
                <div
                    style={{
                        background: isMaster ? BRANDING.colors.glassBg : 'rgba(var(--brand-primary-rgb), 0.05)',
                        backdropFilter: isMaster ? 'blur(10px)' : 'none',
                        borderColor: isMaster ? BRANDING.colors.glassBorder : 'rgba(var(--brand-primary-rgb), 0.1)',
                        boxShadow: isMaster ? BRANDING.colors.glassShadow : 'none'
                    }}
                    className="p-6 rounded-[30px] border relative overflow-hidden group transition-all"
                >
                    <div className="relative z-10">
                        <div className="flex justify-between items-start">
                            <span className="text-[10px] font-black uppercase tracking-widest text-brand-primary/60">{t("admin.settings.active_profile", "Active profile")}</span>
                            <span className="text-[10px] font-black text-brand-primary bg-white/80 backdrop-blur-md px-2 py-0.5 rounded-full shadow-sm border border-brand-primary/10 font-mono">
                                <i className="fas fa-globe mr-1"></i> {configStats?.hostname || window.location.hostname}
                            </span>
                        </div>
                        <div className="text-2xl font-black text-gray-900 mt-1">{configStats?.activeProfile?.name || "None"}</div>
                        <div className="flex items-center gap-2 mt-2">
                            <span className={`w-2 h-2 rounded-full ${configStats?.activeConfigs > 0 ? 'bg-green-500 animate-pulse' : 'bg-amber-500'}`}></span>
                            <span className={`text-xs font-bold uppercase tracking-tighter ${configStats?.activeConfigs > 0 ? 'text-green-600' : 'text-amber-600'}`}>
                                {configStats?.activeConfigs || 0} / {configStats?.activeProfileTotalConfigs || 0} {t("admin.settings.variables", "Variables Live")}
                            </span>
                        </div>
                    </div>
                    <i className="fas fa-layer-group absolute bottom-[-10px] right-[-10px] text-5xl text-brand-primary/5 group-hover:scale-110 transition-transform"></i>
                </div>

                {/* Storage Health */}
                <div className="bg-gray-50 p-6 rounded-[30px] border border-gray-100 relative overflow-hidden group">
                    <div className="relative z-10">
                        <div className="flex justify-between items-start">
                            <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
                                {t("admin.settings.storage_usage", "Storage Usage")}
                                {selectedProfileId && typeof profiles !== 'undefined' ? ` - ${profiles.find(p => p.id === selectedProfileId)?.name || ''}` : ''}
                            </span>
                            <span className="text-[10px] font-black text-gray-900 bg-white px-2 py-0.5 rounded-full shadow-sm">{storageStats?.provider?.toUpperCase()}</span>
                        </div>
                        <div className="flex items-end gap-2 mt-1">
                            <div className="text-2xl font-black text-gray-900">{storageStats?.usagePercent}%</div>
                            <div className="text-[10px] font-bold text-gray-400 mb-1">{storageStats?.providers?.[storageStats?.provider]?.sizeMB || 0} MB / {storageStats?.limit} MB</div>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2 overflow-hidden">
                            <div className={`h-full ${getProgressColor(storageStats?.usagePercent)} transition-all duration-1000`} style={{ width: `${storageStats?.usagePercent}%` }}></div>
                        </div>

                        {/* Breakdown per account (if multiple) */}
                        <div className="mt-4 space-y-2">
                            {Object.entries(storageStats?.providers || {}).map(([p, data]) => {
                                if (data.accounts && Object.keys(data.accounts).length > 1) {
                                    return (
                                        <div key={p} className="text-[9px] font-black uppercase text-gray-400 pt-2 border-t border-gray-100 flex items-center justify-between">
                                            <span>{p} Accounts</span>
                                            <span>{data.sizeMB} MB Total</span>
                                        </div>
                                    );
                                }
                                return null;
                            })}
                        </div>

                        <div className="mt-4 pt-4 border-t border-gray-100/50">
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-[9px] font-black uppercase tracking-tight text-gray-400">{t("admin.settings.db_size", "Database Size")}</span>
                                <span className="text-[10px] font-black text-gray-900">{storageStats?.databaseSizeMB || 0} MB</span>
                            </div>
                        </div>

                        <div className="mt-2 flex flex-col gap-1.5 overflow-y-auto max-h-[120px] pr-2 custom-scrollbar">
                            {Object.entries(storageStats?.providers || {}).map(([p, data]) => {
                                if (data.sizeMB <= 0) return null;

                                // Show separate accounts/buckets if they exist
                                if (data.accounts && Object.keys(data.accounts).length > 0) {
                                    return Object.entries(data.accounts).map(([accName, accData]) => {
                                        const isMainActive = (p === storageStats?.provider && accName === storageStats?.activeAccount);
                                        const isOtherActive = (accName === storageStats?.activeAccount); // For other providers

                                        return (
                                            <div key={accName} className={`flex items-center justify-between p-2 rounded-xl border transition-all ${isMainActive || (p !== 'cloudinary' && isOtherActive) ? 'bg-brand-primary/10 text-brand-primary border-brand-primary/20' : 'bg-white text-gray-400 border-gray-100'}`} title={`${accData.sizeMB} MB on ${accName}`}>
                                                <div className="flex items-center gap-2">
                                                    <i className={`fas ${p === 'cloudinary' ? 'fa-cloud' : p === 'r2' ? 'fa-archive' : 'fa-database'} text-[10px]`}></i>
                                                    <span className="text-[10px] font-black uppercase tracking-tight truncate max-w-[100px]">{accName}</span>
                                                    {isMainActive && <span className="bg-brand-primary text-white text-[8px] px-1.5 py-0.5 rounded-full uppercase ml-1">Live</span>}
                                                </div>
                                                <span className="text-[10px] font-black">{accData.sizeMB} MB</span>
                                            </div>
                                        );
                                    });
                                }

                                return (
                                    <div key={p} className={`flex items-center justify-between p-2 rounded-xl border transition-all ${p === storageStats?.provider ? 'bg-brand-primary/10 text-brand-primary border-brand-primary/20' : 'bg-white text-gray-400 border-gray-100'}`} title={`${data.sizeMB} MB on ${p}`}>
                                        <div className="flex items-center gap-2">
                                            <i className="fas fa-hdd text-[10px]"></i>
                                            <span className="text-[10px] font-black uppercase tracking-tight">{p}</span>
                                        </div>
                                        <span className="text-[10px] font-black">{data.sizeMB} MB</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <i className="fas fa-database absolute bottom-[-10px] right-[-10px] text-5xl text-gray-100 group-hover:scale-110 transition-transform"></i>
                </div>

                {/* Owner Storage Server (per-hostname) */}
                <div className="mb-12">
                    <div className="flex justify-between items-center mb-6">
                        <h3 className="text-xs font-black uppercase tracking-[3px] text-gray-400">{t("admin.settings.owner_storage", "Owner Storage Server")}</h3>
                        <span className="text-[9px] font-bold text-gray-400 bg-gray-100 px-2 py-1 rounded-full">{t("admin.settings.per_hostname", "Per Configuration Set")}</span>
                    </div>
                    <form onSubmit={handleSaveOwnerStorage} className="bg-white rounded-[30px] border border-gray-100 p-6 space-y-5">
                        <p className="text-[11px] text-gray-500 leading-relaxed">
                            {t("admin.settings.owner_storage_help", "Uploads are sent to YOUR OWN storage server (owner-storage-server) instead of the app disk. Each Configuration Set can use a different server. Set this once per set; images then appear on both localhost and the live site.")}
                        </p>

                        <div>
                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.storage_provider", "Storage Mode")}</label>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                {/* Option 1: hostname-owner-local */}
                                <button
                                    type="button"
                                    onClick={() => setOwnerStorageForm({ ...ownerStorageForm, STORAGE_PROVIDER: "hostname-owner-local" })}
                                    className={`text-left p-4 rounded-2xl border-2 transition-all ${ownerStorageForm.STORAGE_PROVIDER === "hostname-owner-local" ? "border-brand-primary bg-brand-primary/5" : "border-gray-100 bg-gray-50 hover:border-gray-200"}`}
                                >
                                    <div className="flex items-center justify-between">
                                        <span className="font-black text-gray-900 text-[12px]">hostname-owner-local</span>
                                        {ownerStorageForm.STORAGE_PROVIDER === "hostname-owner-local" && <i className="fas fa-check-circle text-brand-primary"></i>}
                                    </div>
                                    <p className="text-[10px] text-gray-500 mt-1 leading-snug">{t("admin.settings.mode_hostname_desc", "Owner ID is taken automatically from this set's profile. Best when each hostname has its own owner-storage-server.")}</p>
                                </button>
                                {/* Option 2: local */}
                                <button
                                    type="button"
                                    onClick={() => setOwnerStorageForm({ ...ownerStorageForm, STORAGE_PROVIDER: "local" })}
                                    className={`text-left p-4 rounded-2xl border-2 transition-all ${ownerStorageForm.STORAGE_PROVIDER === "local" ? "border-brand-primary bg-brand-primary/5" : "border-gray-100 bg-gray-50 hover:border-gray-200"}`}
                                >
                                    <div className="flex items-center justify-between">
                                        <span className="font-black text-gray-900 text-[12px]">local</span>
                                        {ownerStorageForm.STORAGE_PROVIDER === "local" && <i className="fas fa-check-circle text-brand-primary"></i>}
                                    </div>
                                    <p className="text-[10px] text-gray-500 mt-1 leading-snug">{t("admin.settings.mode_local_desc", "You set the Owner ID manually below. Best when you share one storage server across several sets.")}</p>
                                </button>
                            </div>
                            <div className="ml-4 mt-2 space-y-2">
                                {/* Informational notice (per selected option) */}
                                <div className="p-3 rounded-xl bg-amber-50 border border-amber-100">
                                    <p className="text-[10px] text-amber-700 leading-relaxed">
                                        <i className="fas fa-info-circle mr-1"></i>
                                        {ownerStorageForm.STORAGE_PROVIDER === "hostname-owner-local"
                                            ? t("admin.settings.notice_hostname", "Option 1 — hostname-owner-local: uploads go to YOUR owner-storage-server. The Owner ID is resolved automatically from this set's profile, so you don't need to fill Owner ID. Images appear on both localhost and the live site.")
                                            : t("admin.settings.notice_local", "Option 2 — local: uploads go to YOUR owner-storage-server. You control the Owner ID manually (leave it empty to use the hostname). Images appear on both localhost and the live site.")}
                                    </p>
                                </div>
                                {/* Honest warning — applies to BOTH options (both use the owner-storage-server) */}
                                <div className="p-3 rounded-xl bg-red-50 border border-red-200">
                                    <p className="text-[10px] text-red-700 font-black uppercase tracking-wider mb-1">
                                        <i className="fas fa-exclamation-triangle mr-1"></i>
                                        {t("admin.settings.storage_warning_title", "Important — read before using")}
                                    </p>
                                    <ul className="text-[10px] text-red-700 leading-relaxed list-disc list-inside space-y-1">
                                        <li>{t("admin.settings.warn_spof", "Your owner-storage-server is the ONLY copy. If it is offline, the tunnel is down, or the machine is turned off, uploads will FAIL and existing images will NOT load (404). The app keeps no backup.")}</li>
                                        <li>{t("admin.settings.warn_public_url", "The server's PUBLIC_URL must be your tunnel or public IP (e.g. http://41.41.52.214/<id>), NOT https://your-app.vercel.app:5050 — Vercel does not expose port 5050, so a wrong value means images never appear.")}</li>
                                        <li>{t("admin.settings.warn_key", "If REQUIRE_AUTH=true on the server, the API Key below MUST match its STORAGE_API_KEY exactly, or every upload is rejected (401).")}</li>
                                        <li>{ownerStorageForm.STORAGE_PROVIDER === "hostname-owner-local"
                                            ? t("admin.settings.warn_hostname", "Owner ID comes from this set's profile. If owner_id is missing or wrong, files land under the wrong/'default' folder and may be mixed with other sets.")
                                            : t("admin.settings.warn_local", "Owner ID is manual. Leave it empty and it falls back to the raw hostname; if two sets share a hostname they will collide. Use a unique Owner ID per owner.")}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.upload_url", "Upload URL")}</label>
                            <input
                                value={ownerStorageForm.LOCAL_STORAGE_UPLOAD_URL}
                                onChange={e => setOwnerStorageForm({ ...ownerStorageForm, LOCAL_STORAGE_UPLOAD_URL: e.target.value })}
                                className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-mono font-bold text-[11px]"
                                placeholder="http://41.41.52.214/<tunnel-id>/api/storage/upload"
                            />
                            <p className="text-[9px] text-gray-400 ml-4 mt-1 italic">{t("admin.settings.upload_url_hint", "The owner server's /api/storage/upload endpoint (your tunnel or public IP).")}</p>
                        </div>

                        <div>
                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.public_url", "Public URL")}</label>
                            <input
                                value={ownerStorageForm.LOCAL_STORAGE_PUBLIC_URL}
                                onChange={e => setOwnerStorageForm({ ...ownerStorageForm, LOCAL_STORAGE_PUBLIC_URL: e.target.value })}
                                className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-mono font-bold text-[11px]"
                                placeholder="http://41.41.52.214/<tunnel-id>/storage"
                            />
                            <p className="text-[9px] text-gray-400 ml-4 mt-1 italic">{t("admin.settings.public_url_hint", "Same host as Upload URL, but ending in /storage. Used to build image links.")}</p>
                        </div>

                        <div>
                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.api_key", "API Key (x-api-key)")}</label>
                            <input
                                type="password"
                                value={ownerStorageForm.LOCAL_STORAGE_API_KEY}
                                onChange={e => setOwnerStorageForm({ ...ownerStorageForm, LOCAL_STORAGE_API_KEY: e.target.value })}
                                className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-mono font-bold text-[11px]"
                                placeholder="Matches your owner-storage-server STORAGE_API_KEY"
                            />
                            <p className="text-[9px] text-gray-400 ml-4 mt-1 italic">{t("admin.settings.api_key_hint", "Must match STORAGE_API_KEY on your owner-storage-server (required when REQUIRE_AUTH=true).")}</p>
                        </div>

                        <div>
                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.owner_id", "Owner ID (optional)")}</label>
                            <input
                                value={ownerStorageForm.LOCAL_OWNER_ID}
                                onChange={e => setOwnerStorageForm({ ...ownerStorageForm, LOCAL_OWNER_ID: e.target.value })}
                                className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-mono font-bold text-[11px]"
                                placeholder="Leave empty to use the hostname"
                            />
                        </div>

                        <div className="flex gap-4 pt-2">
                            <button
                                type="submit"
                                disabled={savingOwnerStorage || !selectedProfileId}
                                className="flex-1 bg-brand-primary text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-lg shadow-brand-primary/20 hover:scale-[1.02] transition-all disabled:opacity-60"
                            >
                                {savingOwnerStorage ? <i className="fas fa-spinner fa-spin mr-1"></i> : <i className="fas fa-save mr-1"></i>}
                                {t("admin.settings.save_owner_storage", "Save Owner Storage")}
                            </button>
                        </div>
                    </form>
                </div>

                {/* Media Library — lists every file uploaded to the owner storage server (media table) */}
                <div className="bg-white p-6 rounded-[30px] border border-gray-100 relative overflow-hidden">
                    <div className="flex justify-between items-center mb-4">
                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
                            {t("admin.settings.media_library", "Media Library")}
                            {selectedProfileId ? (
                                <span className="text-brand-primary ml-1">
                                    (Set: {profiles?.find(p => p.id === selectedProfileId)?.name || ''})
                                </span>
                            ) : ''}
                        </span>
                        <button
                            onClick={fetchMedia}
                            className="text-gray-400 hover:text-brand-primary transition-colors"
                            title={t("admin.settings.refresh_media", "Refresh")}
                        >
                            <i className="fas fa-sync-alt text-[10px]"></i>
                        </button>
                    </div>

                    {!selectedProfileId ? (
                        <p className="text-[11px] text-gray-400 italic">{t("admin.settings.select_set_first", "Select a Configuration Set to view its uploaded media.")}</p>
                    ) : mediaLoading ? (
                        <p className="text-[11px] text-gray-400"><i className="fas fa-spinner fa-spin mr-1"></i>{t("admin.settings.loading", "Loading…")}</p>
                    ) : mediaError ? (
                        <p className="text-[11px] text-red-500">{mediaError}</p>
                    ) : mediaList.length === 0 ? (
                        <p className="text-[11px] text-gray-400 italic">{t("admin.settings.no_media", "No media uploaded yet for this set.")}</p>
                    ) : (
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 max-h-80 overflow-y-auto pr-1">
                            {mediaList.map((m) => (
                                <a
                                    key={m.id}
                                    href={m.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="group block rounded-2xl border border-gray-100 overflow-hidden hover:border-brand-primary/40 transition-all"
                                >
                                    <div className="aspect-square bg-gray-50 flex items-center justify-center overflow-hidden">
                                        {m.mimetype?.startsWith('image/') ? (
                                            <img src={m.url} alt={m.filename || 'media'} className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" />
                                        ) : (
                                            <i className="fas fa-file-video text-3xl text-gray-300"></i>
                                        )}
                                    </div>
                                    <div className="p-2">
                                        <p className="text-[9px] font-bold text-gray-700 truncate">{m.filename || m.url?.split('/').pop()}</p>
                                        <p className="text-[8px] text-gray-400 truncate">{m.folder} · {m.provider}</p>
                                    </div>
                                </a>
                            ))}
                        </div>
                    )}
                    <p className="text-[9px] text-gray-400 mt-3 italic">
                        {t("admin.settings.media_note", "Every upload through this set is recorded in the database (media table), so you can audit and find files even if the storage server is offline.")}
                    </p>
                </div>

                {/* System Stats (Now Profile Stats) */}
                <div className="bg-gray-50 p-6 rounded-[30px] border border-gray-100 relative overflow-hidden group">
                    <div className="relative z-10">
                        <div className="flex justify-between items-start">
                            <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
                                {t("admin.settings.quick_stats", "Quick Stats")}
                                {selectedProfileId && typeof profiles !== 'undefined' ? (
                                    <span className="text-brand-primary ml-1">
                                        (Set: {profiles.find(p => p.id === selectedProfileId)?.name || ''})
                                    </span>
                                ) : ''}
                            </span>
                            <button onClick={() => { fetchStats(); fetchProfiles(); }} className="text-gray-400 hover:text-brand-primary transition-colors">
                                <i className="fas fa-sync-alt text-[10px]"></i>
                            </button>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mt-2">
                            <div>
                                <div className="text-xl font-black text-gray-900">{storageStats?.active?.totalFiles || 0}</div>
                                <div className="text-[9px] font-bold text-gray-400 uppercase tracking-tighter">{t("admin.settings.total_media", "Media Files")}</div>
                            </div>
                            <div>
                                <div className="flex items-center gap-2">
                                    <div className="text-xl font-black text-gray-900">
                                        {configStats?.activeConfigs || 0}
                                        <span className="text-xs text-gray-400 ml-1">/ {configStats?.activeProfileTotalConfigs || 0}</span>
                                    </div>
                                    {(configStats?.activeConfigs < configStats?.activeProfileTotalConfigs) && (
                                        <button
                                            onClick={() => handleActivateAllVars(selectedProfileId)}
                                            className={`text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full border transition-all ${syncingProfileId === selectedProfileId ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed' : 'bg-brand-primary/10 text-brand-primary border-brand-primary/20 hover:bg-brand-primary hover:text-white'}`}
                                            disabled={syncingProfileId === selectedProfileId}
                                        >
                                            {syncingProfileId === selectedProfileId ? <i className="fas fa-spinner fa-spin mr-1"></i> : <i className="fas fa-bolt mr-1"></i>}
                                            {t("admin.settings.activate_all", "Activate")}
                                        </button>
                                    )}
                                </div>
                                <div className="text-[9px] font-bold text-gray-400 uppercase tracking-tighter">{t("admin.settings.active_set_vars", "Set Variables")}</div>
                            </div>
                        </div>
                    </div>
                    <i className="fas fa-bolt absolute bottom-[-10px] right-[-10px] text-5xl text-gray-100 group-hover:scale-110 transition-transform"></i>
                </div>
            </div>

            {/* Profile Selection */}
            <div className="mb-12">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-xs font-black uppercase tracking-[3px] text-gray-400">{t("admin.settings.configuration_sets", "Configuration Sets")}</h3>
                    <div className="flex gap-2">
                        <button
                            onClick={() => { openProfileModal(null); }}
                            className="bg-gray-900 text-white px-4 py-2 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-black transition-all"
                        >
                            <i className="fas fa-plus mr-1"></i> {t("admin.settings.new_set", "Add New Set")}
                        </button>
                        <button
                            onClick={() => handleSyncAllUnnamed()}
                            className={`bg-white text-gray-600 border px-4 py-2 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-50 transition-all flex items-center gap-2 ${syncingAllUnnamed ? 'opacity-70 cursor-wait' : ''}`}
                            disabled={syncingAllUnnamed}
                            title={t("admin.settings.sync_all_unnamed", "Sync All Unnamed DBs")}
                        >
                            {syncingAllUnnamed ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-cloud-upload-alt"></i>}
                            <span className="text-[11px]">{t("admin.settings.sync_all_unnamed_btn", "Sync Unnamed")}</span>
                        </button>
                    </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {profiles.map(p => (
                        <div
                            key={p.id}
                            onClick={() => setSelectedProfileId(p.id)}
                            style={{
                                background: selectedProfileId === p.id && isMaster ? BRANDING.colors.cardGlassBg : p.id === selectedProfileId ? 'rgba(var(--brand-primary-rgb), 0.05)' : 'white',
                                borderColor: selectedProfileId === p.id && isMaster ? BRANDING.colors.cardGlassBorder : selectedProfileId === p.id ? 'var(--brand-primary)' : '#f3f4f6',
                                backdropFilter: isMaster ? 'blur(8px)' : 'none',
                                boxShadow: selectedProfileId === p.id && isMaster ? BRANDING.colors.glassShadow : 'none'
                            }}
                            className={`p-5 rounded-[25px] border cursor-pointer transition-all ${selectedProfileId === p.id ? 'ring-4 ring-brand-primary/5' : 'hover:border-gray-200'}`}
                        >
                            <div className="flex flex-wrap gap-2 items-start mb-2">
                                <h4 className="font-black text-gray-900 truncate pr-2 flex-1">{p.name}</h4>
                                <div className="flex flex-col gap-1 items-end">
                                    {p.is_active === 1 && (
                                        <div className="flex flex-col items-end gap-1">
                                            <span className="bg-green-100 text-green-600 text-[8px] font-black uppercase px-2 py-0.5 rounded-full border border-green-200 shadow-sm whitespace-nowrap">
                                                <i className="fas fa-star mr-1"></i> {t("admin.settings.global_default", "Default")}
                                            </span>
                                            <button
                                                onClick={(e) => { e.stopPropagation(); handleActivateProfile(p.id, 1); }}
                                                className="text-[8px] font-black uppercase tracking-tighter text-red-400 hover:text-red-600 transition-colors"
                                            >
                                                {t("admin.common.deactivate", "Deactivate")}
                                            </button>
                                        </div>
                                    )}
                                    {p.hostname && (
                                        <span className="bg-blue-100 text-blue-600 text-[8px] font-black uppercase px-2 py-0.5 rounded-full border border-blue-200 shadow-sm whitespace-nowrap">
                                            <i className="fas fa-check mr-1"></i> {t("admin.settings.hostname_active", "Active")}
                                        </span>
                                    )}
                                    {p.is_active === 0 && (
                                        <button
                                            onClick={(e) => { e.stopPropagation(); handleActivateProfile(p.id, 0); }}
                                            className="text-[9px] font-black uppercase tracking-tighter text-brand-primary hover:underline"
                                        >
                                            <i className="fas fa-plus-circle mr-1"></i>
                                            {t("admin.settings.make_default", "Make Default")}
                                        </button>
                                    )}
                                    <div className="flex items-center text-[10px] text-gray-500 font-bold bg-white/50 px-3 py-1.5 rounded-xl border border-gray-50">
                                        <div className="flex items-center gap-1.5">
                                            <i className="fas fa-cube text-brand-primary/60"></i>
                                            <span>{p.product_counts || 0} {t("admin.settings.products", "Products")}</span>
                                        </div>
                                        <button
                                            onClick={(e) => { e.stopPropagation(); handleRefreshProfileCount(p.id); }}
                                            className="ml-2 text-gray-400 hover:text-brand-primary transition-colors p-1"
                                            title="Refresh product count"
                                            disabled={syncingCountProfileId === p.id}
                                        >
                                            <i className={`fas fa-sync-alt text-[8px] ${syncingCountProfileId === p.id ? 'fa-spin' : ''}`}></i>
                                        </button>
                                        {p.DATABASE_URL && (
                                            <i className="fas fa-external-link-alt text-[7px] text-blue-400 ml-1" title="Expansion Database"></i>
                                        )}
                                    </div>
                                    <div className="flex items-center text-[10px] text-gray-500 font-bold bg-white/50 px-3 py-1.5 rounded-xl border border-gray-50">
                                        <i className="fas fa-list mr-2 text-brand-primary/60"></i>
                                        {p.variable_counts} {t("admin.settings.vars", "Vars")}
                                    </div>
                                </div>
                            </div>
                            <p className="text-[10px] text-gray-500 font-medium line-clamp-2 h-8 leading-relaxed mb-1">{p.description || "No description provided."}</p>
                            {p.hostname && (
                                <div className="text-[9px] font-black text-brand-primary bg-brand-primary/5 px-2 py-0.5 rounded-full inline-block mb-3 border border-brand-primary/10">
                                    <i className="fas fa-globe mr-1"></i> {p.hostname}
                                </div>
                            )}
                            <div className="flex justify-end gap-2 border-t border-gray-50 pt-3">
                                <button
                                    title={p.hostname ? t("admin.settings.sync_profile", "Sync Domain Database") : t("admin.settings.sync_expansion", "Sync Expansion Database")}
                                    onClick={(e) => { e.stopPropagation(); handleSyncProfile(p.id); }}
                                    className={`transition-all ${syncingProfileId === p.id ? 'text-brand-primary' : 'text-gray-400 hover:text-brand-primary'}`}
                                    disabled={syncingProfileId === p.id}
                                >
                                    <i className={`fas ${syncingProfileId === p.id ? 'fa-spinner fa-spin' : 'fa-sync-alt'} text-[10px]`}></i>
                                </button>
                                {/* {isMaster && */}
                                {/* (<> */}
                                <button
                                    title={t("admin.settings.pull_sync", "Pull Data from Remote to Local (Secure Save)")}
                                    onClick={(e) => { e.stopPropagation(); handlePullSyncProfile(p.id); }}
                                    className={`transition-all ${pullingProfileId === p.id ? 'text-green-500' : 'text-gray-400 hover:text-green-500'}`}
                                    disabled={pullingProfileId === p.id}
                                >
                                    <i className={`fas ${pullingProfileId === p.id ? 'fa-spinner fa-spin' : 'fa-download'} text-[10px]`}></i>
                                </button>
                                <button
                                    title={t("admin.settings.sync_tunnel", "Update Cloudflare Tunnel URL")}
                                    onClick={(e) => { e.stopPropagation(); handleSyncTunnel(p.id); }}
                                    className={`transition-all ${syncingTunnelProfileId === p.id ? 'text-blue-500' : 'text-gray-400 hover:text-blue-500'}`}
                                    disabled={syncingTunnelProfileId === p.id}
                                >
                                    <i className={`fas ${syncingTunnelProfileId === p.id ? 'fa-spinner fa-spin' : 'fa-broadcast-tower'} text-[10px]`}></i>
                                </button>
                                {/* </>)} */}
                                {/* Add Extra Sets — per-domain button */}
                                <button
                                    title={t("admin.settings.add_extra_sets", "Add Extra Config Sets to this domain")}
                                    onClick={(e) => { e.stopPropagation(); handleAddExtraSets(p); }}
                                    className="text-gray-400 hover:text-blue-500 transition-colors"
                                >
                                    <i className="fas fa-layer-group text-[10px]"></i>
                                </button>
                                {/* {p.id !== p.hostname && !MASTER_PROFILE_ID && ( */}
                                <button title={t("admin.settings.edit_profile", "Edit Profile")} onClick={(e) => { e.stopPropagation(); openProfileModal(p); }} className="text-gray-400 hover:text-blue-500 transition-colors"><i className="fas fa-edit text-[10px]"></i></button>
                                {/* )} */}
                                {p.id !== MASTER_PROFILE_ID && !p.hostname && (
                                    <button title={t("admin.settings.delete_profile", "Delete Profile")} onClick={(e) => { e.stopPropagation(); handleDeleteProfile(p.id); }} className="text-gray-400 hover:text-red-500 transition-colors"><i className="fas fa-trash text-[10px]"></i></button>
                                )}
                                {p.hostname && (
                                    <span title={t("admin.settings.domain_profile_protected", "Domain profiles cannot be deleted — remove the hostname first")} className="text-gray-300 cursor-not-allowed"><i className="fas fa-lock text-[10px]"></i></span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Variable Table */}
            <div className={`transition-all ${!selectedProfileId ? 'opacity-50 pointer-events-none' : ''}`}>
                <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                    <h3 className="text-xs font-black uppercase tracking-[3px] text-gray-400">{profiles.find(p => p.id === selectedProfileId)?.name} {t("admin.settings.variables", "Variables")}</h3>
                    <div className="flex gap-4 w-full md:w-auto">
                        <div className="relative flex-1 md:w-64">
                            <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
                            <input
                                value={searchQuery}
                                onChange={e => setSearchQuery(e.target.value)}
                                placeholder={t("admin.common.search", "Search...")}
                                className="pl-10 pr-4 py-2 bg-gray-50 rounded-xl border-none w-full text-xs font-bold focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all"
                            />
                        </div>
                        <div className="flex gap-2">
                            <button
                                onClick={() => handleToggleAllVariables(true)}
                                disabled={syncingVarsProfileId === selectedProfileId}
                                className="bg-green-50 text-green-600 hover:bg-green-600 hover:text-white px-3 py-2 rounded-xl font-black text-[9px] uppercase tracking-widest transition-all whitespace-nowrap"
                                title={t("admin.settings.activate_all", "Activate All")}
                            >
                                <i className={`fas ${syncingVarsProfileId === selectedProfileId ? 'fa-spinner fa-spin' : 'fa-check-double'}`}></i>
                            </button>
                            <button
                                onClick={() => handleToggleAllVariables(false)}
                                disabled={syncingVarsProfileId === selectedProfileId}
                                className="bg-amber-50 text-amber-600 hover:bg-amber-600 hover:text-white px-3 py-2 rounded-xl font-black text-[9px] uppercase tracking-widest transition-all whitespace-nowrap"
                                title={t("admin.settings.deactivate_all", "Deactivate All")}
                            >
                                <i className="fas fa-ban"></i>
                            </button>
                        </div>
                        <button
                            onClick={() => { setEditingConfig(null); setConfigForm({ config_key: "", config_value: "", description: "", is_active: 1 }); setShowConfigModal(true); }}
                            className="bg-brand-primary text-white px-6 py-2 rounded-xl font-black text-[10px] uppercase tracking-widest hover:scale-105 transition-all shadow-lg shadow-brand-primary/10 whitespace-nowrap"
                        >
                            <i className="fas fa-plus mr-1"></i> {t("admin.settings.add_key", "Add Variable")}
                        </button>
                    </div>
                </div>

                <div className="bg-white rounded-[30px] border border-gray-100 overflow-x-auto shadow-sm">
                    <table className={`w-full ${isArabic ? 'text-right' : 'text-left'}`}>
                        <thead className="bg-gray-50 text-[10px] font-black uppercase tracking-widest text-gray-400 border-b border-gray-100">
                            <tr>
                                <th className="p-5">{t("admin.settings.key", "Key")}</th>
                                <th className="p-5">{t("admin.settings.value", "Value")}</th>
                                <th className="p-5">{t("admin.settings.status", "Status")}</th>
                                <th className="p-5 text-right">{t("admin.common.actions", "Actions")}</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {loadingConfigs ? (
                                <tr><td colSpan="4" className="p-20 text-center"><i className="fas fa-spinner fa-spin text-brand-primary text-xl"></i></td></tr>
                            ) : filteredConfigs.length === 0 ? (
                                <tr><td colSpan="4" className="p-20 text-center text-gray-400 font-bold italic">{t("admin.settings.no_configs", "No configurations for this set.")}</td></tr>
                            ) : filteredConfigs.map(c => (
                                <tr key={c.id} className="hover:bg-gray-50/50 group transition-colors">
                                    <td className="p-5">
                                        <div className="font-mono text-xs font-black text-gray-900 bg-gray-100 px-3 py-1 rounded inline-block">{c.config_key}</div>
                                    </td>
                                    <td className="p-5">
                                        <div className="text-xs font-medium text-gray-600 max-w-xs truncate" title={c.config_value}>{c.config_value}</div>
                                        {c.description && <div className="text-[9px] text-gray-400 mt-1">{c.description}</div>}
                                    </td>
                                    <td className="p-5">
                                        <div className="flex flex-col gap-1">
                                            <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-tighter ${c.is_active ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'}`}>
                                                {c.is_active ? t("admin.settings.active", "Enabled") : t("admin.settings.inactive", "Disabled")}
                                            </div>
                                            {!c.is_active && profiles.find(p => p.id !== selectedProfileId && p.is_active === 1) && (
                                                <div className="text-[8px] font-black uppercase text-amber-500 italic flex items-center gap-1">
                                                    <i className="fas fa-reply fa-rotate-180"></i>
                                                    {t("admin.settings.fallback_active", "Fallback active")}
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td className="p-5 text-right">
                                        <div className="flex justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                            <button onClick={() => { setEditingConfig(c); setConfigForm({ ...c }); setShowConfigModal(true); }} className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-600 hover:text-white transition-all"><i className="fas fa-edit text-xs"></i></button>
                                            {!isMaster && (
                                                <button onClick={() => handleDeleteConfig(c.id)} className="w-8 h-8 rounded-lg bg-red-50 text-red-600 hover:bg-red-600 hover:text-white transition-all"><i className="fas fa-trash text-xs"></i></button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modals ... */}
            {showProfileModal && (
                <div className="fixed inset-0 z-[110] overflow-y-auto bg-gray-900/60 backdrop-blur-sm">
                    <div className="flex min-h-full items-start justify-center p-4">
                        <div className="bg-white rounded-[40px] w-full max-w-2xl p-10 animate-scale-in my-8">
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-2xl font-black text-gray-900">{isEditing ? t("admin.settings.edit_set", "Edit Set") : t("admin.settings.new_set", "New Configuration Set")}</h3>
                                <button onClick={() => setShowProfileModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors"><i className="fas fa-times text-xl"></i></button>
                            </div>

                            <form onSubmit={handleSaveProfile} className="space-y-8">
                                {/* Base Information */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gray-50 rounded-[30px] border border-gray-100">
                                    <div className="md:col-span-2">
                                        <h4 className="text-xs font-black uppercase tracking-widest text-brand-primary mb-4 flex items-center gap-2">
                                            <i className="fas fa-info-circle"></i> {t("admin.settings.basic_info", "Basic Information")}
                                        </h4>
                                    </div>
                                    <div>
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.set_name", "Set Name")}</label>
                                        <input value={profileForm.name} onChange={e => setProfileForm({ ...profileForm, name: e.target.value })} className="bg-white border border-gray-100 p-4 w-full rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold" required placeholder="e.g. Luxury Branch" />
                                    </div>
                                    {/* {isMaster && ( */}
                                    <div>
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.hostname", "Hostname (Domain)")}</label>
                                        <input value={profileForm.hostname} onChange={e => setProfileForm({ ...profileForm, hostname: e.target.value })} className="bg-white border border-gray-100 p-4 w-full rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold" placeholder="e.g. branch.com" />
                                        <p className="text-[9px] text-gray-400 ml-4 mt-1 italic">Required for full branding & isolation.</p>
                                    </div>
                                    {/* )} */}
                                    <div className="md:col-span-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.description", "Description")}</label>
                                        <textarea value={profileForm.description} onChange={e => setProfileForm({ ...profileForm, description: e.target.value })} className="bg-white border border-gray-100 p-4 w-full rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold h-20" placeholder="Briefly describe this profile..." />
                                    </div>

                                    <div className="md:col-span-2 flex items-center gap-3 p-4 bg-white rounded-2xl border border-gray-100">
                                        <div
                                            onClick={() => setProfileForm(prev => ({ ...prev, is_active: prev.is_active ? 0 : 1 }))}
                                            className={`w-12 h-6 rounded-full relative transition-all cursor-pointer ${profileForm.is_active ? 'bg-green-500' : 'bg-gray-200'}`}
                                        >
                                            <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${profileForm.is_active ? 'right-1' : 'left-1'}`}></div>
                                        </div>
                                        <div className="flex-1">
                                            <span className="text-[10px] font-black uppercase tracking-widest text-gray-900 block">{t("admin.settings.make_default", "Primary Default Store")}</span>
                                            <p className="text-[9px] text-gray-400 font-bold italic">When no hostname matches, this set will be used.</p>
                                        </div>
                                        {profileForm.is_active ? <i className="fas fa-check-circle text-green-500"></i> : null}
                                    </div>
                                </div>

                                {/* Branding Section (Master Only) */}
                                <div className={`space-y-6 p-6 bg-white rounded-[30px] border-2 border-brand-primary/10 relative transition-all duration-500 ${(!profileForm.hostname && editingProfile?.id !== 1) ? 'opacity-40 grayscale-[0.5]' : ''}`}>
                                    {/* Lock Overlay */}
                                    {(!profileForm.hostname && !isMaster && editingProfile?.id !== 1) && (
                                        <div className="absolute inset-0 z-50 flex items-center justify-center p-8 text-center bg-white/20 backdrop-blur-[1px] rounded-[30px] pointer-events-none">
                                            <div className="bg-white/95 shadow-2xl shadow-brand-primary/10 border border-brand-primary/10 p-8 rounded-[30px] max-w-[300px] transform -translate-y-4 animate-bounce-subtle pointer-events-auto">
                                                <div className="w-14 h-14 bg-brand-primary/10 text-brand-primary rounded-full flex items-center justify-center mx-auto mb-4">
                                                    <i className="fas fa-lock text-xl"></i>
                                                </div>
                                                <h5 className="text-[11px] font-black uppercase tracking-widest text-gray-900 mb-2">{t("admin.settings.branding_restricted", "Branding Restricted")}</h5>
                                                <p className="text-[10px] text-gray-500 font-bold leading-relaxed">
                                                    {t("admin.settings.branding_restricted_desc", "To prevent branding conflicts, please enter a hostname in the Basic Information section above first.")}
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    <div className="space-y-4 pt-4 border-t border-gray-100">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                            <i className="fas fa-shield-alt"></i> {t("admin.settings.compliance_settings", "Compliance Settings")}
                                        </span>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-[9px] font-black uppercase tracking-widest text-gray-400 mb-1">
                                                    {t("admin.settings.enable_global_consent_banner", "Enable Global Consent Banner")}
                                                </label>
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        id="enableGlobalConsent"
                                                        checked={profileForm.branding?.compliance?.enableGlobalConsentBanner ?? true}
                                                        onChange={e =>
                                                            setProfileForm({
                                                                ...profileForm,
                                                                branding: {
                                                                    ...profileForm.branding,
                                                                    compliance: {
                                                                        ...(profileForm.branding?.compliance || {}),
                                                                        enableGlobalConsentBanner: e.target.checked
                                                                    }
                                                                }
                                                            })}
                                                        className="mt-1 w-4 h-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer"
                                                    />
                                                    <label htmlFor="enableGlobalConsent" className="text-xs text-gray-500 leading-tight cursor-pointer">
                                                        {t("admin.settings.enable_global_consent_desc", "Show the EU/UK/EG global consent banner for all users")}
                                                    </label>
                                                </div>
                                            </div>

                                            <div>
                                                <label className="block text-[9px] font-black uppercase tracking-widest text-gray-400 mb-1">
                                                    {t("admin.settings.enable_egypt_marketing_consent", "Enable Egypt Marketing Consent")}
                                                </label>
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        id="enableEgyptMarketing"
                                                        checked={profileForm.branding?.compliance?.enableEgyptMarketingConsent ?? true}
                                                        onChange={e =>
                                                            setProfileForm({
                                                                ...profileForm,
                                                                branding: {
                                                                    ...profileForm.branding,
                                                                    compliance: {
                                                                        ...(profileForm.branding?.compliance || {}),
                                                                        enableEgyptMarketingConsent: e.target.checked
                                                                    }
                                                                }
                                                            })}
                                                        className="mt-1 w-4 h-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer"
                                                    />
                                                    <label htmlFor="enableEgyptMarketing" className="text-xs text-gray-500 leading-tight cursor-pointer">
                                                        {t("admin.settings.enable_egypt_marketing_desc", "Require explicit marketing opt‑in for Egyptian users")}
                                                    </label>
                                                </div>
                                            </div>

                                            <div>
                                                <label className="block text-[9px] font-black uppercase tracking-widest text-gray-400 mb-1">
                                                    {t("admin.settings.enable_explicit_data_processing", "Enable Explicit Data Processing Consent")}
                                                </label>
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        id="enableExplicitProcessing"
                                                        checked={profileForm.branding?.compliance?.enableExplicitDataProcessing ?? true}
                                                        onChange={e =>
                                                            setProfileForm({
                                                                ...profileForm,
                                                                branding: {
                                                                    ...profileForm.branding,
                                                                    compliance: {
                                                                        ...(profileForm.branding?.compliance || {}),
                                                                        enableExplicitDataProcessing: e.target.checked
                                                                    }
                                                                }
                                                            })}
                                                        className="mt-1 w-4 h-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer"
                                                    />
                                                    <label htmlFor="enableExplicitProcessing" className="text-xs text-gray-500 leading-tight cursor-pointer">
                                                        {t("admin.settings.enable_explicit_processing_desc", "Require explicit data processing consent for all users")}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`flex justify-between items-center ${!profileForm.hostname ? 'pointer-events-none select-none' : ''}`}>
                                        <h4 className="text-xs font-black uppercase tracking-widest text-brand-primary flex items-center gap-2">
                                            <i className="fas fa-palette"></i> {t("admin.settings.branding_isolation", "App Branding & Identity")}
                                        </h4>
                                    </div>

                                    {/* App Names */}
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t('admin.settings.app_name_en_t')}{t('admin.settings.app_name_en_td')}</label>
                                            <input value={profileForm.branding?.appName?.en || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, appName: { ...(profileForm.branding?.appName || {}), en: e.target.value } } })} className="bg-gray-50 border-none p-4 w-full rounded-2xl font-bold" placeholder="Furniture Shop" />
                                        </div>
                                        <div>
                                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.app_name_ar_t")}{t('admin.settings.app_name_ar_td')}</label>
                                            <input value={profileForm.branding?.appName?.ar || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, appName: { ...(profileForm.branding?.appName || {}), ar: e.target.value } } })} className="bg-gray-50 border-none p-4 w-full rounded-2xl font-bold text-right" dir="rtl" placeholder="فيرنتشر شوب" />
                                        </div>
                                    </div>

                                    {/* SEO Fields */}
                                    <div className="space-y-4 pt-2 border-t border-gray-50">
                                        <div className="flex justify-between items-center">
                                            <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">{t("admin.settings.seo_settings")}</span>
                                        </div>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.default_title_en_t")}{t('admin.settings.default_title_en_td')}</label>
                                                <input value={profileForm.branding?.seo?.defaultTitle?.en || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultTitle: { ...(profileForm.branding?.seo?.defaultTitle || {}), en: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder={isArabic ? t('admin.settings.default_title') : undefined} />
                                            </div>
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.default_title_ar_t")}{t('admin.settings.default_title_ar_td')}</label>
                                                <input value={profileForm.branding?.seo?.defaultTitle?.ar || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultTitle: { ...(profileForm.branding?.seo?.defaultTitle || {}), ar: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold text-right" placeholder={isArabic ? t('admin.settings.default_title') : undefined} dir="rtl" />
                                            </div>
                                            <div className="col-span-2">
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.default_desc_en_t")}{t('admin.settings.default_desc_en_td')}</label>
                                                <textarea value={profileForm.branding?.seo?.defaultDescription?.en || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultDescription: { ...(profileForm.branding?.seo?.defaultDescription || {}), en: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold h-16" placeholder={isArabic ? t('admin.settings.default_desc') : undefined} />
                                            </div>
                                            <div className="col-span-2 text-right" dir="rtl">
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 mr-4 mb-2 block">{t("admin.settings.default_desc_ar_t")}{t("admin.settings.default_desc_ar_td")}</label>
                                                <textarea value={profileForm.branding?.seo?.defaultDescription?.ar || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultDescription: { ...(profileForm.branding?.seo?.defaultDescription || {}), ar: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold h-16" placeholder={isArabic ? t('admin.settings.default_desc') : undefined} />
                                            </div>

                                            {/* Custom Head Meta Tags */}
                                            <div className="col-span-2 mt-4 space-y-2">
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">Custom Head Meta Tags</label>
                                                <textarea
                                                    value={profileForm.branding?.seo?.customHeadTags || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), customHeadTags: e.target.value } } })}
                                                    className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold h-24"
                                                    placeholder="One full <meta .../> tag per line. These will be injected into the <head> of your store."
                                                />
                                                <p className="text-[9px] text-gray-400 italic ml-4">Example: <meta name="google-site-verification" content="abc123xyz" /></p>
                                            </div>

                                            {/* Selling Points Editor */}
                                            <div className="col-span-2 mt-4 space-y-4">
                                                <span className="text-[10px] font-black uppercase tracking-widest text-brand-primary flex items-center gap-2">
                                                    <i className="fas fa-bullhorn rotate-[-12deg]"></i> {t("admin.settings.selling_points", "SEO Selling Points & Trust Badges")}
                                                </span>
                                                <div className="grid grid-cols-2 gap-6">
                                                    {/* English Selling Points */}
                                                    <div className="space-y-3">
                                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2 block">English Points</label>
                                                        <div className="flex flex-wrap gap-2 p-3 bg-gray-50 rounded-2xl border border-gray-100 min-h-[60px]">
                                                            {(profileForm.branding?.seo?.sellingPoints?.en || []).map((point, idx) => (
                                                                <span key={idx} className="bg-white px-3 py-1.5 rounded-xl text-[10px] font-bold text-gray-700 shadow-sm border border-gray-100 flex items-center gap-2 group/point">
                                                                    {point}
                                                                    <button type="button" onClick={() => {
                                                                        const updated = (profileForm.branding.seo.sellingPoints.en || []).filter((_, i) => i !== idx);
                                                                        setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...profileForm.branding.seo.sellingPoints, en: updated } } } });
                                                                    }} className="text-gray-300 hover:text-red-500 transition-colors">
                                                                        <i className="fas fa-times text-[8px]"></i>
                                                                    </button>
                                                                </span>
                                                            ))}
                                                            <input
                                                                className="bg-transparent border-none p-0 text-[10px] font-bold outline-none flex-1 min-w-[80px]"
                                                                placeholder="+ Add Point..."
                                                                onKeyDown={e => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        const val = e.target.value.trim();
                                                                        if (val) {
                                                                            const updated = [...(profileForm.branding?.seo?.sellingPoints?.en || []), val];
                                                                            setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...(profileForm.branding.seo.sellingPoints || {}), en: updated } } } });
                                                                            e.target.value = '';
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Arabic Selling Points */}
                                                    <div className="space-y-3" dir="rtl">
                                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 mr-2 block">النقاط البيعية (عربي)</label>
                                                        <div className="flex flex-wrap gap-2 p-3 bg-gray-50 rounded-2xl border border-gray-100 min-h-[60px]">
                                                            {(profileForm.branding?.seo?.sellingPoints?.ar || []).map((point, idx) => (
                                                                <span key={idx} className="bg-white px-3 py-1.5 rounded-xl text-[10px] font-bold text-gray-700 shadow-sm border border-gray-100 flex items-center gap-2 group/point">
                                                                    {point}
                                                                    <button type="button" onClick={() => {
                                                                        const updated = (profileForm.branding.seo.sellingPoints.ar || []).filter((_, i) => i !== idx);
                                                                        setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...profileForm.branding.seo.sellingPoints, ar: updated } } } });
                                                                    }} className="text-gray-300 hover:text-red-500 transition-colors">
                                                                        <i className="fas fa-times text-[8px]"></i>
                                                                    </button>
                                                                </span>
                                                            ))}
                                                            <input
                                                                className="bg-transparent border-none p-0 text-[10px] font-bold outline-none flex-1 min-w-[80px]"
                                                                placeholder="+ إضافة نقطة..."
                                                                onKeyDown={e => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        const val = e.target.value.trim();
                                                                        if (val) {
                                                                            const updated = [...(profileForm.branding?.seo?.sellingPoints?.ar || []), val];
                                                                            setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...(profileForm.branding.seo.sellingPoints || {}), ar: updated } } } });
                                                                            e.target.value = '';
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Per-Page SEO Titles */}
                                        <div className="mt-4 p-4 bg-gray-50 rounded-2xl border border-gray-100">
                                            <div className="flex justify-between items-center mb-4">
                                                <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">Page-Specific SEO Titles</span>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const slug = window.prompt("Enter page slug (e.g. shop, about, contact):");
                                                        if (slug) {
                                                            setProfileForm({
                                                                ...profileForm,
                                                                branding: {
                                                                    ...profileForm.branding,
                                                                    seo: {
                                                                        ...profileForm.branding.seo,
                                                                        pages: {
                                                                            ...profileForm.branding.seo.pages,
                                                                            [slug.toLowerCase()]: { title: { en: '', ar: '' }, description: { en: '', ar: '' } }
                                                                        }
                                                                    }
                                                                }
                                                            });
                                                        }
                                                    }}
                                                    className="text-[9px] font-black uppercase text-brand-primary hover:underline"
                                                >
                                                    + Add Page
                                                </button>
                                            </div>
                                            <div className="space-y-4 max-h-60 overflow-y-auto pr-2">
                                                {Object.entries(profileForm.branding?.seo?.pages || {}).map(([slug, data]) => (
                                                    <div key={slug} className="p-3 bg-white rounded-xl border border-gray-200 shadow-sm relative group">
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                const newPages = { ...profileForm.branding.seo.pages };
                                                                delete newPages[slug];
                                                                setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, pages: newPages } } });
                                                            }}
                                                            className="absolute top-2 right-2 text-gray-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                                                        >
                                                            <i className="fas fa-trash-alt text-[10px]"></i>
                                                        </button>
                                                        <div className="text-[10px] font-black text-brand-primary uppercase mb-2">/{slug}</div>
                                                        <div className="grid grid-cols-2 gap-2">
                                                            <input
                                                                placeholder="Title (EN)"
                                                                value={data.title?.en || ''}
                                                                onChange={e => {
                                                                    const updated = { ...profileForm.branding.seo.pages };
                                                                    updated[slug].title.en = e.target.value;
                                                                    setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, pages: updated } } });
                                                                }}
                                                                className="bg-gray-50 border-none p-2 rounded-lg text-[10px] font-bold"
                                                            />
                                                            <input
                                                                placeholder="العنوان (AR)"
                                                                value={data.title?.ar || ''}
                                                                onChange={e => {
                                                                    const updated = { ...profileForm.branding.seo.pages };
                                                                    updated[slug].title.ar = e.target.value;
                                                                    setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, pages: updated } } });
                                                                }}
                                                                dir="rtl"
                                                                className="bg-gray-50 border-none p-2 rounded-lg text-[10px] font-bold"
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                                {Object.keys(profileForm.branding?.seo?.pages || {}).length === 0 && (
                                                    <div className="text-[9px] text-gray-400 italic text-center py-4">No page-specific titles defined. Falling back to default.</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Colors & Visuals */}
                                    <div className="space-y-4 pt-4 border-t border-gray-100">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                            <i className="fas fa-palette"></i> {t('admin.settings.color_palette', 'Color Palette & Backgrounds')}
                                        </span>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t('admin.settings.logo_url', 'Brand Logo')}</label>
                                                <div className="flex items-center gap-3">
                                                    <div className="relative group">
                                                        <div className="w-16 h-16 rounded-2xl border-2 border-dashed border-gray-200 flex items-center justify-center overflow-hidden bg-gray-50">
                                                            {logoPreview ? <img src={logoPreview} alt="Logo Preview" className="w-full h-full object-contain" /> : <i className="fas fa-image text-gray-300"></i>}
                                                        </div>
                                                        <input type="file" accept="image/*" id="logo_file_input" style={{ display: 'none' }} onChange={e => { const f = e.target.files?.[0]; if (f) { setLogoPreview(URL.createObjectURL(f)); uploadBrandingFile(f, 'logo'); } }} />
                                                        <label htmlFor="logo_file_input" className="absolute inset-0 flex items-center justify-center bg-black/50 text-white opacity-0 group-hover:opacity-100 cursor-pointer transition-opacity rounded-2xl text-[8px] font-black uppercase">Change</label>
                                                    </div>
                                                    <div className="flex-1 space-y-2">
                                                        <div className="flex gap-2">
                                                            <input value={profileForm.branding?.logo?.path || logoPreview} onChange={e => { setLogoPreview(e.target.value); setProfileForm(prev => ({ ...prev, branding: { ...prev.branding, logo: { ...(prev.branding?.logo || {}), path: e.target.value } } })); }} className="bg-gray-50 border-none p-3 flex-1 rounded-xl text-[9px] font-bold" placeholder="Logo URL..." />
                                                        </div>
                                                        <div className="flex gap-2">
                                                            <input value={profileForm.branding?.favicon?.path || ''} onChange={e => setProfileForm(prev => ({ ...prev, branding: { ...prev.branding, favicon: { path: e.target.value } } }))} className="bg-gray-50 border-none p-3 flex-1 rounded-xl text-[9px] font-bold" placeholder="Favicon URL (16x16)..." />
                                                            <input type="file" accept="image/*" id="favicon_file_input" style={{ display: 'none' }} onChange={e => { const f = e.target.files?.[0]; if (f) uploadBrandingFile(f, 'favicon'); }} />
                                                            <label htmlFor="favicon_file_input" className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-2 rounded-xl text-[9px] font-black uppercase cursor-pointer flex items-center"><i className="fas fa-upload"></i></label>
                                                        </div>
                                                        <div className="flex gap-2">
                                                            <input value={profileForm.branding?.appleTouchIcon?.path || ''} onChange={e => setProfileForm(prev => ({ ...prev, branding: { ...prev.branding, appleTouchIcon: { path: e.target.value } } }))} className="bg-gray-50 border-none p-3 flex-1 rounded-xl text-[9px] font-bold" placeholder="Apple Touch URL (180x180)..." />
                                                            <input type="file" accept="image/*" id="apple_file_input" style={{ display: 'none' }} onChange={e => { const f = e.target.files?.[0]; if (f) uploadBrandingFile(f, 'appleTouchIcon'); }} />
                                                            <label htmlFor="apple_file_input" className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-2 rounded-xl text-[9px] font-black uppercase cursor-pointer flex items-center"><i className="fas fa-upload"></i></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="space-y-4">
                                                <div className="col-span-2">
                                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.primary_palette", "Primary & Palette")}</label>
                                                    <div className="grid grid-cols-3 gap-3">
                                                        <div>
                                                            <input type="color" value={profileForm.branding?.colors?.primary || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primary: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
                                                            <input value={profileForm.branding?.colors?.primary || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primary: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
                                                            <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Primary</span>
                                                        </div>
                                                        <div>
                                                            <input type="color" value={profileForm.branding?.colors?.primaryHover || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primaryHover: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
                                                            <input value={profileForm.branding?.colors?.primaryHover || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primaryHover: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
                                                            <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Hover</span>
                                                        </div>
                                                        <div>
                                                            <input type="color" value={profileForm.branding?.colors?.secondary || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), secondary: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
                                                            <input value={profileForm.branding?.colors?.secondary || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), secondary: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
                                                            <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Secondary</span>
                                                        </div>
                                                        <div>
                                                            <input type="color" value={profileForm.branding?.colors?.accent || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), accent: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
                                                            <input value={profileForm.branding?.colors?.accent || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), accent: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
                                                            <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Accent</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-2 gap-x-4 gap-y-3 pt-2">
                                                    <div className="flex items-center gap-2">
                                                        <input type="color" value={profileForm.branding?.colors?.bgBody || '#FDF7F0'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), bgBody: e.target.value } } })} className="w-8 h-8 rounded-lg cursor-pointer border-none p-0 shrink-0" />
                                                        <div className="flex-1">
                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.body_bg", "Body BG")}</label>
                                                            <input value={profileForm.branding?.colors?.bgBody || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), bgBody: e.target.value } } })} className="w-full bg-gray-50 border-none px-2 py-1 text-[9px] font-mono font-bold rounded-lg" placeholder="#HEX" />
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <input type="color" value={profileForm.branding?.colors?.bgHeader || '#FFFFFF'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), bgHeader: e.target.value } } })} className="w-8 h-8 rounded-lg cursor-pointer border-none p-0 shrink-0" />
                                                        <div className="flex-1">
                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.header_bg", "Header BG")}</label>
                                                            <input value={profileForm.branding?.colors?.bgHeader || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), bgHeader: e.target.value } } })} className="w-full bg-gray-50 border-none px-2 py-1 text-[9px] font-mono font-bold rounded-lg" placeholder="#HEX" />
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <input type="color" value={profileForm.branding?.colors?.textMain || '#1F2937'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), textMain: e.target.value } } })} className="w-8 h-8 rounded-lg cursor-pointer border-none p-0 shrink-0" />
                                                        <div className="flex-1">
                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.text_main", "Text Main")}</label>
                                                            <input value={profileForm.branding?.colors?.textMain || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), textMain: e.target.value } } })} className="w-full bg-gray-50 border-none px-2 py-1 text-[9px] font-mono font-bold rounded-lg" placeholder="#HEX" />
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <input type="color" value={profileForm.branding?.colors?.textMuted || '#6B7280'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), textMuted: e.target.value } } })} className="w-8 h-8 rounded-lg cursor-pointer border-none p-0 shrink-0" />
                                                        <div className="flex-1">
                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.text_muted", "Text Muted")}</label>
                                                            <input value={profileForm.branding?.colors?.textMuted || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), textMuted: e.target.value } } })} className="w-full bg-gray-50 border-none px-2 py-1 text-[9px] font-mono font-bold rounded-lg" placeholder="#HEX" />                                                            </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <input type="color" value={profileForm.branding?.colors?.textHeader || '#111827'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), textHeader: e.target.value } } })} className="w-8 h-8 rounded-lg cursor-pointer border-none p-0 shrink-0" />
                                                        <div className="flex-1">
                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.header_text", "Header Text")}</label>
                                                            <input value={profileForm.branding?.colors?.textHeader || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), textHeader: e.target.value } } })} className="w-full bg-gray-50 border-none px-2 py-1 text-[9px] font-mono font-bold rounded-lg" placeholder="#HEX" />
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <input type="color" value={profileForm.branding?.colors?.border || '#E5E7EB'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), border: e.target.value } } })} className="w-8 h-8 rounded-lg cursor-pointer border-none p-0 shrink-0" />
                                                        <div className="flex-1">
                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.border_color", "Border Color")}</label>
                                                            <input value={profileForm.branding?.colors?.border || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), border: e.target.value } } })} className="w-full bg-gray-50 border-none px-2 py-1 text-[9px] font-mono font-bold rounded-lg" placeholder="#HEX" />
                                                        </div>
                                                    </div>

                                                    {/* Glassmorphism Section */}
                                                    <div className="col-span-2 pt-4 mt-2 border-t border-gray-100">
                                                        <label className="text-[9px] font-black uppercase tracking-widest text-brand-primary mb-3 block">Glassmorphism Effects</label>
                                                        <div className="grid grid-cols-2 gap-4">
                                                            <div className="space-y-2">
                                                                <label className="text-[8px] font-black uppercase text-gray-400 block ml-2">Main Glass BG</label>
                                                                <input value={profileForm.branding?.colors?.glassBg || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), glassBg: e.target.value } } })} className="w-full bg-gray-50 border-none px-3 py-2 text-[10px] font-mono font-bold rounded-xl" placeholder="rgba(255,255,255,0.03)" />
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="text-[8px] font-black uppercase text-gray-400 block ml-2">Main Glass Border</label>
                                                                <input value={profileForm.branding?.colors?.glassBorder || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), glassBorder: e.target.value } } })} className="w-full bg-gray-50 border-none px-3 py-2 text-[10px] font-mono font-bold rounded-xl" placeholder="rgba(255,255,255,0.05)" />
                                                            </div>
                                                            <div className="col-span-2 space-y-2">
                                                                <label className="text-[8px] font-black uppercase text-gray-400 block ml-2">Glass Shadow</label>
                                                                <input value={profileForm.branding?.colors?.glassShadow || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), glassShadow: e.target.value } } })} className="w-full bg-gray-50 border-none px-3 py-2 text-[10px] font-mono font-bold rounded-xl" placeholder="0 8px 32px 0 rgba(0,0,0,0.37)" />
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="text-[8px] font-black uppercase text-gray-400 block ml-2">Card Glass BG</label>
                                                                <input value={profileForm.branding?.colors?.cardGlassBg || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), cardGlassBg: e.target.value } } })} className="w-full bg-gray-50 border-none px-3 py-2 text-[10px] font-mono font-bold rounded-xl" placeholder="rgba(255,255,255,0.05)" />
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="text-[8px] font-black uppercase text-gray-400 block ml-2">Card Glass Border</label>
                                                                <input value={profileForm.branding?.colors?.cardGlassBorder || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), cardGlassBorder: e.target.value } } })} className="w-full bg-gray-50 border-none px-3 py-2 text-[10px] font-mono font-bold rounded-xl" placeholder="rgba(255,255,255,0.1)" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* UI Elements Branding */}
                                    <div className="mt-6">
                                        <h3 className="text-lg font-semibold mb-2">Filter Placeholders Labels and Selects Types and Options</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            {/* Category */}
                                            <div>
                                                <label className="block text-sm font-medium mb-1">Category Label (EN)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.category?.label?.en || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, category: { ...profileForm.branding.filterPlaceholders?.category, label: { ...profileForm.branding.filterPlaceholders?.category?.label, en: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Category Label (AR)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.category?.label?.ar || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, category: { ...profileForm.branding.filterPlaceholders?.category, label: { ...profileForm.branding.filterPlaceholders?.category?.label, ar: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mb-1">Category Select and Option Text (EN)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.category?.selectTypeAndOption?.en || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, category: { ...profileForm.branding.filterPlaceholders?.category, selectTypeAndOption: { ...profileForm.branding.filterPlaceholders?.category?.selectTypeAndOption, en: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Category Select and Option Text (AR)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.category?.selectTypeAndOption?.ar || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, category: { ...profileForm.branding.filterPlaceholders?.category, selectTypeAndOption: { ...profileForm.branding.filterPlaceholders?.category?.selectTypeAndOption, ar: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Category Icon</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.category?.icon || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, category: { ...profileForm.branding.filterPlaceholders?.category, icon: e.target.value } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                            </div>
                                            {/* Material */}
                                            <div>
                                                <label className="block text-sm font-medium mb-1">Material Label (EN)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.material?.label?.en || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, material: { ...profileForm.branding.filterPlaceholders?.material, label: { ...profileForm.branding.filterPlaceholders?.material?.label, en: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Material Label (AR)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.material?.label?.ar || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, material: { ...profileForm.branding.filterPlaceholders?.material, label: { ...profileForm.branding.filterPlaceholders?.material?.label, ar: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mb-1">Material Select and Option Text (EN)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.material?.selectTypeAndOption?.en || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, material: { ...profileForm.branding.filterPlaceholders?.material, selectTypeAndOption: { ...profileForm.branding.filterPlaceholders?.material?.selectTypeAndOption, en: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Material Select and Option Text (AR)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.material?.selectTypeAndOption?.ar || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, material: { ...profileForm.branding.filterPlaceholders?.material, selectTypeAndOption: { ...profileForm.branding.filterPlaceholders?.material?.selectTypeAndOption, ar: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Material Icon</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.material?.icon || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, material: { ...profileForm.branding.filterPlaceholders?.material, icon: e.target.value } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                            </div>
                                            {/* Dimensions */}
                                            <div>
                                                <label className="block text-sm font-medium mb-1">Dimensions Label (EN)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.dimensions?.label?.en || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, dimensions: { ...profileForm.branding.filterPlaceholders?.dimensions, label: { ...profileForm.branding.filterPlaceholders?.dimensions?.label, en: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Dimensions Label (AR)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.dimensions?.label?.ar || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, dimensions: { ...profileForm.branding.filterPlaceholders?.dimensions, label: { ...profileForm.branding.filterPlaceholders?.dimensions?.label, ar: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mb-1">Dimensions Select and Option Text (EN)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.dimensions?.selectTypeAndOption?.en || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, dimensions: { ...profileForm.branding.filterPlaceholders?.dimensions, selectTypeAndOption: { ...profileForm.branding.filterPlaceholders?.dimensions?.selectTypeAndOption, en: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Dimensions Select and Option Text (AR)</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.dimensions?.selectTypeAndOption?.ar || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, dimensions: { ...profileForm.branding.filterPlaceholders?.dimensions, selectTypeAndOption: { ...profileForm.branding.filterPlaceholders?.dimensions?.selectTypeAndOption, ar: e.target.value } } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                                <label className="block text-sm font-medium mt-2 mb-1">Dimensions Icon</label>
                                                <input type="text" value={profileForm.branding?.filterPlaceholders?.dimensions?.icon || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, filterPlaceholders: { ...profileForm.branding.filterPlaceholders, dimensions: { ...profileForm.branding.filterPlaceholders?.dimensions, icon: e.target.value } } } })}
                                                    className="bg-gray-50 border p-2 w-full rounded" />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="space-y-4 pt-4 border-t border-gray-100">
                                            <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                                <i className="fas fa-shapes"></i> {t("admin.settings.ui_styling", "UI Styling (Radii & Spacing)")}
                                            </span>
                                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.btn_radius", "Button Radius")}</label>
                                                    <input value={profileForm.branding?.ui?.buttonRadius || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), buttonRadius: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="0.5rem" />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.card_radius", "Card Radius")}</label>
                                                    <input value={profileForm.branding?.ui?.cardRadius || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), cardRadius: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="1rem" />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.input_radius", "Input Radius")}</label>
                                                    <input value={profileForm.branding?.ui?.inputRadius || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), inputRadius: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="0.5rem" />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.nav_height", "Nav Height")}</label>
                                                    <input value={profileForm.branding?.ui?.navbarHeight || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), navbarHeight: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="80px" />
                                                </div>
                                                <div className="col-span-2">
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.card_shadow", "Card Shadow")}</label>
                                                    <input value={profileForm.branding?.ui?.cardShadow || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), cardShadow: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-[10px] font-mono" placeholder="0 4px 6px -1px ..." />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.transition", "Transition")}</label>
                                                    <input value={profileForm.branding?.ui?.transitionSpeed || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), transitionSpeed: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="0.3s" />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.card_padding", "Card Padding")}</label>
                                                    <input value={profileForm.branding?.ui?.cardPadding || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), cardPadding: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="1.5rem" />
                                                </div>
                                                <div className="col-span-2">
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <div className="flex items-center gap-3">
                                                            <input type="color" value={profileForm.branding?.ui?.footerBg || '#111827'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), footerBg: e.target.value } } })} className="w-10 h-10 rounded-xl cursor-pointer border-none p-0 shrink-0" />
                                                            <div className="flex-1">
                                                                <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.footer_bg", "Footer BG")}</label>
                                                                <input value={profileForm.branding?.ui?.footerBg || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), footerBg: e.target.value } } })} className="w-full bg-gray-50 border-none px-3 py-2 text-[10px] font-mono font-bold rounded-xl" placeholder="#HEX" />
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-3">
                                                            <input type="color" value={profileForm.branding?.ui?.footerText || '#FFFFFF'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), footerText: e.target.value } } })} className="w-10 h-10 rounded-xl cursor-pointer border-none p-0 shrink-0 shadow-sm" />
                                                            <div className="flex-1">
                                                                <label className="text-[8px] font-black uppercase text-gray-400 block mb-0.5">{t("admin.settings.footer_text", "Footer Text")}</label>
                                                                <input value={profileForm.branding?.ui?.footerText || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, ui: { ...(profileForm.branding?.ui || {}), footerText: e.target.value } } })} className="w-full bg-gray-50 border-none px-3 py-2 text-[10px] font-mono font-bold rounded-xl" placeholder="#HEX" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="space-y-4 pt-4 border-t border-gray-100">
                                            <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                                <i className="fas fa-font"></i> {t("admin.settings.typography", "Typography (Font Families)")}
                                            </span>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.body_font_en", "Body Font (EN)")}</label>
                                                    <input value={profileForm.branding?.fonts?.bodyEn || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, fonts: { ...(profileForm.branding?.fonts || {}), bodyEn: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="'Roboto', sans-serif" />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.body_font_ar", "Body Font (AR)")}</label>
                                                    <input value={profileForm.branding?.fonts?.bodyAr || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, fonts: { ...(profileForm.branding?.fonts || {}), bodyAr: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="'Cairo', sans-serif" />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.heading_font_en", "Heading Font (EN)")}</label>
                                                    <input value={profileForm.branding?.fonts?.headingEn || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, fonts: { ...(profileForm.branding?.fonts || {}), headingEn: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="'Roboto', sans-serif" />
                                                </div>
                                                <div>
                                                    <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-1 block">{t("admin.settings.heading_font_ar", "Heading Font (AR)")}</label>
                                                    <input value={profileForm.branding?.fonts?.headingAr || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, fonts: { ...(profileForm.branding?.fonts || {}), headingAr: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder="'Cairo', sans-serif" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contact & Social */}
                                    <div className="space-y-4 pt-2 border-t border-gray-50">
                                        <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">{t("admin.settings.contact_social", "Contact & Social Links")}</span>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.phoneHeader.part1", "Phone")}"\"{t("admin.settings.phoneHeader.part2", "header")}</label>
                                                <input value={profileForm.branding?.contact?.phoneHeader || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, contact: { ...(profileForm.branding?.contact || {}), phoneHeader: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.phoneFooter.part1", "Phone")}"\"{t("admin.settings.phoneFooter.part2", "footer")}</label>
                                                <input value={profileForm.branding?.contact?.phoneFooter || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, contact: { ...(profileForm.branding?.contact || {}), phoneFooter: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.email", "Email")}</label>
                                                <input value={profileForm.branding?.contact?.email || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, contact: { ...(profileForm.branding?.contact || {}), email: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" />
                                            </div>
                                            <div className="col-span-2 space-y-4 pt-2 border-t border-gray-100">
                                                <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">{t("admin.settings.footer_content", "Footer Description")}</span>
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.footer_desc_en", "Footer Description (EN)")}</label>
                                                        <textarea value={profileForm.branding?.footerDescription?.en || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, footerDescription: { ...(profileForm.branding?.footerDescription || {}), en: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold h-16" />
                                                    </div>
                                                    <div>
                                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.footer_desc_ar", "Footer Description (AR)")}</label>
                                                        <textarea value={profileForm.branding?.footerDescription?.ar || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, footerDescription: { ...(profileForm.branding?.footerDescription || {}), ar: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold text-right h-16" dir="rtl" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.facebook", "Facebook")}</label>
                                                <input value={profileForm.branding?.socialLinks?.facebook || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, socialLinks: { ...(profileForm.branding?.socialLinks || {}), facebook: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.instagram", "Instagram")}</label>
                                                <input value={profileForm.branding?.socialLinks?.instagram || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, socialLinks: { ...(profileForm.branding?.socialLinks || {}), instagram: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.whatsapp", "WhatsApp")}</label>
                                                <input value={profileForm.branding?.socialLinks?.whatsapp || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, socialLinks: { ...(profileForm.branding?.socialLinks || {}), whatsapp: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.tiktok", "TikTok")}</label>
                                                <input value={profileForm.branding?.socialLinks?.tiktok || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, socialLinks: { ...(profileForm.branding?.socialLinks || {}), tiktok: e.target.value } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Home Page Content */}
                                    <div className="space-y-4 pt-4 border-t border-gray-100">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                            <i className="fas fa-home"></i> {t("admin.settings.home_content", "Home Page Static Content")}
                                        </span>
                                        <div className="grid grid-cols-1 gap-6 p-4 bg-gray-50 rounded-2xl border border-gray-100">
                                            {[
                                                { key: 'exploreCollections', label: t('admin.settings.home.explore_collections', 'Explore Collections'), hint: t('admin.settings.home.explore_hint', 'Label above categories on home page') },
                                                { key: 'shopByCategory', label: t('admin.settings.home.shop_by_category', 'Shop by Category Title'), hint: t('admin.settings.home.categories_hint', 'Main title for categories section') },
                                                { key: 'eliteSelection', label: t('admin.settings.home.elite_selection', 'Elite Selection'), hint: t('admin.settings.home.elite_hint', 'Label above top products') },
                                                { key: 'topRatedProducts', label: t('admin.settings.home.top_rated', 'Top Rated Products'), hint: t('admin.settings.home.top_rated_hint', 'Main title for top products section') },
                                                { key: 'viewAllCollection', label: t('admin.settings.home.view_all_btn', 'View All Collection Button'), hint: t('admin.settings.home.view_all_hint', 'Text for the "View All" link') },
                                                { key: 'testimonials', label: t('admin.settings.home.testimonials_title', 'Testimonials Section Title'), hint: t('admin.settings.home.testimonials_hint', 'Label above reviews') },
                                                { key: 'customerReviews', label: t('admin.settings.home.customer_reviews_subtitle', 'Customer Reviews Subtitle'), hint: t('admin.settings.home.reviews_hint', 'Main title for reviews section') },
                                                { key: 'trustBannerTitle', label: t('admin.settings.home.trust_banner_title', 'Trust Banner Main Title'), hint: t('admin.settings.home.trust_hint', 'Main title for the bottom trust banner') }
                                            ].map(field => (
                                                <div key={field.key} className="space-y-2">
                                                    <div className="flex justify-between items-center">
                                                        <label className="text-[9px] font-black uppercase tracking-widest text-gray-400 ml-2">{field.label}</label>
                                                        <span className="text-[8px] text-gray-300 italic">{field.hint}</span>
                                                    </div>
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <input
                                                            value={profileForm.branding?.homeContent?.[field.key]?.en || ''}
                                                            onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, homeContent: { ...(profileForm.branding?.homeContent || {}), [field.key]: { ...(profileForm.branding?.homeContent?.[field.key] || {}), en: e.target.value } } } })}
                                                            className="bg-white border-none p-2 rounded-lg text-xs font-bold"
                                                            placeholder="English"
                                                        />
                                                        <input
                                                            value={profileForm.branding?.homeContent?.[field.key]?.ar || ''}
                                                            onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, homeContent: { ...(profileForm.branding?.homeContent || {}), [field.key]: { ...(profileForm.branding?.homeContent?.[field.key] || {}), ar: e.target.value } } } })}
                                                            className="bg-white border-none p-2 rounded-lg text-xs font-bold text-right"
                                                            dir="rtl"
                                                            placeholder="العربية"
                                                        />
                                                    </div>
                                                </div>
                                            ))}

                                            {/* Trust Features */}
                                            <div className="mt-2 pt-4 border-t border-gray-200">
                                                <label className="text-[10px] font-black uppercase tracking-widest text-gray-900 block mb-4">Trust Features Labels</label>
                                                <div className="space-y-4">
                                                    {[
                                                        { key: 'verifiedReviews', label: 'Verified Reviews' },
                                                        { key: 'qualityGuarantee', label: 'Quality Guarantee' },
                                                        { key: 'easyContact', label: 'Easy Contact' }
                                                    ].map(feat => (
                                                        <div key={feat.key} className="space-y-2">
                                                            <label className="text-[8px] font-black uppercase text-gray-400 ml-2">{feat.label}</label>
                                                            <div className="grid grid-cols-2 gap-3">
                                                                <input
                                                                    value={profileForm.branding?.homeContent?.trustFeatures?.[feat.key]?.en || ''}
                                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, homeContent: { ...profileForm.branding.homeContent, trustFeatures: { ...profileForm.branding.homeContent.trustFeatures, [feat.key]: { ...profileForm.branding.homeContent.trustFeatures[feat.key], en: e.target.value } } } } })}
                                                                    className="bg-white border-none p-2 rounded-lg text-xs font-bold"
                                                                    placeholder="English"
                                                                />
                                                                <input
                                                                    value={profileForm.branding?.homeContent?.trustFeatures?.[feat.key]?.ar || ''}
                                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, homeContent: { ...profileForm.branding.homeContent, trustFeatures: { ...profileForm.branding.homeContent.trustFeatures, [feat.key]: { ...profileForm.branding.homeContent.trustFeatures[feat.key], ar: e.target.value } } } } })}
                                                                    className="bg-white border-none p-2 rounded-lg text-xs font-bold text-right"
                                                                    dir="rtl"
                                                                    placeholder="العربية"
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    {/* App Features & Localization */}
                                    <div className="space-y-4 pt-4 border-t border-gray-100">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                            <i className="fas fa-cog"></i> {t("admin.settings.app_config", "App Features & Localization")}
                                        </span>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            {/* Default Language */}
                                            <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100">
                                                <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-2 block">{t("admin.settings.default_language", "Initial Language")}</label>
                                                <div className="flex gap-2">
                                                    {['en', 'ar'].map(lang => (
                                                        <button
                                                            key={lang}
                                                            type="button"
                                                            onClick={() => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, defaultLanguage: lang } })}
                                                            className={`flex-1 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all ${profileForm.branding?.defaultLanguage === lang ? 'bg-brand-primary text-white shadow-lg shadow-brand-primary/20' : 'bg-white text-gray-400 hover:bg-gray-100'}`}
                                                        >
                                                            {lang === 'en' ? 'English' : 'العربية'}
                                                        </button>
                                                    ))}
                                                </div>
                                                <p className="text-[8px] text-gray-400 mt-2 italic px-2">{t("admin.settings.lang_hint", "Sets the initial language when a user first visits the store.")}</p>
                                            </div>

                                            {/* Feature Toggles */}
                                            <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100">
                                                <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-3 block">{t("admin.settings.feature_toggles", "Enabled Modules")}</label>
                                                <div className="grid grid-cols-1 gap-2">
                                                    {[
                                                        { key: 'cart', label: t('admin.settings.features.cart', 'Shopping Cart'), icon: 'fa-shopping-cart' },
                                                        { key: 'wishlist', label: t('admin.settings.features.wishlist', 'Wishlist System'), icon: 'fa-heart' },
                                                        { key: 'comparison', label: t('admin.settings.features.compare', 'Product Comparison'), icon: 'fa-exchange-alt' },
                                                        { key: 'userPortal', label: t('admin.settings.features.portal', 'User Portal (Orders)'), icon: 'fa-user-circle' },
                                                        { key: 'payments', label: t('admin.settings.features.payments', 'Multi-Currency Payments'), icon: 'fa-credit-card' }
                                                    ].map(feat => (
                                                        <div key={feat.key} className="flex items-center justify-between p-2 bg-white rounded-xl border border-gray-100 group hover:border-brand-primary/20 transition-all">
                                                            <div className="flex items-center gap-3">
                                                                <div className={`w-7 h-7 rounded-lg flex items-center justify-center transition-colors ${profileForm.branding?.features?.[feat.key] ? 'bg-brand-primary/10 text-brand-primary' : 'bg-gray-100 text-gray-400'}`}>
                                                                    <i className={`fas ${feat.icon} text-[10px]`}></i>
                                                                </div>
                                                                <span className="text-[10px] font-bold text-gray-700">{feat.label}</span>
                                                            </div>
                                                            <div
                                                                onClick={() => setProfileForm({
                                                                    ...profileForm,
                                                                    branding: {
                                                                        ...profileForm.branding,
                                                                        features: {
                                                                            ...(profileForm.branding?.features || {}),
                                                                            [feat.key]: !profileForm.branding?.features?.[feat.key]
                                                                        }
                                                                    }
                                                                })}
                                                                className={`w-9 h-5 rounded-full relative transition-all cursor-pointer ${profileForm.branding?.features?.[feat.key] ? 'bg-brand-primary' : 'bg-gray-200'}`}
                                                            >
                                                                <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${profileForm.branding?.features?.[feat.key] ? (isArabic ? 'left-0.5' : 'right-0.5') : (isArabic ? 'right-0.5' : 'left-0.5')}`}></div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Compliance & Data Protection */}
                                    <div className="space-y-4 pt-4 border-t border-gray-100">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                            <i className="fas fa-shield-alt"></i> {t("admin.settings.compliance_legal", "Compliance & Data Protection")}
                                        </span>

                                        <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100">
                                            <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-3 block">{t("admin.settings.modular_compliance", "Modular Regulatory Controls")}</label>
                                            <div className="grid grid-cols-1 gap-2">
                                                {[
                                                    { key: 'enableGlobalConsentBanner', label: t('admin.settings.compliance.banner', 'Global Privacy & Cookie Banner'), icon: 'fa-cookie-bite' },
                                                    { key: 'enableEgyptMarketingConsent', label: t('admin.settings.compliance.egypt', 'Egypt Law 151/2020 Marketing Consent'), icon: 'fa-envelope-open-text' },
                                                    { key: 'enableExplicitDataProcessing', label: t('admin.settings.compliance.gdpr', 'GDPR/PDPL Explicit Data Processing'), icon: 'fa-user-lock' }
                                                ].map(item => (
                                                    <div key={item.key} className="flex items-center justify-between p-2 bg-white rounded-xl border border-gray-100 group hover:border-brand-primary/20 transition-all">
                                                        <div className="flex items-center gap-3">
                                                            <div className={`w-7 h-7 rounded-lg flex items-center justify-center transition-colors ${profileForm.branding?.compliance?.[item.key] ? 'bg-brand-primary/10 text-brand-primary' : 'bg-gray-100 text-gray-400'}`}>
                                                                <i className={`fas ${item.icon} text-[10px]`}></i>
                                                            </div>
                                                            <span className="text-[10px] font-bold text-gray-700">{item.label}</span>
                                                        </div>
                                                        <div
                                                            onClick={() => setProfileForm({
                                                                ...profileForm,
                                                                branding: {
                                                                    ...profileForm.branding,
                                                                    compliance: {
                                                                        ...(profileForm.branding?.compliance || {}),
                                                                        [item.key]: !profileForm.branding?.compliance?.[item.key]
                                                                    }
                                                                }
                                                            })}
                                                            className={`w-9 h-5 rounded-full relative transition-all cursor-pointer ${profileForm.branding?.compliance?.[item.key] ? 'bg-brand-primary' : 'bg-gray-200'}`}
                                                        >
                                                            <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${profileForm.branding?.compliance?.[item.key] ? (isArabic ? 'left-0.5' : 'right-0.5') : (isArabic ? 'right-0.5' : 'left-0.5')}`}></div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <p className="text-[8px] text-gray-400 mt-2 italic px-2">{t("admin.settings.compliance_hint", "Toggle these based on your target market requirements (EU, Saudi, UAE, Egypt).")}</p>
                                        </div>
                                    </div>

                                    {/* AI Stories Module Toggle */}
                                    <div className="space-y-3 pt-4 border-t border-gray-100">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                            <i className="fas fa-film"></i> {t("admin.settings.ai_stories", "AI Stories Module")}
                                        </span>
                                        <div className="p-3 bg-gray-50 rounded-2xl border border-gray-100 space-y-2">
                                            <div className="flex items-center justify-between p-2 bg-white rounded-xl border border-gray-100 group hover:border-brand-primary/20 transition-all">
                                                <div className="flex items-center gap-3">
                                                    <div className={`w-7 h-7 rounded-lg flex items-center justify-center transition-colors ${profileForm.branding?.features?.aiStories !== false ? 'bg-brand-primary/10 text-brand-primary' : 'bg-gray-100 text-gray-400'}`}>
                                                        <i className="fas fa-film text-[10px]"></i>
                                                    </div>
                                                    <div>
                                                        <span className="text-[10px] font-bold text-gray-700">Enable AI Stories Feed & Shop Carousel</span>
                                                        <p className="text-[8px] text-gray-400 mt-0.5">Show AI-generated product stories on the shop page and at /stories</p>
                                                    </div>
                                                </div>
                                                <div
                                                    onClick={() => setProfileForm({
                                                        ...profileForm,
                                                        branding: {
                                                            ...profileForm.branding,
                                                            features: {
                                                                ...(profileForm.branding?.features || {}),
                                                                aiStories: profileForm.branding?.features?.aiStories === false ? true : false
                                                            }
                                                        }
                                                    })}
                                                    className={`w-9 h-5 rounded-full relative transition-all cursor-pointer ${profileForm.branding?.features?.aiStories !== false ? 'bg-brand-primary' : 'bg-gray-200'}`}
                                                >
                                                    <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${profileForm.branding?.features?.aiStories !== false ? (isArabic ? 'left-0.5' : 'right-0.5') : (isArabic ? 'right-0.5' : 'left-0.5')}`}></div>
                                                </div>
                                            </div>
                                            <p className="text-[8px] text-gray-400 italic px-2">Videos are generated via Python + Pillow. Requires Python to be installed on the server.</p>
                                        </div>
                                    </div>

                                    {/* Checkout & Payments */}
                                    <div className="space-y-4 pt-4 border-t border-gray-100">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
                                            <i className="fas fa-credit-card"></i> Checkout & Payments Configuration
                                        </span>

                                        <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100 space-y-6">
                                            {/* Global Checkout Settings */}
                                            <div>
                                                <label className="text-[9px] font-black uppercase text-gray-400 ml-2 mb-2 block">Receipt WhatsApp Number</label>
                                                <input
                                                    value={profileForm.branding?.checkout?.receiptWhatsApp || ''}
                                                    onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...(profileForm.branding?.checkout || {}), receiptWhatsApp: e.target.value } } })}
                                                    className="bg-white border-none p-3 w-full rounded-xl text-xs font-bold"
                                                    placeholder="Optional: WhatsApp number for manual payment receipts (e.g., +1234567890)"
                                                />
                                            </div>

                                            {/* Gateway Keys (Stripe/PayPal) */}
                                            <div className="space-y-3 pt-4 border-t border-gray-200">
                                                <label className="text-[9px] font-black uppercase tracking-widest text-brand-primary ml-2">API Keys (Card / PayPal)</label>
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="text-[8px] font-black uppercase text-gray-400 ml-2 mb-1 block">Stripe Publishable Key</label>
                                                        <input value={profileForm.branding?.checkout?.gatewayKeys?.stripe_publishable_key || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...(profileForm.branding?.checkout || {}), gatewayKeys: { ...(profileForm.branding?.checkout?.gatewayKeys || {}), stripe_publishable_key: e.target.value } } } })} className="bg-white border border-gray-100 p-2 w-full rounded-xl text-[10px] font-mono" placeholder="pk_live_..." />
                                                    </div>
                                                    <div>
                                                        <label className="text-[8px] font-black uppercase text-gray-400 ml-2 mb-1 block">Stripe Secret Key</label>
                                                        <input type="password" value={profileForm.branding?.checkout?.gatewayKeys?.stripe_secret_key || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...(profileForm.branding?.checkout || {}), gatewayKeys: { ...(profileForm.branding?.checkout?.gatewayKeys || {}), stripe_secret_key: e.target.value } } } })} className="bg-white border border-gray-100 p-2 w-full rounded-xl text-[10px] font-mono" placeholder="sk_live_..." />
                                                    </div>
                                                    <div>
                                                        <label className="text-[8px] font-black uppercase text-gray-400 ml-2 mb-1 block">PayPal Client ID</label>
                                                        <input value={profileForm.branding?.checkout?.gatewayKeys?.paypal_client_id || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...(profileForm.branding?.checkout || {}), gatewayKeys: { ...(profileForm.branding?.checkout?.gatewayKeys || {}), paypal_client_id: e.target.value } } } })} className="bg-white border border-gray-100 p-2 w-full rounded-xl text-[10px] font-mono" placeholder="AZ..." />
                                                    </div>
                                                    <div>
                                                        <label className="text-[8px] font-black uppercase text-gray-400 ml-2 mb-1 block">PayPal Secret</label>
                                                        <input type="password" value={profileForm.branding?.checkout?.gatewayKeys?.paypal_client_secret || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...(profileForm.branding?.checkout || {}), gatewayKeys: { ...(profileForm.branding?.checkout?.gatewayKeys || {}), paypal_client_secret: e.target.value } } } })} className="bg-white border border-gray-100 p-2 w-full rounded-xl text-[10px] font-mono" placeholder="E..." />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Payment Methods Toggle & Config */}
                                            <div className="space-y-4 pt-4 border-t border-gray-200">
                                                <label className="text-[9px] font-black uppercase tracking-widest text-brand-primary ml-2">Payment Methods Toggles & Instructions</label>
                                                {[
                                                    { id: 'cash_on_delivery', name: 'Cash on Delivery', hasAccount: false },
                                                    { id: 'bank_transfer', name: 'Bank Transfer', hasAccount: true, hasBank: true },
                                                    { id: 'vodafone_cash', name: 'Vodafone Cash', hasAccount: true },
                                                    { id: 'instapay', name: 'InstaPay', hasAccount: true },
                                                    { id: 'fawry', name: 'Fawry', hasAccount: true },
                                                    { id: 'paypal', name: 'PayPal', hasAccount: false },
                                                    { id: 'stripe_card', name: 'Stripe Card', hasAccount: false }
                                                ].map(method => {
                                                    const mData = profileForm.branding?.checkout?.paymentMethods?.[method.id] || {};
                                                    return (
                                                        <div key={method.id} className="bg-white p-4 rounded-xl border border-gray-100 space-y-3">
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-[10px] font-black uppercase text-gray-700">{method.name}</span>
                                                                <div
                                                                    onClick={() => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...(profileForm.branding?.checkout || {}), paymentMethods: { ...(profileForm.branding?.checkout?.paymentMethods || {}), [method.id]: { ...mData, enabled: !mData.enabled } } } } })}
                                                                    className={`w-8 h-4 rounded-full relative cursor-pointer transition-all ${mData.enabled ? 'bg-green-500' : 'bg-gray-200'}`}
                                                                >
                                                                    <div className={`absolute top-0.5 w-3 h-3 bg-white rounded-full transition-all ${mData.enabled ? 'right-0.5' : 'left-0.5'}`}></div>
                                                                </div>
                                                            </div>
                                                            {mData.enabled && (
                                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">
                                                                    {method.hasAccount && (
                                                                        <div>
                                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-1">Account Number / Reference</label>
                                                                            <input value={mData.accountNumber || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...profileForm.branding.checkout, paymentMethods: { ...profileForm.branding.checkout.paymentMethods, [method.id]: { ...mData, accountNumber: e.target.value } } } } })} className="bg-gray-50 border-none p-2 w-full rounded-lg text-xs font-bold" />
                                                                        </div>
                                                                    )}
                                                                    {method.hasBank && (
                                                                        <div>
                                                                            <label className="text-[8px] font-black uppercase text-gray-400 block mb-1">Bank Name</label>
                                                                            <input value={mData.bankName || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...profileForm.branding.checkout, paymentMethods: { ...profileForm.branding.checkout.paymentMethods, [method.id]: { ...mData, bankName: e.target.value } } } } })} className="bg-gray-50 border-none p-2 w-full rounded-lg text-xs font-bold" />
                                                                        </div>
                                                                    )}
                                                                    <div className="md:col-span-2">
                                                                        <label className="text-[8px] font-black uppercase text-gray-400 block mb-1">Instructions for User</label>
                                                                        <textarea value={mData.instructions || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, checkout: { ...profileForm.branding.checkout, paymentMethods: { ...profileForm.branding.checkout.paymentMethods, [method.id]: { ...mData, instructions: e.target.value } } } } })} className="bg-gray-50 border-none p-2 w-full rounded-lg text-xs font-bold h-12" />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Database Isolation (Master Only) */}
                                    {isMaster && (
                                        <div className="pt-4 border-t border-gray-50">
                                            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t('admin.settings.database_url', 'Remote Database URL (Isolation)')}</label>
                                            <div className="flex gap-2">
                                                <input value={profileForm.database_url || ''} onChange={e => setProfileForm({ ...profileForm, database_url: e.target.value })} className="bg-gray-50 border-none p-4 flex-1 rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all font-mono font-bold text-[10px]" placeholder="mysql://user:pass@host:port/db" />
                                                <button type="button" onClick={testDatabaseConnection} className="bg-gray-900 text-white px-4 py-2 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-black">{t('admin.settings.test', 'Test')}</button>
                                            </div>
                                            <p className="text-[9px] text-gray-400 ml-4 mt-1 italic">Optional: Connect this store to a private database server.</p>
                                        </div>
                                    )}
                                </div>

                                <div className="flex gap-4 pt-4">
                                    <button type="submit" className="flex-1 bg-brand-primary text-white py-5 rounded-3xl font-black text-xs uppercase tracking-widest shadow-xl shadow-brand-primary/20 hover:scale-[1.02] transition-all">
                                        {editingProfile ? t("admin.common.update", "Update Profile") : t("admin.common.save", "Create Profile")}
                                    </button>
                                    <button type="button" onClick={() => setShowProfileModal(false)} className="flex-1 bg-gray-100 text-gray-600 py-5 rounded-3xl font-black text-xs uppercase tracking-widest hover:bg-gray-200 transition-all">
                                        {t("admin.common.cancel", "Cancel")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {showConfigModal && (
                <div className="fixed inset-0 z-[110] overflow-y-auto bg-gray-900/60 backdrop-blur-sm">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <div className="bg-white rounded-[40px] w-full max-w-lg p-10 animate-scale-in my-8">
                            <h3 className="text-2xl font-black text-gray-900 mb-6">{editingConfig ? t("admin.settings.edit_var", "Edit Variable") : t("admin.settings.add_var", "Add New Variable")}</h3>
                            <form onSubmit={handleSaveConfig} className="space-y-6">
                                <div>
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.key", "Variable Key")}</label>
                                    <input value={configForm.config_key} onChange={e => setConfigForm({ ...configForm, config_key: e.target.value })} className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-mono font-bold" required placeholder="e.g. STORAGE_PROVIDER" />
                                </div>
                                <div>
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.value", "Value")}</label>
                                    <textarea value={configForm.config_value} onChange={e => setConfigForm({ ...configForm, config_value: e.target.value })} className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold h-24" required placeholder="Paste value here..." />
                                </div>
                                <div>
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.description", "Description")}</label>
                                    <input value={configForm.description} onChange={e => setConfigForm({ ...configForm, description: e.target.value })} className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold" placeholder="What is this used for?" />
                                </div>
                                <div className="flex items-center gap-3 ml-4">
                                    <input type="checkbox" checked={!!configForm.is_active} onChange={e => setConfigForm({ ...configForm, is_active: e.target.checked ? 1 : 0 })} id="var_active" className="w-5 h-5 rounded border-gray-300 text-brand-primary focus:ring-brand-primary" />
                                    <label htmlFor="var_active" className="text-sm font-bold text-gray-700">{t("admin.settings.active", "Enabled")}</label>
                                </div>
                                <div className="flex gap-4 pt-4">
                                    <button type="submit" className="flex-1 bg-brand-primary text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-lg shadow-brand-primary/20 hover:scale-[1.02] transition-all">
                                        {t("admin.common.save", "Save")}
                                    </button>
                                    <button type="button" onClick={() => setShowConfigModal(false)} className="flex-1 bg-gray-100 text-gray-600 py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-gray-200 transition-all">
                                        {t("admin.common.cancel", "Cancel")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Add Extra Sets Modal ─────────────────────────────────────────── */}
            {showExtraSetsModal && (
                <div className="fixed inset-0 z-[110] overflow-y-auto bg-gray-900/60 backdrop-blur-sm">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <div className="bg-white rounded-[40px] w-full max-w-2xl p-10 shadow-2xl my-8 animate-scale-in">

                            {/* Header */}
                            <div className="flex items-start justify-between mb-8">
                                <div>
                                    <h3 className="text-2xl font-black text-gray-900">
                                        {t("admin.settings.add_extra_sets_title", "Add Configuration Variables")}
                                    </h3>
                                    <p className="text-[11px] text-gray-400 font-medium mt-1">
                                        {t("admin.settings.add_extra_sets_subtitle", `Targeting domain: ${extraSetsTargetProfile?.name || 'Unknown'}`)}
                                    </p>
                                </div>
                                <button
                                    onClick={() => setShowExtraSetsModal(false)}
                                    className="text-gray-300 hover:text-gray-600 transition-colors ml-4 mt-1"
                                >
                                    <i className="fas fa-times text-lg"></i>
                                </button>
                            </div>

                            {/* ── Step 1: Set Information ── */}
                            <div className="mb-6 space-y-4">
                                <div>
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">
                                        {t("admin.settings.set_name", "Set Group Name (Optional)")}
                                    </label>
                                    <input
                                        value={extraSetName}
                                        onChange={e => setExtraSetName(e.target.value)}
                                        className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold"
                                        placeholder="e.g. Payment Keys"
                                    />
                                    <p className="text-[9px] text-gray-400 italic ml-4 mt-1">Used to visually group these variables together.</p>
                                </div>

                                <div>
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">
                                        {t("admin.settings.set_description", "Description (Optional)")}
                                    </label>
                                    <input
                                        value={extraSetDescription}
                                        onChange={e => setExtraSetDescription(e.target.value)}
                                        className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold"
                                        placeholder="e.g. Production Stripe Credentials"
                                    />
                                </div>

                                <div>
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block flex justify-between items-center pr-4">
                                        <span>{t("admin.settings.database_url", "Database URL (Optional)")}</span>
                                        <i className="fas fa-database text-gray-300"></i>
                                    </label>
                                    <input
                                        value={extraSetDbUrl}
                                        onChange={e => setExtraSetDbUrl(e.target.value)}
                                        className="bg-gray-50 border-none p-4 w-full rounded-2xl focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold text-[11px]"
                                        placeholder="mysql://user:pass@host:port/db"
                                    />
                                    <p className="text-[9px] text-brand-primary/70 font-bold ml-4 mt-1">Warning: Providing a DB URL here will update the domain's external database connection!</p>
                                </div>
                            </div>

                            {/* ── Step 2: Config Variables ── */}
                            <div className="mb-8">
                                <div className="flex items-center justify-between mb-3">
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400">
                                        <i className="fas fa-sliders-h mr-1"></i>
                                        {t("admin.settings.add_vars_optional", "Config Variables (optional)")}
                                    </label>
                                    <button
                                        type="button"
                                        onClick={addExtraVarRow}
                                        className="text-[9px] font-black uppercase tracking-widest text-brand-primary bg-brand-primary/10 hover:bg-brand-primary hover:text-white px-3 py-1.5 rounded-xl transition-all"
                                    >
                                        <i className="fas fa-plus mr-1"></i> {t("admin.settings.add_row", "Add Row")}
                                    </button>
                                </div>

                                <div className="space-y-2">
                                    {/* Column headers */}
                                    <div className="grid grid-cols-[2fr_2fr_3fr_auto] gap-2 px-1">
                                        <span className="text-[9px] font-black uppercase text-gray-300">Key</span>
                                        <span className="text-[9px] font-black uppercase text-gray-300">Value</span>
                                        <span className="text-[9px] font-black uppercase text-gray-300">Description</span>
                                        <span></span>
                                    </div>

                                    {extraSetsVariables.map((row, idx) => (
                                        <div key={idx} className="grid grid-cols-[2fr_2fr_3fr_auto] gap-2 items-center">
                                            <input
                                                value={row.key}
                                                onChange={e => updateExtraVarRow(idx, 'key', e.target.value)}
                                                placeholder="STORAGE_PROVIDER"
                                                className="bg-gray-50 border-none p-2.5 rounded-xl text-[10px] font-mono font-bold focus:ring-2 focus:ring-brand-primary/20 focus:bg-white transition-all"
                                            />
                                            <input
                                                value={row.value}
                                                onChange={e => updateExtraVarRow(idx, 'value', e.target.value)}
                                                placeholder="cloudinary"
                                                className="bg-gray-50 border-none p-2.5 rounded-xl text-[10px] font-bold focus:ring-2 focus:ring-brand-primary/20 focus:bg-white transition-all"
                                            />
                                            <input
                                                value={row.description}
                                                onChange={e => updateExtraVarRow(idx, 'description', e.target.value)}
                                                placeholder="Optional description…"
                                                className="bg-gray-50 border-none p-2.5 rounded-xl text-[10px] font-bold focus:ring-2 focus:ring-brand-primary/20 focus:bg-white transition-all"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => removeExtraVarRow(idx)}
                                                disabled={extraSetsVariables.length === 1}
                                                className="w-8 h-8 flex items-center justify-center rounded-xl text-gray-300 hover:text-red-500 hover:bg-red-50 transition-all disabled:opacity-30"
                                            >
                                                <i className="fas fa-times text-[10px]"></i>
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                <p className="text-[9px] text-gray-300 italic mt-2 ml-1">
                                    {t("admin.settings.vars_hint", "Variables are added to this profile. Leave key empty to skip a row.")}
                                </p>
                            </div>

                            {/* ── Action Buttons ── */}
                            <div className="flex gap-4">
                                <button
                                    type="button"
                                    onClick={handleSubmitExtraSets}
                                    disabled={submittingExtraSets || !extraSetsTargetProfile}
                                    className="flex-1 bg-blue-600 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-lg shadow-blue-600/20 hover:bg-blue-700 hover:scale-[1.02] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:scale-100 flex items-center justify-center gap-2"
                                >
                                    {submittingExtraSets ? (
                                        <><i className="fas fa-spinner fa-spin"></i> {t("admin.settings.syncing", "Syncing…")}</>
                                    ) : (
                                        <><i className="fas fa-layer-group"></i> {t("admin.settings.add_extra_sets_btn", "Add Extra Sets")}</>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setShowExtraSetsModal(false)}
                                    className="flex-1 bg-gray-100 text-gray-600 py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-gray-200 transition-all"
                                >
                                    {t("admin.common.cancel", "Cancel")}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* Success Toast */}
            {message && (
                <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[120] bg-gray-900 text-white px-8 py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-2xl animate-bounce-in flex items-center gap-3">
                    <i className="fas fa-check-circle text-green-500"></i>
                    {message}
                </div>
            )}
        </div>
    );
});

export default SystemSettingsAdmin;






















// import React, { useState, useEffect, useCallback, memo } from "react";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { getToken } from "../../utils/auth";
// import CONFIG from "../../config";
// import { useNavigate } from "react-router-dom";
// import BRANDING from "../../branding";

// // const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';

// // const SystemSettingsAdmin = memo(() => {
// //     const { t } = useTranslation();
// //     const navigate = useNavigate();

// //     // Stats State
// //     const [configStats, setConfigStats] = useState(null);
// //     const [storageStats, setStorageStats] = useState(null);

// //     // Profile State
// //     const [profiles, setProfiles] = useState([]);
// //     const [selectedProfileId, setSelectedProfileId] = useState(null);
// //     const [showProfileModal, setShowProfileModal] = useState(false);
// //     const [editingProfile, setEditingProfile] = useState(null);
// //     const [profileForm, setProfileForm] = useState({ name: "", description: "", hostname: "" });

// //     // Config State
// //     const [configs, setConfigs] = useState([]);
// //     const [loadingConfigs, setLoadingConfigs] = useState(false);
// //     const [showConfigModal, setShowConfigModal] = useState(false);
// //     const [editingConfig, setEditingConfig] = useState(null);
// //     const [configForm, setConfigForm] = useState({ config_key: "", config_value: "", description: "", is_active: 1 });

// //     const [message, setMessage] = useState("");
// //     const [searchQuery, setSearchQuery] = useState("");

// //     // --- Data Fetching ---

// //     const fetchStats = useCallback(async () => {
// //         try {
// //             const token = getToken();
// //             const configRes = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats`, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });
// //             const storageRes = await axios.get(`${CONFIG.API_URL}/api/storage/stats`, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });
// //             setConfigStats(configRes.data);
// //             setStorageStats(storageRes.data);
// //             if (configRes.data.activeProfile) {
// //                 if (!selectedProfileId) setSelectedProfileId(configRes.data.activeProfile.id);
// //             }
// //         } catch (err) {
// //             console.error("Failed to fetch stats", err);
// //         }
// //     }, [selectedProfileId]);

// //     const fetchProfiles = useCallback(async () => {
// //         try {
// //             const token = getToken();
// //             const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });
// //             setProfiles(res.data || []);
// //         } catch (err) {
// //             console.error("Failed to fetch profiles", err);
// //         }
// //     }, []);

// //     const fetchConfigs = useCallback(async (profileId) => {
// //         if (!profileId) return;
// //         setLoadingConfigs(true);
// //         try {
// //             const token = getToken();
// //             const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs?profile_id=${profileId}`, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });
// //             setConfigs(res.data || []);
// //         } catch (err) {
// //             console.error("Failed to fetch configs", err);
// //         } finally {
// //             setLoadingConfigs(false);
// //         }
// //     }, []);

// //     useEffect(() => {
// //         fetchStats();
// //         fetchProfiles();
// //     }, [fetchStats, fetchProfiles]);

// //     useEffect(() => {
// //         if (selectedProfileId) {
// //             fetchConfigs(selectedProfileId);
// //         }
// //     }, [selectedProfileId, fetchConfigs]);

// //     // --- Profile Handlers ---

// //     const handleActivateProfile = async (id) => {
// //         try {
// //             const token = getToken();
// //             await axios.patch(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/activate`, {}, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });
// //             setMessage(t("admin.settings.profile_activated", "Profile activated successfully"));
// //             fetchStats();
// //             fetchProfiles();
// //             setTimeout(() => setMessage(""), 3000);
// //         } catch (err) {
// //             alert(t("admin.common.error", "Action failed"));
// //         }
// //     };

// //     const handleDeleteProfile = async (id) => {
// //         if (id === 1) return;
// //         if (!window.confirm(t("admin.settings.delete_profile_confirm", "Delete this configuration set and all its variables?"))) return;
// //         try {
// //             const token = getToken();
// //             await axios.delete(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}`, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });
// //             fetchProfiles();
// //             if (selectedProfileId === id) setSelectedProfileId(1);
// //         } catch (err) {
// //             alert(err.response?.data?.message || t("admin.common.error", "Delete failed"));
// //         }
// //     };



// // import React, { useState, useEffect, useCallback, memo } from "react";
// // import axios from "axios";
// // import { useTranslation } from "react-i18next";
// // import { getToken } from "../../utils/auth";
// // import CONFIG from "../../config";
// // import { useNavigate } from "react-router-dom";
// // import BRANDING from "../../branding";

// const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';


// // import React, { useState, useEffect, useCallback, memo } from "react";
// // import axios from "axios";
// // import { useTranslation } from "react-i18next";
// // import { getToken } from "../../utils/auth";
// // import CONFIG from "../../config";
// // import { useNavigate } from "react-router-dom";

// // const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';

// // Deep merge utility function
// const deepMerge = (target, source) => {
//     if (!source) return target;
//     const result = { ...target };
//     Object.keys(source).forEach(key => {
//         if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
//             result[key] = deepMerge(result[key] || {}, source[key]);
//         } else {
//             result[key] = source[key];
//         }
//     });
//     return result;
// };

// const SystemSettingsAdmin = memo(() => {
//     const { t, i18n } = useTranslation();
//     const navigate = useNavigate();

//     const isArabic = i18n.language.startsWith('ar');

//     // Stats State
//     const [configStats, setConfigStats] = useState(null);
//     const [storageStats, setStorageStats] = useState(null);

//     // Profile State
//     const [profiles, setProfiles] = useState([]);
//     const [selectedProfileId, setSelectedProfileId] = useState(null);

//     const [showProfileModal, setShowProfileModal] = useState(false);
//     const [editingProfile, setEditingProfile] = useState(null);
//     const [profileForm, setProfileForm] = useState({
//         name: "",
//         description: "",
//         hostname: "",
//         is_active: 0,
//         branding: {
//             appName: { en: '', ar: '' },
//             contact: { phoneHeader: '', phoneFooter: '', email: '' },
//             colors: {
//                 primary: '',
//                 primaryHover: '',
//                 secondary: '',
//                 accent: '',
//                 bgBody: '',
//                 bgHeader: '',
//                 textHeader: '',
//                 textMain: '',
//                 textMuted: '',
//                 border: '',
//                 glassBg: '',
//                 glassBorder: '',
//                 glassShadow: '',
//                 cardGlassBg: '',
//                 cardGlassBorder: ''
//             },
//             ui: {
//                 buttonRadius: '',
//                 cardRadius: '',
//                 inputRadius: '',
//                 cardShadow: '',
//                 cardPadding: '',
//                 navbarHeight: '',
//                 footerBg: '',
//                 footerText: '',
//                 transitionSpeed: ''
//             },
//             fonts: {
//                 bodyEn: '',
//                 bodyAr: '',
//                 headingEn: '',
//                 headingAr: ''
//             },
//             socialLinks: { facebook: '', instagram: '', whatsapp: '', tiktok: '' },
//             logo: { path: '', alt: '', showText: false },
//             favicon: { path: '' },
//             appleTouchIcon: { path: '' },
//             seo: {
//                 defaultTitle: { en: '', ar: '' },
//                 defaultDescription: { en: '', ar: '' },
//                 pages: {}
//             },
//             compliance: {
//                 enableGlobalConsentBanner: true,
//                 enableEgyptMarketingConsent: true,
//                 enableExplicitDataProcessing: true
//             },
//             homeContent: {
//                 exploreCollections: { en: '', ar: '' },
//                 shopByCategory: { en: '', ar: '' },
//                 eliteSelection: { en: '', ar: '' },
//                 topRatedProducts: { en: '', ar: '' },
//                 viewAllCollection: { en: '', ar: '' },
//                 testimonials: { en: '', ar: '' },
//                 customerReviews: { en: '', ar: '' },
//                 trustBannerTitle: { en: '', ar: '' },
//                 trustFeatures: {
//                     verifiedReviews: { en: '', ar: '' },
//                     qualityGuarantee: { en: '', ar: '' },
//                     easyContact: { en: '', ar: '' }
//                 }
//             }
//         }
//     });

//     // Config State
//     const [configs, setConfigs] = useState([]);
//     const [loadingConfigs, setLoadingConfigs] = useState(false);
//     const [showConfigModal, setShowConfigModal] = useState(false);
//     const [editingConfig, setEditingConfig] = useState(null);
//     const [configForm, setConfigForm] = useState({ config_key: "", config_value: "", description: "", is_active: 1 });

//     const [message, setMessage] = useState("");
//     const [isEditing, setIsEditing] = useState(false);
//     const [syncingProfileId, setSyncingProfileId] = useState(null);
//     const [pullingProfileId, setPullingProfileId] = useState(null);
//     const [syncingTunnelProfileId, setSyncingTunnelProfileId] = useState(null);
//     const [syncingAllUnnamed, setSyncingAllUnnamed] = useState(false);
//     const [syncingCountProfileId, setSyncingCountProfileId] = useState(null);
//     const [syncingVarsProfileId, setSyncingVarsProfileId] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [logoPreview, setLogoPreview] = useState('');

//     // --- Extra Sets Modal State ---
//     const [showExtraSetsModal, setShowExtraSetsModal] = useState(false);
//     const [extraSetsTargetProfile, setExtraSetsTargetProfile] = useState(null);
//     const [extraSetsVariables, setExtraSetsVariables] = useState([{ key: '', value: '', description: '' }]);
//     const [extraSetName, setExtraSetName] = useState('');
//     const [extraSetDescription, setExtraSetDescription] = useState('');
//     const [extraSetDbUrl, setExtraSetDbUrl] = useState('');
//     const [submittingExtraSets, setSubmittingExtraSets] = useState(false);



//     // --- Data Fetching ---

//     const fetchStats = useCallback(async () => {
//         try {
//             const token = getToken();
//             const configRes = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats?profile_id=${selectedProfileId || ''}`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });

//             // Determine the correct profile ID to fetch storage stats for.
//             // If none is selected yet, use the active profile ID from the config response.
//             let targetProfileId = selectedProfileId;
//             if (!targetProfileId && configRes.data?.activeProfile) {
//                 targetProfileId = configRes.data.activeProfile.id;
//                 // Update state for subsequent renders
//                 setSelectedProfileId(targetProfileId);
//             }

//             const storageUrl = targetProfileId
//                 ? `${CONFIG.API_URL}/api/admin/storage/stats?profile_id=${targetProfileId}`
//                 : `${CONFIG.API_URL}/api/admin/storage/stats`;

//             const storageRes = await axios.get(storageUrl, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });

//             setConfigStats(configRes.data);
//             setStorageStats(storageRes.data);
//             // expose master flag for UI conditional fields
//             if (configRes.data && typeof configRes.data.isMaster !== 'undefined') {
//                 setIsMaster(!!configRes.data.isMaster);
//             }
//         } catch (err) {
//             console.error("Failed to fetch stats", err);
//         }
//     }, [selectedProfileId]);

//     // UI: whether the current admin is master (can edit hostnames/branding/db)
//     const [isMaster, setIsMaster] = useState(false);

//     const fetchProfiles = useCallback(async () => {
//         try {
//             const token = getToken();
//             const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setProfiles(res.data || []);
//         } catch (err) {
//             console.error("Failed to fetch profiles", err);
//         }
//     }, []);

//     const fetchConfigs = useCallback(async (profileId) => {
//         if (!profileId) return;
//         setLoadingConfigs(true);
//         try {
//             const token = getToken();
//             const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs?profile_id=${profileId}`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setConfigs(res.data || []);
//         } catch (err) {
//             console.error("Failed to fetch configs", err);
//         } finally {
//             setLoadingConfigs(false);
//         }
//     }, []);

//     const handleRefreshProfileCount = async (id) => {
//         try {
//             setSyncingCountProfileId(id);
//             const token = getToken();
//             const res = await axios.post(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/refresh-count`, {}, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'x-profile-id': id
//                 }
//             });

//             // Update the count in the profiles list
//             setProfiles(prev => prev.map(p =>
//                 p.id === id ? { ...p, product_counts: res.data.count } : p
//             ));

//             setMessage(t("admin.settings.count_refreshed", "Count refreshed!"));
//             setTimeout(() => setMessage(""), 3000);
//         } catch (err) {
//             console.error("Failed to refresh count", err);
//             alert(t("admin.common.failed", "Failed!"));
//         } finally {
//             setSyncingCountProfileId(null);
//         }
//     };

//     useEffect(() => {
//         fetchStats();
//         fetchProfiles();
//     }, [fetchStats, fetchProfiles]);

//     useEffect(() => {
//         if (selectedProfileId) {
//             fetchConfigs(selectedProfileId);
//         }
//     }, [selectedProfileId, fetchConfigs]);

//     // --- Profile Handlers ---

//     const handleActivateProfile = async (id, currentActive) => {
//         try {
//             const token = getToken();
//             const newActive = currentActive ? 0 : 1;
//             await axios.patch(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/activate`, { active: newActive }, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setMessage(newActive ? t("admin.settings.profile_activated", "Profile activated successfully") : t("admin.settings.profile_deactivated", "Profile deactivated successfully"));
//             fetchStats();
//             fetchProfiles();
//             setTimeout(() => setMessage(""), 3000);
//         } catch (err) {
//             alert(t("admin.common.error", "Action failed"));
//         }
//     };

//     const handleDeleteProfile = async (id) => {
//         if (id === MASTER_PROFILE_ID) return;
//         if (!window.confirm(t("admin.settings.delete_profile_confirm", "Delete this configuration set and all its variables?"))) return;
//         try {
//             const token = getToken();
//             await axios.delete(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             fetchProfiles();
//             if (selectedProfileId === id) setSelectedProfileId(MASTER_PROFILE_ID);
//         } catch (err) {
//             alert(err.response?.data?.message || t("admin.common.error", "Delete failed"));
//         }
//     };

//     const handleActivateAllVars = async (id) => {
//         try {
//             setSyncingVarsProfileId(id);
//             const token = getToken();
//             await axios.put(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/activate-vars`, { active: 1 }, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'x-profile-id': id
//                 }
//             });
//             fetchStats();
//             fetchConfigs(id);
//             fetchProfiles();
//         } catch (err) {
//             console.error("Failed to activate variables:", err);
//         } finally {
//             setSyncingVarsProfileId(null);
//         }
//     };

//     const handleSyncProfile = async (id) => {
//         if (syncingProfileId) return;
//         if (!window.confirm(t("admin.settings.sync_profile_confirm", "Initialize and synchronize this domain's database? This will create missing tables and mirror your settings."))) return;

//         try {
//             setSyncingProfileId(id);
//             const token = getToken();
//             const res = await axios.post(`${CONFIG.API_URL}/api/admin/configs/profiles/${id}/sync`, {}, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'x-profile-id': id
//                 }
//             });

//             if (res.data.success) {
//                 setMessage(t("admin.settings.sync_success", "Domain synchronized successfully!"));
//                 setTimeout(() => setMessage(""), 5000);
//             }
//         } catch (err) {
//             console.error("Sync error:", err.response?.data || err);
//             alert(err.response?.data?.message || t("admin.settings.sync_failed", "Synchronization failed"));
//         } finally {
//             setSyncingProfileId(null);
//         }
//     };

//     const handlePullSyncProfile = async (id) => {
//         if (pullingProfileId) return;
//         if (!window.confirm(t("admin.settings.pull_sync_confirm", "Securely save Remote data to Local? This will pull products and users from your live site into this local MariaDB mirror."))) return;

//         try {
//             setPullingProfileId(id);
//             const token = getToken();
//             const res = await axios.post(`${CONFIG.API_URL}/api/admin/profiles/${id}/pull-sync`, {}, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'x-profile-id': id
//                 }
//             });

//             if (res.data.success) {
//                 setMessage(t("admin.settings.pull_sync_success", "Data mirrored to local MariaDB successfully!"));
//                 fetchProfiles(); // Refresh to show new counts
//                 setTimeout(() => setMessage(""), 5000);
//             }
//         } catch (err) {
//             console.error("Pull Sync error:", err.response?.data || err);
//             alert(err.response?.data?.message || t("admin.settings.pull_sync_failed", "Data migration failed"));
//         } finally {
//             setPullingProfileId(null);
//         }
//     };

//     const handleSyncTunnel = async (id) => {
//         if (syncingTunnelProfileId) return;
//         const tunnelUrl = window.prompt(t("admin.settings.enter_tunnel_url", "Enter your new Cloudflare Tunnel URL (e.g. https://example.trycloudflare.com):"));
//         if (!tunnelUrl) return;

//         try {
//             setSyncingTunnelProfileId(id);
//             const token = getToken();
//             const res = await axios.post(`${CONFIG.API_URL}/api/admin/profiles/${id}/sync-tunnel`, { tunnelUrl }, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'x-profile-id': id
//                 }
//             });

//             if (res.data.success) {
//                 setMessage(t("admin.settings.tunnel_sync_success", "Tunnel configuration updated successfully!"));
//                 fetchProfiles();
//                 fetchConfigs(id);
//                 setTimeout(() => setMessage(""), 5000);
//             }
//         } catch (err) {
//             console.error("Tunnel Sync error:", err.response?.data || err);
//             alert(err.response?.data?.message || t("admin.settings.tunnel_sync_failed", "Tunnel sync failed"));
//         } finally {
//             setSyncingTunnelProfileId(null);
//         }
//     };



//     const handleSyncAllUnnamed = async () => {
//         if (syncingAllUnnamed) return;
//         if (!window.confirm(t("admin.settings.sync_all_unnamed_confirm", "Sync all expansion (hostname-less) DBs? This will initialize and mirror each configured DB."))) return;
//         try {
//             setSyncingAllUnnamed(true);
//             const token = getToken();
//             const url = `${CONFIG.API_URL}/api/admin/profiles/sync-unnamed${selectedProfileId ? `?profile_id=${selectedProfileId}` : ''}`;
//             const res = await axios.post(url, {}, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             if (res.data && res.data.ok) {
//                 setMessage(t("admin.settings.sync_all_unnamed_done", "Bulk sync complete — check results in console."));
//                 console.log('Bulk unnamed sync results:', res.data.results || res.data);
//                 setTimeout(() => setMessage(""), 5000);
//             }
//         } catch (err) {
//             console.error('Bulk unnamed sync failed:', err.response?.data || err);
//             alert(err.response?.data?.message || t("admin.settings.sync_failed", "Synchronization failed"));
//         } finally {
//             setSyncingAllUnnamed(false);
//         }
//     };

//     // // Opens the Extra Sets modal for a specific profile card
//     // const handleAddExtraSets = (profile) => {
//     //     setExtraSetsTargetProfile(profile);
//     //     setExtraSetsVariables([{ key: '', value: '', description: '' }]);
//     //     setExtraSetName('');
//     //     setExtraSetDescription('');
//     //     setExtraSetDbUrl('');
//     //     setShowExtraSetsModal(true);
//     // };

//     // // Add a blank variable row
//     // const addExtraVarRow = () =>
//     //     setExtraSetsVariables(prev => [...prev, { key: '', value: '', description: '' }]);

//     // // Remove a variable row
//     // const removeExtraVarRow = (idx) =>
//     //     setExtraSetsVariables(prev => prev.filter((_, i) => i !== idx));

//     // // Update a single field in a variable row
//     // const updateExtraVarRow = (idx, field, val) =>
//     //     setExtraSetsVariables(prev => prev.map((r, i) => i === idx ? { ...r, [field]: val } : r));

//     // // Submits the modal form — targets the specific profile that was clicked
//     // const handleSubmitExtraSets = async () => {
//     //     if (!extraSetsTargetProfile) return;

//     //     // Only send rows that have a non-empty key, and apply Set Name/Desc to the variable description
//     //     const variables = extraSetsVariables.filter(v => v.key.trim()).map(v => {
//     //         let finalDesc = v.description || '';
//     //         if (extraSetName) {
//     //             const prefix = `[${extraSetName}]${extraSetDescription ? ` - ${extraSetDescription}` : ''}`;
//     //             finalDesc = finalDesc ? `${prefix}: ${finalDesc}` : prefix;
//     //         }
//     //         return {
//     //             ...v,
//     //             description: finalDesc
//     //         };
//     //     });

//     //     try {
//     //         setSubmittingExtraSets(true);
//     //         const token = getToken();

//     //         // 1. If a Database URL was provided, update the domain's profile first
//     //         if (extraSetDbUrl && extraSetDbUrl.trim() !== '') {
//     //             // PUT /api/admin/configs/profiles/:id updates the profile
//     //             // We send a partial update. The backend should handle it.
//     //             try {
//     //                 await axios.put(`${CONFIG.API_URL}/api/admin/configs/profiles/${extraSetsTargetProfile.id}`,
//     //                     { database_url: extraSetDbUrl.trim() },
//     //                     { headers: { Authorization: `Bearer ${token}` } }
//     //                 );
//     //             } catch (dbErr) {
//     //                 console.warn("Failed to update database URL before sync:", dbErr);
//     //                 // Proceed anyway, the user might just be updating variables
//     //             }
//     //         }

//     //         // 2. Add extra domain sets and sync
//     //         const res = await axios.post(
//     //             `${CONFIG.API_URL}/api/admin/extra-domain-sets`,
//     //             { extraProfileIds: [extraSetsTargetProfile.id], variables },
//     //             { headers: { Authorization: `Bearer ${token}` } }
//     //         );

//     //         if (res.data && res.data.ok) {
//     //             const results = res.data.results || [];
//     //             const successCount = results.filter(r => r.success).length;
//     //             const failCount = results.filter(r => !r.success).length;
//     //             setShowExtraSetsModal(false);
//     //             setMessage(
//     //                 t(
//     //                     "admin.settings.add_extra_sets_success",
//     //                     `Extra sets added to "${extraSetsTargetProfile.name}" — ${successCount > 0 ? 'Synced' : ''}${failCount > 0 ? `, ${failCount} failed` : ''}.`
//     //                 )
//     //             );
//     //             if (failCount > 0) {
//     //                 const summary = results
//     //                     .map(r => `${r.name || r.id}: ${r.success ? '✅' : `❌ ${r.error || 'failed'}`}`)
//     //                     .join('\n');
//     //                 alert(`Sync completed with issues:\n\n${summary}`);
//     //             }
//     //             fetchProfiles();
//     //             fetchStats();
//     //             if (selectedProfileId === extraSetsTargetProfile.id) {
//     //                 fetchConfigs(selectedProfileId);
//     //             }
//     //             setTimeout(() => setMessage(""), 6000);
//     //         }
//     //     } catch (err) {
//     //         console.error("Add extra sets error:", err.response?.data || err);
//     //         alert(err.response?.data?.message || t("admin.settings.add_extra_sets_failed", "Failed to add extra sets."));
//     //     } finally {
//     //         setSubmittingExtraSets(false);
//     //     }
//     // };

//     // Opens the Extra Sets modal for a specific profile card
//     const handleAddExtraSets = (profile) => {
//         setExtraSetsTargetProfile(profile);
//         setExtraSetsVariables([{ key: '', value: '', description: '' }]);
//         setExtraSetName('');
//         setExtraSetDescription('');
//         setExtraSetDbUrl('');
//         setShowExtraSetsModal(true);
//     };

//     // Add a blank variable row
//     const addExtraVarRow = () =>
//         setExtraSetsVariables(prev => [...prev, { key: '', value: '', description: '' }]);

//     // Remove a variable row
//     const removeExtraVarRow = (idx) =>
//         setExtraSetsVariables(prev => prev.filter((_, i) => i !== idx));

//     // Update a single field in a variable row
//     const updateExtraVarRow = (idx, field, val) =>
//         setExtraSetsVariables(prev => prev.map((r, i) => i === idx ? { ...r, [field]: val } : r));

//     // Submits the modal form — targets the specific profile that was clicked
//     const handleSubmitExtraSets = async () => {
//         if (!extraSetsTargetProfile) return;

//         // Only send rows that have a non-empty key, and apply Set Name/Desc to the variable description
//         const variables = extraSetsVariables.filter(v => v.key.trim()).map(v => {
//             let finalDesc = v.description || '';
//             if (extraSetName) {
//                 const prefix = `[${extraSetName}]${extraSetDescription ? ` - ${extraSetDescription}` : ''}`;
//                 finalDesc = finalDesc ? `${prefix}: ${finalDesc}` : prefix;
//             }
//             return {
//                 ...v,
//                 description: finalDesc
//             };
//         });

//         try {
//             setSubmittingExtraSets(true);
//             const token = getToken();

//             // 1. Send to backend to create a completely new profile (Extra Set) that targets this domain
//             const res = await axios.post(
//                 `${CONFIG.API_URL}/api/admin/extra-domain-sets`,
//                 {
//                     targetProfileId: extraSetsTargetProfile.id,
//                     variables,
//                     setName: extraSetName.trim(),
//                     setDescription: extraSetDescription.trim(),
//                     databaseUrl: extraSetDbUrl.trim()
//                 },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             if (res.data && res.data.ok) {
//                 const results = res.data.results || [];
//                 const successCount = results.filter(r => r.success).length;
//                 const failCount = results.filter(r => !r.success).length;
//                 setShowExtraSetsModal(false);
//                 setMessage(
//                     t(
//                         "admin.settings.add_extra_sets_success",
//                         `Extra sets added to "${extraSetsTargetProfile.name}" — ${successCount > 0 ? 'Synced' : ''}${failCount > 0 ? `, ${failCount} failed` : ''}.`
//                     )
//                 );
//                 if (failCount > 0) {
//                     const summary = results
//                         .map(r => `${r.name || r.id}: ${r.success ? '✅' : `❌ ${r.error || 'failed'}`}`)
//                         .join('\n');
//                     alert(`Sync completed with issues:\n\n${summary}`);
//                 }
//                 fetchProfiles();
//                 fetchStats();
//                 if (selectedProfileId === extraSetsTargetProfile.id) {
//                     fetchConfigs(selectedProfileId);
//                 }
//                 setTimeout(() => setMessage(""), 6000);
//             }
//         } catch (err) {
//             console.error("Add extra sets error:", err.response?.data || err);
//             alert(err.response?.data?.message || t("admin.settings.add_extra_sets_failed", "Failed to add extra sets."));
//         } finally {
//             setSubmittingExtraSets(false);
//         }
//     };


//     const handleSaveProfile = async (e) => {
//         e.preventDefault();
//         try {
//             const token = getToken();
//             const authHeaders = { Authorization: `Bearer ${token}` };
//             // Send the profileForm as is, it now contains a structured branding object
//             const payload = { ...profileForm };

//             let savedProfileId;
//             if (editingProfile) {
//                 await axios.put(`${CONFIG.API_URL}/api/admin/configs/profiles/${editingProfile.id}`, payload, {
//                     headers: authHeaders
//                 });
//                 savedProfileId = editingProfile.id;
//             } else {
//                 const res = await axios.post(`${CONFIG.API_URL}/api/admin/configs/profiles`, payload, {
//                     headers: authHeaders
//                 });
//                 savedProfileId = res.data?.id;
//             }

//             // Safety-net: also save branding via the dedicated endpoint so that
//             // hostname profile owners (who may not be the DB owner_id) always
//             // persist their branding even if the embedded branding in the PUT
//             // body was skipped by a server-side guard.
//             if (savedProfileId && profileForm.branding) {
//                 try {
//                     await axios.put(
//                         `${CONFIG.API_URL}/api/admin/configs/profiles/${savedProfileId}/branding`,
//                         profileForm.branding,
//                         { headers: authHeaders }
//                     );
//                 } catch (brandingErr) {
//                     // Non-fatal: log but don't block the rest of the save flow
//                     console.warn('[handleSaveProfile] Secondary branding save failed:', brandingErr?.response?.data?.message || brandingErr);
//                 }
//             }

//             setShowProfileModal(false);
//             setEditingProfile(null);
//             fetchProfiles();
//             fetchStats();
//             if (selectedProfileId) fetchConfigs(selectedProfileId);
//         } catch (err) {
//             alert(t("admin.common.error", "Save failed"));
//         }
//     };

//     const testDatabaseConnection = async () => {
//         if (!profileForm.database_url) return alert(t('admin.settings.enter_db_url', 'Enter a Database URL to test'));
//         try {
//             const token = getToken();
//             const id = editingProfile?.id || 0; // 0 -> server will allow admin testing for new profiles
//             const res = await axios.post(`${CONFIG.API_URL}/api/profiles/${id}/test-db`, { database_url: profileForm.database_url }, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             if (res.data && res.data.ok) alert(t('admin.settings.db_test_ok', 'Connection successful'));
//             else alert(t('admin.settings.db_test_failed', 'Connection failed'));
//         } catch (err) {
//             alert(err.response?.data?.message || t('admin.settings.db_test_failed', 'Connection failed'));
//         }
//     };

//     const uploadBrandingFile = async (file, field = 'logo') => {
//         if (!file) return;
//         try {
//             const token = getToken();
//             const fd = new FormData();
//             fd.append('file', file);
//             fd.append('folder', 'branding');
//             const res = await axios.post(`${CONFIG.API_URL}/api/storage/upload`, fd, {
//                 headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
//             });
//             if (res.data && res.data.url) {
//                 const url = res.data.url;
//                 setProfileForm(prev => {
//                     const updated = { ...prev.branding };
//                     if (field === 'logo') {
//                         updated.logo = { ...(updated.logo || {}), path: url };
//                         updated.logo_url = url;
//                         setLogoPreview(url);
//                     } else if (field === 'favicon') {
//                         updated.favicon = { path: url };
//                     } else if (field === 'appleTouchIcon') {
//                         updated.appleTouchIcon = { path: url };
//                     }
//                     return { ...prev, branding: updated };
//                 });
//                 setMessage(t('admin.settings.file_uploaded', 'File uploaded'));
//                 setTimeout(() => setMessage(''), 2500);
//             }
//         } catch (err) {
//             alert(err.response?.data?.message || t('admin.settings.upload_failed', 'Upload failed'));
//         }
//     };

//     const openProfileModal = async (profile) => {
//         setIsEditing(!!profile);
//         if (!profile) {
//             setEditingProfile(null);
//             setProfileForm({
//                 name: "",
//                 description: "",
//                 hostname: "",
//                 is_active: 1,
//                 branding: {
//                     appName: { en: '', ar: '' },
//                     seo: {
//                         defaultTitle: { en: '', ar: '' },
//                         defaultDescription: { en: '', ar: '' },
//                         sellingPoints: { en: [], ar: [] },
//                         pages: {},
//                         customHeadTags: ''
//                     },
//                     colors: {
//                         primary: '#0ea5a4',
//                         bgBody: '#FAFAFA',
//                         secondary: '',
//                         accent: '',
//                         textMain: '',
//                         textMuted: '',
//                         bgHeader: '',
//                         textHeader: '',
//                         border: '',
//                         glassBg: 'rgba(255, 255, 255, 0.03)',
//                         glassBorder: 'rgba(255, 255, 255, 0.05)',
//                         glassShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
//                         cardGlassBg: 'rgba(255, 255, 255, 0.05)',
//                         cardGlassBorder: 'rgba(255, 255, 255, 0.1)'
//                     },
//                     ui: {
//                         buttonRadius: '',
//                         cardRadius: '',
//                         inputRadius: '',
//                         cardShadow: '',
//                         cardPadding: '',
//                         navbarHeight: '',
//                         footerBg: '',
//                         footerText: '',
//                         transitionSpeed: ''
//                     },
//                     fonts: {
//                         bodyEn: '',
//                         bodyAr: '',
//                         headingEn: '',
//                         headingAr: ''
//                     },
//                     logo: { path: '', alt: '' },
//                     favicon: { path: '' },
//                     appleTouchIcon: { path: '' },
//                     footerDescription: { en: '', ar: '' },
//                     defaultLanguage: 'en',
//                     features: {
//                         cart: true,
//                         wishlist: true,
//                         comparison: true,
//                         userPortal: true,
//                         payments: true
//                     },
//                     compliance: {
//                         enableGlobalConsentBanner: true,
//                         enableEgyptMarketingConsent: true,
//                         enableExplicitDataProcessing: true
//                     },
//                     contact: { phoneHeader: '', phoneFooter: '', email: '' },
//                     socialLinks: { facebook: '', instagram: '', whatsapp: '', tiktok: '' },
//                     homeContent: {
//                         exploreCollections: { en: '', ar: '' },
//                         shopByCategory: { en: '', ar: '' },
//                         eliteSelection: { en: '', ar: '' },
//                         topRatedProducts: { en: '', ar: '' },
//                         viewAllCollection: { en: '', ar: '' },
//                         testimonials: { en: '', ar: '' },
//                         customerReviews: { en: '', ar: '' },
//                         trustBannerTitle: { en: '', ar: '' },
//                         trustFeatures: {
//                             verifiedReviews: { en: '', ar: '' },
//                             qualityGuarantee: { en: '', ar: '' },
//                             easyContact: { en: '', ar: '' }
//                         }
//                     },
//                     checkout: {
//                         gatewayKeys: { stripe_publishable_key: '', stripe_secret_key: '', paypal_client_id: '', paypal_client_secret: '' },
//                         receiptWhatsApp: '',
//                         paymentMethods: {
//                             cash_on_delivery: { enabled: true, instructions: 'Pay when your order arrives at your door.' },
//                             bank_transfer: { enabled: true, accountNumber: '', bankName: '', instructions: 'Transfer the total to our bank account and send the receipt to our WhatsApp.' },
//                             vodafone_cash: { enabled: false, accountNumber: '', instructions: 'Send the amount to our Vodafone Cash number and send the receipt.' },
//                             instapay: { enabled: false, accountNumber: '', instructions: 'Transfer via InstaPay to our registered account.' },
//                             fawry: { enabled: false, accountNumber: '', instructions: 'Pay at any Fawry outlet using our reference number.' },
//                             paypal: { enabled: false, instructions: 'You will be redirected to PayPal to complete payment.' },
//                             stripe_card: { enabled: false, instructions: 'Secure card payment via Stripe.' }
//                         }
//                     },
//                     filterPlaceholders: {
//                         category: {
//                             label: { en: 'Category', ar: 'الفئة' },
//                             icon: 'category-icon',
//                             SelectTypeAndOption: { en: 'All Categories', ar: 'جميع الفئات' }
//                         },
//                         material: {
//                             label: { en: 'Material', ar: 'المواد' },
//                             icon: 'material-icon',
//                             selectTypeAndOption: { en: 'All Materials', ar: 'جميع المواد' }
//                         },
//                         dimensions: {
//                             label: { en: 'Dimensions', ar: 'المقاسات' },
//                             icon: 'dimensions-icon',
//                             SelectTypeAndOption: { en: 'All Dimensions', ar: 'جميع المقاسات' }
//                         }
//                     }
//                 }
//             });
//             setLogoPreview('');
//             setShowProfileModal(true);
//             return;
//         }

//         // -----------------------------------------------------------------------
//         // Fetch the profile's core data AND branding independently so that a
//         // 403 on the core-profile endpoint (e.g. when owner_id lookup hasn't
//         // propagated yet) does NOT wipe out the branding form fields.
//         // Both requests run in parallel; failures fall back gracefully.
//         // -----------------------------------------------------------------------
//         const token = getToken();
//         const authHeaders = { Authorization: `Bearer ${token}` };

//         // Empty branding skeleton – used as the merge base
//         const emptyBranding = {
//             appName: { en: '', ar: '' },
//             seo: {
//                 defaultTitle: { en: '', ar: '' },
//                 defaultDescription: { en: '', ar: '' },
//                 sellingPoints: { en: [], ar: [] },
//                 pages: {},
//                 customHeadTags: ''
//             },
//             colors: {
//                 primary: '#0ea5a4', primaryHover: '', secondary: '', accent: '',
//                 bgBody: '', bgHeader: '', textMain: '', textMuted: '', textHeader: '', border: '',
//                 glassBg: 'rgba(255,255,255,0.03)', glassBorder: 'rgba(255,255,255,0.05)',
//                 glassShadow: '0 8px 32px 0 rgba(0,0,0,0.37)',
//                 cardGlassBg: 'rgba(255,255,255,0.05)', cardGlassBorder: 'rgba(255,255,255,0.1)'
//             },
//             ui: {
//                 buttonRadius: '', cardRadius: '', inputRadius: '', cardShadow: '',
//                 cardPadding: '', navbarHeight: '', footerBg: '', footerText: '', transitionSpeed: ''
//             },
//             fonts: { bodyEn: '', bodyAr: '', headingEn: '', headingAr: '' },
//             logo: { path: '' },
//             favicon: { path: '' },
//             appleTouchIcon: { path: '' },
//             footerDescription: { en: '', ar: '' },
//             defaultLanguage: 'en',
//             features: { cart: true, wishlist: true, comparison: true, userPortal: true, payments: true },
//             compliance: {
//                 enableGlobalConsentBanner: true,
//                 enableEgyptMarketingConsent: true,
//                 enableExplicitDataProcessing: true
//             },
//             contact: { phoneHeader: '', phoneFooter: '', email: '' },
//             socialLinks: { facebook: '', instagram: '', whatsapp: '', tiktok: '' },
//             homeContent: {
//                 exploreCollections: { en: '', ar: '' },
//                 shopByCategory: { en: '', ar: '' },
//                 eliteSelection: { en: '', ar: '' },
//                 topRatedProducts: { en: '', ar: '' },
//                 viewAllCollection: { en: '', ar: '' },
//                 testimonials: { en: '', ar: '' },
//                 customerReviews: { en: '', ar: '' },
//                 trustBannerTitle: { en: '', ar: '' },
//                 trustFeatures: {
//                     verifiedReviews: { en: '', ar: '' },
//                     qualityGuarantee: { en: '', ar: '' },
//                     easyContact: { en: '', ar: '' }
//                 }
//             },
//             checkout: {
//                 gatewayKeys: { stripe_publishable_key: '', stripe_secret_key: '', paypal_client_id: '', paypal_client_secret: '' },
//                 receiptWhatsApp: '',
//                 paymentMethods: {
//                     cash_on_delivery: { enabled: true, instructions: 'Pay when your order arrives at your door.' },
//                     bank_transfer: { enabled: true, accountNumber: '', bankName: '', instructions: 'Transfer the total to our bank account and send the receipt to our WhatsApp.' },
//                     vodafone_cash: { enabled: false, accountNumber: '', instructions: 'Send the amount to our Vodafone Cash number and send the receipt.' },
//                     instapay: { enabled: false, accountNumber: '', instructions: 'Transfer via InstaPay to our registered account.' },
//                     fawry: { enabled: false, accountNumber: '', instructions: 'Pay at any Fawry outlet using our reference number.' },
//                     paypal: { enabled: false, instructions: 'You will be redirected to PayPal to complete payment.' },
//                     stripe_card: { enabled: false, instructions: 'Secure card payment via Stripe.' }
//                 }
//             },
//             filterPlaceholders: {
//                 category: {
//                     label: { en: 'Category', ar: 'الفئة' },
//                     icon: 'category-icon',
//                     selectTypeAndOption: { en: 'All Categories', ar: 'جميع الفئات' }
//                 },
//                 material: {
//                     label: { en: 'Material', ar: 'المواد' },
//                     icon: 'material-icon',
//                     selectTypeAndOption: { en: 'All Materials', ar: 'جميع المواد' }
//                 },
//                 dimensions: {
//                     label: { en: 'Dimensions', ar: 'المقاسات' },
//                     icon: 'dimensions-icon',
//                     selectTypeAndOption: { en: 'All Dimensions', ar: 'جميع المقاسات' }
//                 }
//             }
//         };

//         // Run both fetches in parallel; capture individual results/errors
//         const [coreResult, brandingResult] = await Promise.allSettled([
//             axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles/${profile.id}`, { headers: authHeaders }),
//             axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles/${profile.id}/branding`, { headers: authHeaders })
//         ]);

//         // --- Core profile data ---
//         // Falls back to the profile object from the list (already has name/hostname/etc.)
//         const core = coreResult.status === 'fulfilled'
//             ? (coreResult.value?.data || {})
//             : {};

//         if (coreResult.status === 'rejected') {
//             console.warn('[openProfileModal] Core profile fetch failed, using list data as fallback:', coreResult.reason?.response?.data?.message || coreResult.reason);
//         }

//         const base = {
//             name: core.name ?? profile.name ?? '',
//             description: core.description ?? profile.description ?? '',
//             hostname: core.hostname ?? profile.hostname ?? '',
//             is_active: core.is_active ?? profile.is_active ?? 0,
//             database_url: core.database_url ?? '',
//             branding: { ...emptyBranding }
//         };

//         // --- Branding data ---
//         if (brandingResult.status === 'fulfilled') {
//             const bData = brandingResult.value?.data;
//             if (bData && Object.keys(bData).length > 0) {
//                 base.branding = deepMerge(emptyBranding, bData);
//                 const logoPath = bData.logo?.path || bData.logo_url || '';
//                 if (logoPath) setLogoPreview(logoPath);
//             }
//         } else {
//             console.warn('[openProfileModal] Branding fetch failed:', brandingResult.reason?.response?.data?.message || brandingResult.reason);
//         }

//         setEditingProfile(profile);
//         setProfileForm(base);
//         setShowProfileModal(true);
//     };

//     // --- Config Handlers ---

//     const handleSaveConfig = async (e) => {
//         e.preventDefault();
//         try {
//             const token = getToken();
//             const payload = { ...configForm, profile_id: selectedProfileId };
//             if (editingConfig) {
//                 await axios.put(`${CONFIG.API_URL}/api/admin/configs/${editingConfig.id}`, payload, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//             } else {
//                 await axios.post(`${CONFIG.API_URL}/api/admin/configs`, payload, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//             }
//             setShowConfigModal(false);
//             setEditingConfig(null);
//             fetchConfigs(selectedProfileId);
//             fetchStats();
//         } catch (err) {
//             alert(t("admin.common.error", "Save failed"));
//         }
//     };

//     const handleToggleAllVariables = async (active) => {
//         if (!selectedProfileId) return;
//         const actionStr = active ? t("admin.settings.enable", "enable") : t("admin.settings.disable", "disable");
//         if (!window.confirm(t("admin.settings.bulk_toggle_confirm", "Are you sure you want to {{action}} all variables for this set?", { action: actionStr }))) return;

//         try {
//             setSyncingVarsProfileId(selectedProfileId);
//             const token = getToken();
//             await axios.patch(`${CONFIG.API_URL}/api/admin/configs/profiles/${selectedProfileId}/variables/toggle-all`, { active: active ? 1 : 0 }, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'x-profile-id': selectedProfileId
//                 }
//             });
//             setMessage(t("admin.settings.bulk_toggle_success", `All variables ${active ? 'enabled' : 'disabled'} successfully`));
//             fetchConfigs(selectedProfileId);
//             fetchStats();
//             setTimeout(() => setMessage(""), 3000);
//         } catch (err) {
//             alert(err.response?.data?.message || t("admin.common.error", "Action failed"));
//         } finally {
//             setSyncingVarsProfileId(null);
//         }
//     };

//     const handleDeleteConfig = async (id) => {
//         if (!window.confirm(t("admin.settings.delete_config_confirm", "Delete this variable?"))) return;
//         try {
//             const token = getToken();
//             await axios.delete(`${CONFIG.API_URL}/api/admin/configs/${id}`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             fetchConfigs(selectedProfileId);
//             fetchStats();
//         } catch (err) {
//             alert(t("admin.common.error", "Delete failed"));
//         }
//     };

//     const filteredConfigs = configs.filter(c =>
//         c.config_key.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         (c.description && c.description.toLowerCase().includes(searchQuery.toLowerCase()))
//     );

//     const getProgressColor = (percent) => {
//         if (percent >= 90) return 'bg-red-500';
//         if (percent >= 75) return 'bg-amber-500';
//         return 'bg-green-500';
//     };

//     return (
//         <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
//             {/* Header */}
//             <div className="flex flex-wrap justify-center md:justify-between items-start gap-4 md:gap-0 mb-12">
//                 <div>
//                     <h2 className="text-4xl font-black text-gray-900 tracking-tight">{t("admin.settings.title", "System Settings")}</h2>
//                     <p className="text-gray-500 font-medium mt-2">{t("admin.settings.subtitle", "Unified dashboard for profiles, configurations, and system health.")}</p>
//                 </div>
//                 <button onClick={() => navigate("/admin")} className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all">
//                     <span className={`inline-block transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
//                     {t('admin.common.back', 'Back')}
//                 </button>
//             </div>

//             {/* Stats Grid */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
//                 {/* Active Profile Status */}
//                 <div
//                     style={{
//                         background: isMaster ? BRANDING.colors.glassBg : 'rgba(var(--brand-primary-rgb), 0.05)',
//                         backdropFilter: isMaster ? 'blur(10px)' : 'none',
//                         borderColor: isMaster ? BRANDING.colors.glassBorder : 'rgba(var(--brand-primary-rgb), 0.1)',
//                         boxShadow: isMaster ? BRANDING.colors.glassShadow : 'none'
//                     }}
//                     className="p-6 rounded-[30px] border relative overflow-hidden group transition-all"
//                 >
//                     <div className="relative z-10">
//                         <div className="flex justify-between items-start">
//                             <span className="text-[10px] font-black uppercase tracking-widest text-brand-primary/60">{t("admin.settings.active_profile", "Active profile")}</span>
//                             <span className="text-[10px] font-black text-brand-primary bg-white/80 backdrop-blur-md px-2 py-0.5 rounded-full shadow-sm border border-brand-primary/10 font-mono">
//                                 <i className="fas fa-globe mr-1"></i> {configStats?.hostname || window.location.hostname}
//                             </span>
//                         </div>
//                         <div className="text-2xl font-black text-gray-900 mt-1">{configStats?.activeProfile?.name || "None"}</div>
//                         <div className="flex items-center gap-2 mt-2">
//                             <span className={`w-2 h-2 rounded-full ${configStats?.activeConfigs > 0 ? 'bg-green-500 animate-pulse' : 'bg-amber-500'}`}></span>
//                             <span className={`text-xs font-bold uppercase tracking-tighter ${configStats?.activeConfigs > 0 ? 'text-green-600' : 'text-amber-600'}`}>
//                                 {configStats?.activeConfigs || 0} / {configStats?.activeProfileTotalConfigs || 0} {t("admin.settings.variables", "Variables Live")}
//                             </span>
//                         </div>
//                     </div>
//                     <i className="fas fa-layer-group absolute bottom-[-10px] right-[-10px] text-5xl text-brand-primary/5 group-hover:scale-110 transition-transform"></i>
//                 </div>

//                 {/* Storage Health */}
//                 <div className="bg-gray-50 p-6 rounded-[30px] border border-gray-100 relative overflow-hidden group">
//                     <div className="relative z-10">
//                         <div className="flex justify-between items-start">
//                             <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
//                                 {t("admin.settings.storage_usage", "Storage Usage")}
//                                 {selectedProfileId && typeof profiles !== 'undefined' ? ` - ${profiles.find(p => p.id === selectedProfileId)?.name || ''}` : ''}
//                             </span>
//                             <span className="text-[10px] font-black text-gray-900 bg-white px-2 py-0.5 rounded-full shadow-sm">{storageStats?.provider?.toUpperCase()}</span>
//                         </div>
//                         <div className="flex items-end gap-2 mt-1">
//                             <div className="text-2xl font-black text-gray-900">{storageStats?.usagePercent}%</div>
//                             <div className="text-[10px] font-bold text-gray-400 mb-1">{storageStats?.providers?.[storageStats?.provider]?.sizeMB || 0} MB / {storageStats?.limit} MB</div>
//                         </div>
//                         <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2 overflow-hidden">
//                             <div className={`h-full ${getProgressColor(storageStats?.usagePercent)} transition-all duration-1000`} style={{ width: `${storageStats?.usagePercent}%` }}></div>
//                         </div>

//                         {/* Breakdown per account (if multiple) */}
//                         <div className="mt-4 space-y-2">
//                             {Object.entries(storageStats?.providers || {}).map(([p, data]) => {
//                                 if (data.accounts && Object.keys(data.accounts).length > 1) {
//                                     return (
//                                         <div key={p} className="text-[9px] font-black uppercase text-gray-400 pt-2 border-t border-gray-100 flex items-center justify-between">
//                                             <span>{p} Accounts</span>
//                                             <span>{data.sizeMB} MB Total</span>
//                                         </div>
//                                     );
//                                 }
//                                 return null;
//                             })}
//                         </div>

//                         <div className="mt-4 pt-4 border-t border-gray-100/50">
//                             <div className="flex justify-between items-center mb-1">
//                                 <span className="text-[9px] font-black uppercase tracking-tight text-gray-400">{t("admin.settings.db_size", "Database Size")}</span>
//                                 <span className="text-[10px] font-black text-gray-900">{storageStats?.databaseSizeMB || 0} MB</span>
//                             </div>
//                         </div>

//                         <div className="mt-2 flex flex-col gap-1.5 overflow-y-auto max-h-[120px] pr-2 custom-scrollbar">
//                             {Object.entries(storageStats?.providers || {}).map(([p, data]) => {
//                                 if (data.sizeMB <= 0) return null;

//                                 // Show separate accounts/buckets if they exist
//                                 if (data.accounts && Object.keys(data.accounts).length > 0) {
//                                     return Object.entries(data.accounts).map(([accName, accData]) => {
//                                         const isMainActive = (p === storageStats?.provider && accName === storageStats?.activeAccount);
//                                         const isOtherActive = (accName === storageStats?.activeAccount); // For other providers

//                                         return (
//                                             <div key={accName} className={`flex items-center justify-between p-2 rounded-xl border transition-all ${isMainActive || (p !== 'cloudinary' && isOtherActive) ? 'bg-brand-primary/10 text-brand-primary border-brand-primary/20' : 'bg-white text-gray-400 border-gray-100'}`} title={`${accData.sizeMB} MB on ${accName}`}>
//                                                 <div className="flex items-center gap-2">
//                                                     <i className={`fas ${p === 'cloudinary' ? 'fa-cloud' : p === 'r2' ? 'fa-archive' : 'fa-database'} text-[10px]`}></i>
//                                                     <span className="text-[10px] font-black uppercase tracking-tight truncate max-w-[100px]">{accName}</span>
//                                                     {isMainActive && <span className="bg-brand-primary text-white text-[8px] px-1.5 py-0.5 rounded-full uppercase ml-1">Live</span>}
//                                                 </div>
//                                                 <span className="text-[10px] font-black">{accData.sizeMB} MB</span>
//                                             </div>
//                                         );
//                                     });
//                                 }

//                                 return (
//                                     <div key={p} className={`flex items-center justify-between p-2 rounded-xl border transition-all ${p === storageStats?.provider ? 'bg-brand-primary/10 text-brand-primary border-brand-primary/20' : 'bg-white text-gray-400 border-gray-100'}`} title={`${data.sizeMB} MB on ${p}`}>
//                                         <div className="flex items-center gap-2">
//                                             <i className="fas fa-hdd text-[10px]"></i>
//                                             <span className="text-[10px] font-black uppercase tracking-tight">{p}</span>
//                                         </div>
//                                         <span className="text-[10px] font-black">{data.sizeMB} MB</span>
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     </div>
//                     <i className="fas fa-database absolute bottom-[-10px] right-[-10px] text-5xl text-gray-100 group-hover:scale-110 transition-transform"></i>
//                 </div>

//                 {/* System Stats (Now Profile Stats) */}
//                 <div className="bg-gray-50 p-6 rounded-[30px] border border-gray-100 relative overflow-hidden group">
//                     <div className="relative z-10">
//                         <div className="flex justify-between items-start">
//                             <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
//                                 {t("admin.settings.quick_stats", "Quick Stats")}
//                                 {selectedProfileId && typeof profiles !== 'undefined' ? (
//                                     <span className="text-brand-primary ml-1">
//                                         (Set: {profiles.find(p => p.id === selectedProfileId)?.name || ''})
//                                     </span>
//                                 ) : ''}
//                             </span>
//                             <button onClick={() => { fetchStats(); fetchProfiles(); }} className="text-gray-400 hover:text-brand-primary transition-colors">
//                                 <i className="fas fa-sync-alt text-[10px]"></i>
//                             </button>
//                         </div>
//                         <div className="grid grid-cols-2 gap-4 mt-2">
//                             <div>
//                                 <div className="text-xl font-black text-gray-900">{storageStats?.active?.totalFiles || 0}</div>
//                                 <div className="text-[9px] font-bold text-gray-400 uppercase tracking-tighter">{t("admin.settings.total_media", "Media Files")}</div>
//                             </div>
//                             <div>
//                                 <div className="flex items-center gap-2">
//                                     <div className="text-xl font-black text-gray-900">
//                                         {configStats?.activeConfigs || 0}
//                                         <span className="text-xs text-gray-400 ml-1">/ {configStats?.activeProfileTotalConfigs || 0}</span>
//                                     </div>
//                                     {(configStats?.activeConfigs < configStats?.activeProfileTotalConfigs) && (
//                                         <button
//                                             onClick={() => handleActivateAllVars(selectedProfileId)}
//                                             className={`text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full border transition-all ${syncingProfileId === selectedProfileId ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed' : 'bg-brand-primary/10 text-brand-primary border-brand-primary/20 hover:bg-brand-primary hover:text-white'}`}
//                                             disabled={syncingProfileId === selectedProfileId}
//                                         >
//                                             {syncingProfileId === selectedProfileId ? <i className="fas fa-spinner fa-spin mr-1"></i> : <i className="fas fa-bolt mr-1"></i>}
//                                             {t("admin.settings.activate_all", "Activate")}
//                                         </button>
//                                     )}
//                                 </div>
//                                 <div className="text-[9px] font-bold text-gray-400 uppercase tracking-tighter">{t("admin.settings.active_set_vars", "Set Variables")}</div>
//                             </div>
//                         </div>
//                     </div>
//                     <i className="fas fa-bolt absolute bottom-[-10px] right-[-10px] text-5xl text-gray-100 group-hover:scale-110 transition-transform"></i>
//                 </div>
//             </div>

//             {/* Profile Selection */}
//             <div className="mb-12">
//                 <div className="flex justify-between items-center mb-6">
//                     <h3 className="text-xs font-black uppercase tracking-[3px] text-gray-400">{t("admin.settings.configuration_sets", "Configuration Sets")}</h3>
//                     <div className="flex gap-2">
//                         <button
//                             onClick={() => { openProfileModal(null); }}
//                             className="bg-gray-900 text-white px-4 py-2 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-black transition-all"
//                         >
//                             <i className="fas fa-plus mr-1"></i> {t("admin.settings.new_set", "Add New Set")}
//                         </button>
//                         <button
//                             onClick={() => handleSyncAllUnnamed()}
//                             className={`bg-white text-gray-600 border px-4 py-2 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-50 transition-all flex items-center gap-2 ${syncingAllUnnamed ? 'opacity-70 cursor-wait' : ''}`}
//                             disabled={syncingAllUnnamed}
//                             title={t("admin.settings.sync_all_unnamed", "Sync All Unnamed DBs")}
//                         >
//                             {syncingAllUnnamed ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-cloud-upload-alt"></i>}
//                             <span className="text-[11px]">{t("admin.settings.sync_all_unnamed_btn", "Sync Unnamed")}</span>
//                         </button>
//                     </div>
//                 </div>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//                     {profiles.map(p => (
//                         <div
//                             key={p.id}
//                             onClick={() => setSelectedProfileId(p.id)}
//                             style={{
//                                 background: selectedProfileId === p.id && isMaster ? BRANDING.colors.cardGlassBg : p.id === selectedProfileId ? 'rgba(var(--brand-primary-rgb), 0.05)' : 'white',
//                                 borderColor: selectedProfileId === p.id && isMaster ? BRANDING.colors.cardGlassBorder : selectedProfileId === p.id ? 'var(--brand-primary)' : '#f3f4f6',
//                                 backdropFilter: isMaster ? 'blur(8px)' : 'none',
//                                 boxShadow: selectedProfileId === p.id && isMaster ? BRANDING.colors.glassShadow : 'none'
//                             }}
//                             className={`p-5 rounded-[25px] border cursor-pointer transition-all ${selectedProfileId === p.id ? 'ring-4 ring-brand-primary/5' : 'hover:border-gray-200'}`}
//                         >
//                             <div className="flex flex-wrap gap-2 items-start mb-2">
//                                 <h4 className="font-black text-gray-900 truncate pr-2 flex-1">{p.name}</h4>
//                                 <div className="flex flex-col gap-1 items-end">
//                                     {p.is_active === 1 && (
//                                         <div className="flex flex-col items-end gap-1">
//                                             <span className="bg-green-100 text-green-600 text-[8px] font-black uppercase px-2 py-0.5 rounded-full border border-green-200 shadow-sm whitespace-nowrap">
//                                                 <i className="fas fa-star mr-1"></i> {t("admin.settings.global_default", "Default")}
//                                             </span>
//                                             <button
//                                                 onClick={(e) => { e.stopPropagation(); handleActivateProfile(p.id, 1); }}
//                                                 className="text-[8px] font-black uppercase tracking-tighter text-red-400 hover:text-red-600 transition-colors"
//                                             >
//                                                 {t("admin.common.deactivate", "Deactivate")}
//                                             </button>
//                                         </div>
//                                     )}
//                                     {p.hostname && (
//                                         <span className="bg-blue-100 text-blue-600 text-[8px] font-black uppercase px-2 py-0.5 rounded-full border border-blue-200 shadow-sm whitespace-nowrap">
//                                             <i className="fas fa-check mr-1"></i> {t("admin.settings.hostname_active", "Active")}
//                                         </span>
//                                     )}
//                                     {p.is_active === 0 && (
//                                         <button
//                                             onClick={(e) => { e.stopPropagation(); handleActivateProfile(p.id, 0); }}
//                                             className="text-[9px] font-black uppercase tracking-tighter text-brand-primary hover:underline"
//                                         >
//                                             <i className="fas fa-plus-circle mr-1"></i>
//                                             {t("admin.settings.make_default", "Make Default")}
//                                         </button>
//                                     )}
//                                     <div className="flex items-center text-[10px] text-gray-500 font-bold bg-white/50 px-3 py-1.5 rounded-xl border border-gray-50">
//                                         <div className="flex items-center gap-1.5">
//                                             <i className="fas fa-cube text-brand-primary/60"></i>
//                                             <span>{p.product_counts || 0} {t("admin.settings.products", "Products")}</span>
//                                         </div>
//                                         <button
//                                             onClick={(e) => { e.stopPropagation(); handleRefreshProfileCount(p.id); }}
//                                             className="ml-2 text-gray-400 hover:text-brand-primary transition-colors p-1"
//                                             title="Refresh product count"
//                                             disabled={syncingCountProfileId === p.id}
//                                         >
//                                             <i className={`fas fa-sync-alt text-[8px] ${syncingCountProfileId === p.id ? 'fa-spin' : ''}`}></i>
//                                         </button>
//                                         {p.DATABASE_URL && (
//                                             <i className="fas fa-external-link-alt text-[7px] text-blue-400 ml-1" title="Expansion Database"></i>
//                                         )}
//                                     </div>
//                                     <div className="flex items-center text-[10px] text-gray-500 font-bold bg-white/50 px-3 py-1.5 rounded-xl border border-gray-50">
//                                         <i className="fas fa-list mr-2 text-brand-primary/60"></i>
//                                         {p.variable_counts} {t("admin.settings.vars", "Vars")}
//                                     </div>
//                                 </div>
//                             </div>
//                             <p className="text-[10px] text-gray-500 font-medium line-clamp-2 h-8 leading-relaxed mb-1">{p.description || "No description provided."}</p>
//                             {p.hostname && (
//                                 <div className="text-[9px] font-black text-brand-primary bg-brand-primary/5 px-2 py-0.5 rounded-full inline-block mb-3 border border-brand-primary/10">
//                                     <i className="fas fa-globe mr-1"></i> {p.hostname}
//                                 </div>
//                             )}
//                             <div className="flex justify-end gap-2 border-t border-gray-50 pt-3">
//                                 <button
//                                     title={p.hostname ? t("admin.settings.sync_profile", "Sync Domain Database") : t("admin.settings.sync_expansion", "Sync Expansion Database")}
//                                     onClick={(e) => { e.stopPropagation(); handleSyncProfile(p.id); }}
//                                     className={`transition-all ${syncingProfileId === p.id ? 'text-brand-primary' : 'text-gray-400 hover:text-brand-primary'}`}
//                                     disabled={syncingProfileId === p.id}
//                                 >
//                                     <i className={`fas ${syncingProfileId === p.id ? 'fa-spinner fa-spin' : 'fa-sync-alt'} text-[10px]`}></i>
//                                 </button>
//                                 {/* {isMaster && */}
//                                 {/* (<> */}
//                                 <button
//                                     title={t("admin.settings.pull_sync", "Pull Data from Remote to Local (Secure Save)")}
//                                     onClick={(e) => { e.stopPropagation(); handlePullSyncProfile(p.id); }}
//                                     className={`transition-all ${pullingProfileId === p.id ? 'text-green-500' : 'text-gray-400 hover:text-green-500'}`}
//                                     disabled={pullingProfileId === p.id}
//                                 >
//                                     <i className={`fas ${pullingProfileId === p.id ? 'fa-spinner fa-spin' : 'fa-download'} text-[10px]`}></i>
//                                 </button>
//                                 <button
//                                     title={t("admin.settings.sync_tunnel", "Update Cloudflare Tunnel URL")}
//                                     onClick={(e) => { e.stopPropagation(); handleSyncTunnel(p.id); }}
//                                     className={`transition-all ${syncingTunnelProfileId === p.id ? 'text-blue-500' : 'text-gray-400 hover:text-blue-500'}`}
//                                     disabled={syncingTunnelProfileId === p.id}
//                                 >
//                                     <i className={`fas ${syncingTunnelProfileId === p.id ? 'fa-spinner fa-spin' : 'fa-broadcast-tower'} text-[10px]`}></i>
//                                 </button>
//                                 {/* </>)} */}
//                                 {/* Add Extra Sets — per-domain button */}
//                                 <button
//                                     title={t("admin.settings.add_extra_sets", "Add Extra Config Sets to this domain")}
//                                     onClick={(e) => { e.stopPropagation(); handleAddExtraSets(p); }}
//                                     className="text-gray-400 hover:text-blue-500 transition-colors"
//                                 >
//                                     <i className="fas fa-layer-group text-[10px]"></i>
//                                 </button>
//                                 {/* {p.id !== p.hostname && !MASTER_PROFILE_ID && ( */}
//                                 <button title={t("admin.settings.edit_profile", "Edit Profile")} onClick={(e) => { e.stopPropagation(); openProfileModal(p); }} className="text-gray-400 hover:text-blue-500 transition-colors"><i className="fas fa-edit text-[10px]"></i></button>
//                                 {/* )} */}
//                                 {p.id !== MASTER_PROFILE_ID && !p.hostname && (
//                                     <button title={t("admin.settings.delete_profile", "Delete Profile")} onClick={(e) => { e.stopPropagation(); handleDeleteProfile(p.id); }} className="text-gray-400 hover:text-red-500 transition-colors"><i className="fas fa-trash text-[10px]"></i></button>
//                                 )}
//                                 {p.hostname && (
//                                     <span title={t("admin.settings.domain_profile_protected", "Domain profiles cannot be deleted — remove the hostname first")} className="text-gray-300 cursor-not-allowed"><i className="fas fa-lock text-[10px]"></i></span>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             {/* Variable Table */}
//             <div className={`transition-all ${!selectedProfileId ? 'opacity-50 pointer-events-none' : ''}`}>
//                 <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
//                     <h3 className="text-xs font-black uppercase tracking-[3px] text-gray-400">{profiles.find(p => p.id === selectedProfileId)?.name} {t("admin.settings.variables", "Variables")}</h3>
//                     <div className="flex gap-4 w-full md:w-auto">
//                         <div className="relative flex-1 md:w-64">
//                             <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
//                             <input
//                                 value={searchQuery}
//                                 onChange={e => setSearchQuery(e.target.value)}
//                                 placeholder={t("admin.common.search", "Search...")}
//                                 className="pl-10 pr-4 py-2 bg-gray-50 rounded-xl border-none w-full text-xs font-bold focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all"
//                             />
//                         </div>
//                         <div className="flex gap-2">
//                             <button
//                                 onClick={() => handleToggleAllVariables(true)}
//                                 disabled={syncingVarsProfileId === selectedProfileId}
//                                 className="bg-green-50 text-green-600 hover:bg-green-600 hover:text-white px-3 py-2 rounded-xl font-black text-[9px] uppercase tracking-widest transition-all whitespace-nowrap"
//                                 title={t("admin.settings.activate_all", "Activate All")}
//                             >
//                                 <i className={`fas ${syncingVarsProfileId === selectedProfileId ? 'fa-spinner fa-spin' : 'fa-check-double'}`}></i>
//                             </button>
//                             <button
//                                 onClick={() => handleToggleAllVariables(false)}
//                                 disabled={syncingVarsProfileId === selectedProfileId}
//                                 className="bg-amber-50 text-amber-600 hover:bg-amber-600 hover:text-white px-3 py-2 rounded-xl font-black text-[9px] uppercase tracking-widest transition-all whitespace-nowrap"
//                                 title={t("admin.settings.deactivate_all", "Deactivate All")}
//                             >
//                                 <i className="fas fa-ban"></i>
//                             </button>
//                         </div>
//                         <button
//                             onClick={() => { setEditingConfig(null); setConfigForm({ config_key: "", config_value: "", description: "", is_active: 1 }); setShowConfigModal(true); }}
//                             className="bg-brand-primary text-white px-6 py-2 rounded-xl font-black text-[10px] uppercase tracking-widest hover:scale-105 transition-all shadow-lg shadow-brand-primary/10 whitespace-nowrap"
//                         >
//                             <i className="fas fa-plus mr-1"></i> {t("admin.settings.add_key", "Add Variable")}
//                         </button>
//                     </div>
//                 </div>

//                 <div className="bg-white rounded-[30px] border border-gray-100 overflow-x-auto shadow-sm">
//                     <table className={`w-full ${isArabic ? 'text-right' : 'text-left'}`}>
//                         <thead className="bg-gray-50 text-[10px] font-black uppercase tracking-widest text-gray-400 border-b border-gray-100">
//                             <tr>
//                                 <th className="p-5">{t("admin.settings.key", "Key")}</th>
//                                 <th className="p-5">{t("admin.settings.value", "Value")}</th>
//                                 <th className="p-5">{t("admin.settings.status", "Status")}</th>
//                                 <th className="p-5 text-right">{t("admin.common.actions", "Actions")}</th>
//                             </tr>
//                         </thead>
//                         <tbody className="divide-y divide-gray-100">
//                             {loadingConfigs ? (
//                                 <tr><td colSpan="4" className="p-20 text-center"><i className="fas fa-spinner fa-spin text-brand-primary text-xl"></i></td></tr>
//                             ) : filteredConfigs.length === 0 ? (
//                                 <tr><td colSpan="4" className="p-20 text-center text-gray-400 font-bold italic">{t("admin.settings.no_configs", "No configurations for this set.")}</td></tr>
//                             ) : filteredConfigs.map(c => (
//                                 <tr key={c.id} className="hover:bg-gray-50/50 group transition-colors">
//                                     <td className="p-5">
//                                         <div className="font-mono text-xs font-black text-gray-900 bg-gray-100 px-3 py-1 rounded inline-block">{c.config_key}</div>
//                                     </td>
//                                     <td className="p-5">
//                                         <div className="text-xs font-medium text-gray-600 max-w-xs truncate" title={c.config_value}>{c.config_value}</div>
//                                         {c.description && <div className="text-[9px] text-gray-400 mt-1">{c.description}</div>}
//                                     </td>
//                                     <td className="p-5">
//                                         <div className="flex flex-col gap-1">
//                                             <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-tighter ${c.is_active ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'}`}>
//                                                 {c.is_active ? t("admin.settings.active", "Enabled") : t("admin.settings.inactive", "Disabled")}
//                                             </div>
//                                             {!c.is_active && profiles.find(p => p.id !== selectedProfileId && p.is_active === 1) && (
//                                                 <div className="text-[8px] font-black uppercase text-amber-500 italic flex items-center gap-1">
//                                                     <i className="fas fa-reply fa-rotate-180"></i>
//                                                     {t("admin.settings.fallback_active", "Fallback active")}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </td>
//                                     <td className="p-5 text-right">
//                                         <div className="flex justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
//                                             <button onClick={() => { setEditingConfig(c); setConfigForm({ ...c }); setShowConfigModal(true); }} className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-600 hover:text-white transition-all"><i className="fas fa-edit text-xs"></i></button>
//                                             {!isMaster && (
//                                                 <button onClick={() => handleDeleteConfig(c.id)} className="w-8 h-8 rounded-lg bg-red-50 text-red-600 hover:bg-red-600 hover:text-white transition-all"><i className="fas fa-trash text-xs"></i></button>
//                                             )}
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {/* Modals ... */}
//             {showProfileModal && (
//                 <div className="fixed inset-0 z-[110] overflow-y-auto bg-gray-900/60 backdrop-blur-sm">
//                     <div className="flex min-h-full items-start justify-center p-4">
//                         <div className="bg-white rounded-[40px] w-full max-w-2xl p-10 animate-scale-in my-8">
//                             <div className="flex justify-between items-center mb-6">
//                                 <h3 className="text-2xl font-black text-gray-900">{isEditing ? t("admin.settings.edit_set", "Edit Set") : t("admin.settings.new_set", "New Configuration Set")}</h3>
//                                 <button onClick={() => setShowProfileModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors"><i className="fas fa-times text-xl"></i></button>
//                             </div>

//                             <form onSubmit={handleSaveProfile} className="space-y-8">
//                                 {/* Base Information */}
//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gray-50 rounded-[30px] border border-gray-100">
//                                     <div className="md:col-span-2">
//                                         <h4 className="text-xs font-black uppercase tracking-widest text-brand-primary mb-4 flex items-center gap-2">
//                                             <i className="fas fa-info-circle"></i> {t("admin.settings.basic_info", "Basic Information")}
//                                         </h4>
//                                     </div>
//                                     <div>
//                                         <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.set_name", "Set Name")}</label>
//                                         <input value={profileForm.name} onChange={e => setProfileForm({ ...profileForm, name: e.target.value })} className="bg-white border border-gray-100 p-4 w-full rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold" required placeholder="e.g. Luxury Branch" />
//                                     </div>
//                                     {/* {isMaster && ( */}
//                                     <div>
//                                         <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.hostname", "Hostname (Domain)")}</label>
//                                         <input value={profileForm.hostname} onChange={e => setProfileForm({ ...profileForm, hostname: e.target.value })} className="bg-white border border-gray-100 p-4 w-full rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold" placeholder="e.g. branch.com" />
//                                         <p className="text-[9px] text-gray-400 ml-4 mt-1 italic">Required for full branding & isolation.</p>
//                                     </div>
//                                     {/* )} */}
//                                     <div className="md:col-span-2">
//                                         <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.description", "Description")}</label>
//                                         <textarea value={profileForm.description} onChange={e => setProfileForm({ ...profileForm, description: e.target.value })} className="bg-white border border-gray-100 p-4 w-full rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all font-bold h-20" placeholder="Briefly describe this profile..." />
//                                     </div>

//                                     <div className="md:col-span-2 flex items-center gap-3 p-4 bg-white rounded-2xl border border-gray-100">
//                                         <div
//                                             onClick={() => setProfileForm(prev => ({ ...prev, is_active: prev.is_active ? 0 : 1 }))}
//                                             className={`w-12 h-6 rounded-full relative transition-all cursor-pointer ${profileForm.is_active ? 'bg-green-500' : 'bg-gray-200'}`}
//                                         >
//                                             <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${profileForm.is_active ? 'right-1' : 'left-1'}`}></div>
//                                         </div>
//                                         <div className="flex-1">
//                                             <span className="text-[10px] font-black uppercase tracking-widest text-gray-900 block">{t("admin.settings.make_default", "Primary Default Store")}</span>
//                                             <p className="text-[9px] text-gray-400 font-bold italic">When no hostname matches, this set will be used.</p>
//                                         </div>
//                                         {profileForm.is_active ? <i className="fas fa-check-circle text-green-500"></i> : null}
//                                     </div>
//                                 </div>

//                                 {/* Branding Section (Master Only) */}
//                                 <div className={`space-y-6 p-6 bg-white rounded-[30px] border-2 border-brand-primary/10 relative transition-all duration-500 ${(!profileForm.hostname && editingProfile?.id !== 1) ? 'opacity-40 grayscale-[0.5]' : ''}`}>
//                                     {/* Lock Overlay */}
//                                     {(!profileForm.hostname && !isMaster && editingProfile?.id !== 1) && (
//                                         <div className="absolute inset-0 z-50 flex items-center justify-center p-8 text-center bg-white/20 backdrop-blur-[1px] rounded-[30px] pointer-events-none">
//                                             <div className="bg-white/95 shadow-2xl shadow-brand-primary/10 border border-brand-primary/10 p-8 rounded-[30px] max-w-[300px] transform -translate-y-4 animate-bounce-subtle pointer-events-auto">
//                                                 <div className="w-14 h-14 bg-brand-primary/10 text-brand-primary rounded-full flex items-center justify-center mx-auto mb-4">
//                                                     <i className="fas fa-lock text-xl"></i>
//                                                 </div>
//                                                 <h5 className="text-[11px] font-black uppercase tracking-widest text-gray-900 mb-2">{t("admin.settings.branding_restricted", "Branding Restricted")}</h5>
//                                                 <p className="text-[10px] text-gray-500 font-bold leading-relaxed">
//                                                     {t("admin.settings.branding_restricted_desc", "To prevent branding conflicts, please enter a hostname in the Basic Information section above first.")}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     )}

//                                     <div className="space-y-4 pt-4 border-t border-gray-100">
//                                         <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
//                                             <i className="fas fa-shield-alt"></i> {t("admin.settings.compliance_settings", "Compliance Settings")}
//                                         </span>
//                                         <div className="grid grid-cols-2 gap-4">
//                                             <div>
//                                                 <label className="block text-[9px] font-black uppercase tracking-widest text-gray-400 mb-1">
//                                                     {t("admin.settings.enable_global_consent_banner", "Enable Global Consent Banner")}
//                                                 </label>
//                                                 <div className="flex items-center gap-2">
//                                                     <input
//                                                         type="checkbox"
//                                                         id="enableGlobalConsent"
//                                                         checked={profileForm.branding?.compliance?.enableGlobalConsentBanner ?? true}
//                                                         onChange={e =>
//                                                             setProfileForm({
//                                                                 ...profileForm,
//                                                                 branding: {
//                                                                     ...profileForm.branding,
//                                                                     compliance: {
//                                                                         ...(profileForm.branding?.compliance || {}),
//                                                                         enableGlobalConsentBanner: e.target.checked
//                                                                     }
//                                                                 }
//                                                             })}
//                                                         className="mt-1 w-4 h-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer"
//                                                     />
//                                                     <label htmlFor="enableGlobalConsent" className="text-xs text-gray-500 leading-tight cursor-pointer">
//                                                         {t("admin.settings.enable_global_consent_desc", "Show the EU/UK/EG global consent banner for all users")}
//                                                     </label>
//                                                 </div>
//                                             </div>

//                                             <div>
//                                                 <label className="block text-[9px] font-black uppercase tracking-widest text-gray-400 mb-1">
//                                                     {t("admin.settings.enable_egypt_marketing_consent", "Enable Egypt Marketing Consent")}
//                                                 </label>
//                                                 <div className="flex items-center gap-2">
//                                                     <input
//                                                         type="checkbox"
//                                                         id="enableEgyptMarketing"
//                                                         checked={profileForm.branding?.compliance?.enableEgyptMarketingConsent ?? true}
//                                                         onChange={e =>
//                                                             setProfileForm({
//                                                                 ...profileForm,
//                                                                 branding: {
//                                                                     ...profileForm.branding,
//                                                                     compliance: {
//                                                                         ...(profileForm.branding?.compliance || {}),
//                                                                         enableEgyptMarketingConsent: e.target.checked
//                                                                     }
//                                                                 }
//                                                             })}
//                                                         className="mt-1 w-4 h-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer"
//                                                     />
//                                                     <label htmlFor="enableEgyptMarketing" className="text-xs text-gray-500 leading-tight cursor-pointer">
//                                                         {t("admin.settings.enable_egypt_marketing_desc", "Require explicit marketing opt‑in for Egyptian users")}
//                                                     </label>
//                                                 </div>
//                                             </div>

//                                             <div>
//                                                 <label className="block text-[9px] font-black uppercase tracking-widest text-gray-400 mb-1">
//                                                     {t("admin.settings.enable_explicit_data_processing", "Enable Explicit Data Processing Consent")}
//                                                 </label>
//                                                 <div className="flex items-center gap-2">
//                                                     <input
//                                                         type="checkbox"
//                                                         id="enableExplicitProcessing"
//                                                         checked={profileForm.branding?.compliance?.enableExplicitDataProcessing ?? true}
//                                                         onChange={e =>
//                                                             setProfileForm({
//                                                                 ...profileForm,
//                                                                 branding: {
//                                                                     ...profileForm.branding,
//                                                                     compliance: {
//                                                                         ...(profileForm.branding?.compliance || {}),
//                                                                         enableExplicitDataProcessing: e.target.checked
//                                                                     }
//                                                                 }
//                                                             })}
//                                                         className="mt-1 w-4 h-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer"
//                                                     />
//                                                     <label htmlFor="enableExplicitProcessing" className="text-xs text-gray-500 leading-tight cursor-pointer">
//                                                         {t("admin.settings.enable_explicit_processing_desc", "Require explicit data processing consent for all users")}
//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className={`flex justify-between items-center ${!profileForm.hostname ? 'pointer-events-none select-none' : ''}`}>
//                                         <h4 className="text-xs font-black uppercase tracking-widest text-brand-primary flex items-center gap-2">
//                                             <i className="fas fa-palette"></i> {t("admin.settings.branding_isolation", "App Branding & Identity")}
//                                         </h4>
//                                     </div>

//                                     {/* App Names */}
//                                     <div className="grid grid-cols-2 gap-4">
//                                         <div>
//                                             <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t('admin.settings.app_name_en_t')}{t('admin.settings.app_name_en_td')}</label>
//                                             <input value={profileForm.branding?.appName?.en || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, appName: { ...(profileForm.branding?.appName || {}), en: e.target.value } } })} className="bg-gray-50 border-none p-4 w-full rounded-2xl font-bold" placeholder="Furniture Shop" />
//                                         </div>
//                                         <div>
//                                             <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.app_name_ar_t")}{t('admin.settings.app_name_ar_td')}</label>
//                                             <input value={profileForm.branding?.appName?.ar || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, appName: { ...(profileForm.branding?.appName || {}), ar: e.target.value } } })} className="bg-gray-50 border-none p-4 w-full rounded-2xl font-bold text-right" dir="rtl" placeholder="فيرنتشر شوب" />
//                                         </div>
//                                     </div>

//                                     {/* SEO Fields */}
//                                     <div className="space-y-4 pt-2 border-t border-gray-50">
//                                         <div className="flex justify-between items-center">
//                                             <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">{t("admin.settings.seo_settings")}</span>
//                                         </div>
//                                         <div className="grid grid-cols-2 gap-4">
//                                             <div>
//                                                 <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.default_title_en_t")}{t('admin.settings.default_title_en_td')}</label>
//                                                 <input value={profileForm.branding?.seo?.defaultTitle?.en || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultTitle: { ...(profileForm.branding?.seo?.defaultTitle || {}), en: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold" placeholder={isArabic ? t('admin.settings.default_title') : undefined} />
//                                             </div>
//                                             <div>
//                                                 <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.default_title_ar_t")}{t('admin.settings.default_title_ar_td')}</label>
//                                                 <input value={profileForm.branding?.seo?.defaultTitle?.ar || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultTitle: { ...(profileForm.branding?.seo?.defaultTitle || {}), ar: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold text-right" placeholder={isArabic ? t('admin.settings.default_title') : undefined} dir="rtl" />
//                                             </div>
//                                             <div className="col-span-2">
//                                                 <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.default_desc_en_t")}{t('admin.settings.default_desc_en_td')}</label>
//                                                 <textarea value={profileForm.branding?.seo?.defaultDescription?.en || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultDescription: { ...(profileForm.branding?.seo?.defaultDescription || {}), en: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold h-16" placeholder={isArabic ? t('admin.settings.default_desc') : undefined} />
//                                             </div>
//                                             <div className="col-span-2 text-right" dir="rtl">
//                                                 <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 mr-4 mb-2 block">{t("admin.settings.default_desc_ar_t")}{t("admin.settings.default_desc_ar_td")}</label>
//                                                 <textarea value={profileForm.branding?.seo?.defaultDescription?.ar || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), defaultDescription: { ...(profileForm.branding?.seo?.defaultDescription || {}), ar: e.target.value } } } })} className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold h-16" placeholder={isArabic ? t('admin.settings.default_desc') : undefined} />
//                                             </div>

//                                             {/* Custom Head Meta Tags */}
//                                             <div className="col-span-2 mt-4 space-y-2">
//                                                 <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">Custom Head Meta Tags</label>
//                                                 <textarea
//                                                     value={profileForm.branding?.seo?.customHeadTags || ''}
//                                                     onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...(profileForm.branding?.seo || {}), customHeadTags: e.target.value } } })}
//                                                     className="bg-gray-50 border-none p-3 w-full rounded-xl text-xs font-bold h-24"
//                                                     placeholder="One full <meta .../> tag per line. These will be injected into the <head> of your store."
//                                                 />
//                                                 <p className="text-[9px] text-gray-400 italic ml-4">Example: <meta name="google-site-verification" content="abc123xyz" /></p>
//                                             </div>

//                                             {/* Selling Points Editor */}
//                                             <div className="col-span-2 mt-4 space-y-4">
//                                                 <span className="text-[10px] font-black uppercase tracking-widest text-brand-primary flex items-center gap-2">
//                                                     <i className="fas fa-bullhorn rotate-[-12deg]"></i> {t("admin.settings.selling_points", "SEO Selling Points & Trust Badges")}
//                                                 </span>
//                                                 <div className="grid grid-cols-2 gap-6">
//                                                     {/* English Selling Points */}
//                                                     <div className="space-y-3">
//                                                         <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-2 block">English Points</label>
//                                                         <div className="flex flex-wrap gap-2 p-3 bg-gray-50 rounded-2xl border border-gray-100 min-h-[60px]">
//                                                             {(profileForm.branding?.seo?.sellingPoints?.en || []).map((point, idx) => (
//                                                                 <span key={idx} className="bg-white px-3 py-1.5 rounded-xl text-[10px] font-bold text-gray-700 shadow-sm border border-gray-100 flex items-center gap-2 group/point">
//                                                                     {point}
//                                                                     <button type="button" onClick={() => {
//                                                                         const updated = (profileForm.branding.seo.sellingPoints.en || []).filter((_, i) => i !== idx);
//                                                                         setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...profileForm.branding.seo.sellingPoints, en: updated } } } });
//                                                                     }} className="text-gray-300 hover:text-red-500 transition-colors">
//                                                                         <i className="fas fa-times text-[8px]"></i>
//                                                                     </button>
//                                                                 </span>
//                                                             ))}
//                                                             <input
//                                                                 className="bg-transparent border-none p-0 text-[10px] font-bold outline-none flex-1 min-w-[80px]"
//                                                                 placeholder="+ Add Point..."
//                                                                 onKeyDown={e => {
//                                                                     if (e.key === 'Enter') {
//                                                                         e.preventDefault();
//                                                                         const val = e.target.value.trim();
//                                                                         if (val) {
//                                                                             const updated = [...(profileForm.branding?.seo?.sellingPoints?.en || []), val];
//                                                                             setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...(profileForm.branding.seo.sellingPoints || {}), en: updated } } } });
//                                                                             e.target.value = '';
//                                                                         }
//                                                                     }
//                                                                 }}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     {/* Arabic Selling Points */}
//                                                     <div className="space-y-3" dir="rtl">
//                                                         <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 mr-2 block">النقاط البيعية (عربي)</label>
//                                                         <div className="flex flex-wrap gap-2 p-3 bg-gray-50 rounded-2xl border border-gray-100 min-h-[60px]">
//                                                             {(profileForm.branding?.seo?.sellingPoints?.ar || []).map((point, idx) => (
//                                                                 <span key={idx} className="bg-white px-3 py-1.5 rounded-xl text-[10px] font-bold text-gray-700 shadow-sm border border-gray-100 flex items-center gap-2 group/point">
//                                                                     {point}
//                                                                     <button type="button" onClick={() => {
//                                                                         const updated = (profileForm.branding.seo.sellingPoints.ar || []).filter((_, i) => i !== idx);
//                                                                         setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...profileForm.branding.seo.sellingPoints, ar: updated } } } });
//                                                                     }} className="text-gray-300 hover:text-red-500 transition-colors">
//                                                                         <i className="fas fa-times text-[8px]"></i>
//                                                                     </button>
//                                                                 </span>
//                                                             ))}
//                                                             <input
//                                                                 className="bg-transparent border-none p-0 text-[10px] font-bold outline-none flex-1 min-w-[80px]"
//                                                                 placeholder="+ إضافة نقطة..."
//                                                                 onKeyDown={e => {
//                                                                     if (e.key === 'Enter') {
//                                                                         e.preventDefault();
//                                                                         const val = e.target.value.trim();
//                                                                         if (val) {
//                                                                             const updated = [...(profileForm.branding?.seo?.sellingPoints?.ar || []), val];
//                                                                             setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, sellingPoints: { ...(profileForm.branding.seo.sellingPoints || {}), ar: updated } } } });
//                                                                             e.target.value = '';
//                                                                         }
//                                                                     }
//                                                                 }}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         {/* Per-Page SEO Titles */}
//                                         <div className="mt-4 p-4 bg-gray-50 rounded-2xl border border-gray-100">
//                                             <div className="flex justify-between items-center mb-4">
//                                                 <span className="text-[9px] font-black uppercase tracking-widest text-gray-400">Page-Specific SEO Titles</span>
//                                                 <button
//                                                     type="button"
//                                                     onClick={() => {
//                                                         const slug = window.prompt("Enter page slug (e.g. shop, about, contact):");
//                                                         if (slug) {
//                                                             setProfileForm({
//                                                                 ...profileForm,
//                                                                 branding: {
//                                                                     ...profileForm.branding,
//                                                                     seo: {
//                                                                         ...profileForm.branding.seo,
//                                                                         pages: {
//                                                                             ...profileForm.branding.seo.pages,
//                                                                             [slug.toLowerCase()]: { title: { en: '', ar: '' }, description: { en: '', ar: '' } }
//                                                                         }
//                                                                     }
//                                                                 }
//                                                             });
//                                                         }
//                                                     }}
//                                                     className="text-[9px] font-black uppercase text-brand-primary hover:underline"
//                                                 >
//                                                     + Add Page
//                                                 </button>
//                                             </div>
//                                             <div className="space-y-4 max-h-60 overflow-y-auto pr-2">
//                                                 {Object.entries(profileForm.branding?.seo?.pages || {}).map(([slug, data]) => (
//                                                     <div key={slug} className="p-3 bg-white rounded-xl border border-gray-200 shadow-sm relative group">
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => {
//                                                                 const newPages = { ...profileForm.branding.seo.pages };
//                                                                 delete newPages[slug];
//                                                                 setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, pages: newPages } } });
//                                                             }}
//                                                             className="absolute top-2 right-2 text-gray-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
//                                                         >
//                                                             <i className="fas fa-trash-alt text-[10px]"></i>
//                                                         </button>
//                                                         <div className="text-[10px] font-black text-brand-primary uppercase mb-2">/{slug}</div>
//                                                         <div className="grid grid-cols-2 gap-2">
//                                                             <input
//                                                                 placeholder="Title (EN)"
//                                                                 value={data.title?.en || ''}
//                                                                 onChange={e => {
//                                                                     const updated = { ...profileForm.branding.seo.pages };
//                                                                     updated[slug].title.en = e.target.value;
//                                                                     setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, pages: updated } } });
//                                                                 }}
//                                                                 className="bg-gray-50 border-none p-2 rounded-lg text-[10px] font-bold"
//                                                             />
//                                                             <input
//                                                                 placeholder="العنوان (AR)"
//                                                                 value={data.title?.ar || ''}
//                                                                 onChange={e => {
//                                                                     const updated = { ...profileForm.branding.seo.pages };
//                                                                     updated[slug].title.ar = e.target.value;
//                                                                     setProfileForm({ ...profileForm, branding: { ...profileForm.branding, seo: { ...profileForm.branding.seo, pages: updated } } });
//                                                                 }}
//                                                                 dir="rtl"
//                                                                 className="bg-gray-50 border-none p-2 rounded-lg text-[10px] font-bold"
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                                 {Object.keys(profileForm.branding?.seo?.pages || {}).length === 0 && (
//                                                     <div className="text-[9px] text-gray-400 italic text-center py-4">No page-specific titles defined. Falling back to default.</div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Colors & Visuals */}
//                                     <div className="space-y-4 pt-4 border-t border-gray-100">
//                                         <span className="text-[10px] font-black uppercase tracking-widest text-gray-400 flex items-center gap-2">
//                                             <i className="fas fa-palette"></i> {t('admin.settings.color_palette', 'Color Palette & Backgrounds')}
//                                         </span>
//                                         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                                             <div>
//                                                 <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t('admin.settings.logo_url', 'Brand Logo')}</label>
//                                                 <div className="flex items-center gap-3">
//                                                     <div className="relative group">
//                                                         <div className="w-16 h-16 rounded-2xl border-2 border-dashed border-gray-200 flex items-center justify-center overflow-hidden bg-gray-50">
//                                                             {logoPreview ? <img src={logoPreview} alt="Logo Preview" className="w-full h-full object-contain" /> : <i className="fas fa-image text-gray-300"></i>}
//                                                         </div>
//                                                         <input type="file" accept="image/*" id="logo_file_input" style={{ display: 'none' }} onChange={e => { const f = e.target.files?.[0]; if (f) { setLogoPreview(URL.createObjectURL(f)); uploadBrandingFile(f, 'logo'); } }} />
//                                                         <label htmlFor="logo_file_input" className="absolute inset-0 flex items-center justify-center bg-black/50 text-white opacity-0 group-hover:opacity-100 cursor-pointer transition-opacity rounded-2xl text-[8px] font-black uppercase">Change</label>
//                                                     </div>
//                                                     <div className="flex-1 space-y-2">
//                                                         <div className="flex gap-2">
//                                                             <input value={profileForm.branding?.logo?.path || logoPreview} onChange={e => { setLogoPreview(e.target.value); setProfileForm(prev => ({ ...prev, branding: { ...prev.branding, logo: { ...(prev.branding?.logo || {}), path: e.target.value } } })); }} className="bg-gray-50 border-none p-3 flex-1 rounded-xl text-[9px] font-bold" placeholder="Logo URL..." />
//                                                         </div>
//                                                         <div className="flex gap-2">
//                                                             <input value={profileForm.branding?.favicon?.path || ''} onChange={e => setProfileForm(prev => ({ ...prev, branding: { ...prev.branding, favicon: { path: e.target.value } } }))} className="bg-gray-50 border-none p-3 flex-1 rounded-xl text-[9px] font-bold" placeholder="Favicon URL (16x16)..." />
//                                                             <input type="file" accept="image/*" id="favicon_file_input" style={{ display: 'none' }} onChange={e => { const f = e.target.files?.[0]; if (f) uploadBrandingFile(f, 'favicon'); }} />
//                                                             <label htmlFor="favicon_file_input" className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-2 rounded-xl text-[9px] font-black uppercase cursor-pointer flex items-center"><i className="fas fa-upload"></i></label>
//                                                         </div>
//                                                         <div className="flex gap-2">
//                                                             <input value={profileForm.branding?.appleTouchIcon?.path || ''} onChange={e => setProfileForm(prev => ({ ...prev, branding: { ...prev.branding, appleTouchIcon: { path: e.target.value } } }))} className="bg-gray-50 border-none p-3 flex-1 rounded-xl text-[9px] font-bold" placeholder="Apple Touch URL (180x180)..." />
//                                                             <input type="file" accept="image/*" id="apple_file_input" style={{ display: 'none' }} onChange={e => { const f = e.target.files?.[0]; if (f) uploadBrandingFile(f, 'appleTouchIcon'); }} />
//                                                             <label htmlFor="apple_file_input" className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-2 rounded-xl text-[9px] font-black uppercase cursor-pointer flex items-center"><i className="fas fa-upload"></i></label>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="space-y-4">
//                                                 <div className="col-span-2">
//                                                     <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4 mb-2 block">{t("admin.settings.primary_palette", "Primary & Palette")}</label>
//                                                     <div className="grid grid-cols-3 gap-3">
//                                                         <div>
//                                                             <input type="color" value={profileForm.branding?.colors?.primary || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primary: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
//                                                             <input value={profileForm.branding?.colors?.primary || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primary: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
//                                                             <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Primary</span>
//                                                         </div>
//                                                         <div>
//                                                             <input type="color" value={profileForm.branding?.colors?.primaryHover || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primaryHover: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
//                                                             <input value={profileForm.branding?.colors?.primaryHover || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), primaryHover: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
//                                                             <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Hover</span>
//                                                         </div>
//                                                         <div>
//                                                             <input type="color" value={profileForm.branding?.colors?.secondary || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), secondary: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
//                                                             <input value={profileForm.branding?.colors?.secondary || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), secondary: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
//                                                             <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Secondary</span>
//                                                         </div>
//                                                         <div>
//                                                             <input type="color" value={profileForm.branding?.colors?.accent || '#000000'} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), accent: e.target.value } } })} className="w-full h-8 rounded-t-xl cursor-pointer border-none" />
//                                                             <input value={profileForm.branding?.colors?.accent || ''} onChange={e => setProfileForm({ ...profileForm, branding: { ...profileForm.branding, colors: { ...(profileForm.branding?.colors || {}), accent: e.target.value } } })} className="w-full bg-gray-50 border-none p-1 text-[8px] font-mono font-bold text-center rounded-b-xl" placeholder="#HEX" />
//                                                             <span className="text-[7px] font-black text-gray-400 uppercase text-center block mt-1">Accent</span>
//                                                         </div>
//                                  